/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		21: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"2":"route-services","3":"route-home","4":"route-availability","5":"route-support","6":"route-startups","7":"route-internet","8":"route-faq","9":"route-content","10":"route-contact","19":"route-terms-of-use","20":"route-privacy"}[chunkId]||chunkId) + ".chunk." + {"0":"70c48","1":"4f520","2":"bca6a","3":"3fc1b","4":"86ba0","5":"cc95f","6":"6318d","7":"db1c9","8":"c8a20","9":"d794c","10":"5003d","11":"d44c6","12":"f2776","13":"99bdb","14":"cd69c","15":"7506c","16":"d8993","17":"1cd6b","18":"babce","19":"71b72","20":"31557"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+bWy":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("yEjJ");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "/wuY":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("NB7d")('keys');
var uid = __webpack_require__("X6va");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "0WCH":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "0uzy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__("rNh1");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': 'icon_card_frame', x: '0.5', y: '0.5', width: '125.667', height: '237', rx: '4.5', stroke: '#efefef' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'text',
    { x: '45', y: '151.5', fill: '#4A4A4A', style: 'font-size: 12px; font-weight: 500' },
    'Mbit/s'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': 'icon_card_arrows', x: '43.2778', y: '185.781', width: '7.38889', height: '11.0464', fill: '#EEEEEE' });

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { 'class': 'icon_card_arrows', d: 'M46.9721 205.865L55.6564 196.074H38.2878L46.9721 205.865Z', fill: '#EEEEEE' });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': 'icon_card_arrows', width: '7.38889', height: '11.0464', transform: 'matrix(-1 0.000438742 -0.000484746 -1 80.2319 203.859)', fill: '#EEEEEE' });

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { 'class': 'icon_card_arrows', d: 'M76.5279 183.776L67.8483 193.571L85.2169 193.564L76.5279 183.776Z', fill: '#EEEEEE' });

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'text',
    { x: '35', y: '68.5', fill: 'white', style: 'font-size: 18px; font-weight: 400; letter-spacing: 0.35em;' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'iconBar' })
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'mask',
    { id: 'mask0', 'mask-type': 'alpha', maskUnits: 'userSpaceOnUse', x: '158', y: '83', width: '147', height: '62' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M193.5 143.5L158.333 129.906C158.333 129.906 179.445 83.35 231.167 83.3501C288.167 83.3503 304 130.886 304 130.886L267.583 144.607C267.583 144.607 259 122 232 119.5C205 117 193.5 143.5 193.5 143.5Z', fill: '#EEEEEE' })
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M193.5 143.5L158.333 129.906C158.333 129.906 179.445 83.35 231.167 83.3501C288.167 83.3503 304 130.886 304 130.886L267.583 144.607C267.583 144.607 259 122 232 119.5C205 117 193.5 143.5 193.5 143.5Z', fill: '#e2e2e2' });

var IconBar = function (_Component) {
    _inherits(IconBar, _Component);

    function IconBar() {
        _classCallCheck(this, IconBar);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    IconBar.prototype.render = function render(props) {
        var _h;

        var classStyle = 'animatedIconBar_' + this.props.percent;
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'svg',
            (_h = { width: '304', height: '238', viewBox: '0 0 304 238', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, _h['width'] = '80%', _h.style = 'padding-top: 14%;margin-bottom: 12%;', _h),
            _ref,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { 'class': 'icon_card_bar_background', x: '17.9443', y: '49.2065', width: '88.6667', height: '24.1013', rx: '3', fill: props.color }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'text',
                { x: '28', y: '118', fill: props.color, style: 'font-size:43px; font-weight:400' },
                props.number
            ),
            _ref2,
            _ref3,
            _ref4,
            _ref5,
            _ref6,
            _ref7,
            _ref8,
            _ref9,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'g',
                { mask: 'url(#mask0)' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { 'class': 'icon_bar_animated', className: classStyle, d: 'M189.963 167.326L152.692 176.659C152.692 176.659 143.297 126.411 185.674 96.7577C232.376 64.0782 272.602 93.9476 272.602 93.9476L250.632 126.069C250.632 126.069 233.513 111.73 209.622 125.458C186.916 138.504 189.963 167.326 189.963 167.326Z', fill: props.color })
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { 'class': 'icon_bar_arrow', className: classStyle, d: 'M228.181 153.69C222.807 161.884 225.365 163.632 226.487 163.915C227.93 164.28 230.168 165.947 235.278 157.319C254.001 125.703 279.85 83.3503 279.85 83.3503C279.85 83.3503 235.467 142.582 228.181 153.69Z', fill: '#4C4C4C' })
        );
    };

    return IconBar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "0zpp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),

/***/ "1+RE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("868B");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),

/***/ "11Ut":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("Gfzd").f;
var has = __webpack_require__("yS17");
var TAG = __webpack_require__("Ug9I")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),

/***/ "1RxS":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("FTXF");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),

/***/ "1kq3":
/***/ (function(module, exports) {

module.exports = true;

/***/ }),

/***/ "1qpN":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("q3B8");

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),

/***/ "2Axb":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("EiMJ");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

/***/ }),

/***/ "2ibm":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("p/0c"),
    isSymbol = __webpack_require__("bgO7");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

module.exports = isKey;

/***/ }),

/***/ "3v7p":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("htFH");
var $Object = __webpack_require__("zKeE").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

/***/ }),

/***/ "3w4y":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("wppe"),
    arrayMap = __webpack_require__("BblM"),
    isArray = __webpack_require__("p/0c"),
    isSymbol = __webpack_require__("bgO7");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),

/***/ "3zRh":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("g31e");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "5U5Y":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("yeiR");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),

/***/ "6MLN":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("wLcK")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "6uYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export $mobx */
/* unused harmony export FlowCancellationError */
/* unused harmony export IDerivationState */
/* unused harmony export ObservableMap */
/* unused harmony export ObservableSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reaction; });
/* unused harmony export _allowStateChanges */
/* unused harmony export _allowStateChangesInsideComputed */
/* unused harmony export _endAction */
/* unused harmony export _getAdministration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGlobalState; });
/* unused harmony export _interceptReads */
/* unused harmony export _isComputingDerivation */
/* unused harmony export _resetGlobalState */
/* unused harmony export _startAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return action; });
/* unused harmony export autorun */
/* unused harmony export comparer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return computed; });
/* unused harmony export configure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createAtom; });
/* unused harmony export decorate */
/* unused harmony export entries */
/* unused harmony export extendObservable */
/* unused harmony export flow */
/* unused harmony export get */
/* unused harmony export getAtom */
/* unused harmony export getDebugName */
/* unused harmony export getDependencyTree */
/* unused harmony export getObserverTree */
/* unused harmony export has */
/* unused harmony export intercept */
/* unused harmony export isAction */
/* unused harmony export isArrayLike */
/* unused harmony export isBoxedObservable */
/* unused harmony export isComputed */
/* unused harmony export isComputedProp */
/* unused harmony export isFlowCancellationError */
/* unused harmony export isObservable */
/* unused harmony export isObservableArray */
/* unused harmony export isObservableMap */
/* unused harmony export isObservableObject */
/* unused harmony export isObservableProp */
/* unused harmony export isObservableSet */
/* unused harmony export keys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return observable; });
/* unused harmony export observe */
/* unused harmony export onBecomeObserved */
/* unused harmony export onBecomeUnobserved */
/* unused harmony export onReactionError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reaction; });
/* unused harmony export remove */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return runInAction; });
/* unused harmony export set */
/* unused harmony export spy */
/* unused harmony export toJS */
/* unused harmony export trace */
/* unused harmony export transaction */
/* unused harmony export untracked */
/* unused harmony export values */
/* unused harmony export when */
/** MobX - (c) Michel Weststrate 2015 - 2019 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return _extendStatics(d, b);
};

function __extends(d, b) {
    _extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return _assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator],
        i = 0;
    if (m) return m.call(o);
    return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o),
        r,
        ar = [],
        e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    } catch (error) {
        e = { error: error };
    } finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
            if (e) throw e.error;
        }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++) {
        ar = ar.concat(__read(arguments[i]));
    }return ar;
}

var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check) throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true) return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1) return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1) res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
}
function assertPropertyConfigurable(object, prop) {
    if (false) fail("Cannot make property '" + prop.toString() + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
/**
 * Returns the following: own keys, prototype keys & own symbol keys, if they are enumerable.
 */
function getPlainObjectKeys(object) {
    var enumerables = new Set();
    for (var key in object) {
        enumerables.add(key);
    } // *all* enumerables
    Object.getOwnPropertySymbols(object).forEach(function (k) {
        if (Object.getOwnPropertyDescriptor(object, k).enumerable) enumerables.add(k);
    }); // *own* symbols
    // Note: this implementation is missing enumerable, inherited, symbolic property names! That would however pretty expensive to add,
    // as there is no efficient iterator that returns *all* properties
    return Array.from(enumerables);
}
function stringifyKey(key) {
    if (key && key.toString) return key.toString();else return new String(key).toString();
}
function getMapLikeKeys(map) {
    if (isPlainObject(map)) return Object.keys(map);
    if (Array.isArray(map)) return map.map(function (_a) {
        var _b = __read(_a, 1),
            key = _b[0];
        return key;
    });
    if (isES6Map(map) || isObservableMap(map)) return Array.from(map.keys());
    return fail("Cannot get keys from '" + map + "'");
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

var $mobx = Symbol("mobx administration");
var Atom = /** @class */function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name) {
        if (name === void 0) {
            name = "Atom@" + getNextId();
        }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    Atom.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom.prototype.reportObserved = function () {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function () {
        return this.name;
    };
    return Atom;
}();
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) {
        onBecomeObservedHandler = noop;
    }
    if (onBecomeUnobservedHandler === void 0) {
        onBecomeUnobservedHandler = noop;
    }
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) {
        onBecomeObserved(atom, onBecomeObservedHandler);
    }
    if (onBecomeUnobservedHandler !== noop) {
        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    }
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};

var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return cache[prop] || (cache[prop] = {
        configurable: true,
        enumerable: enumerable,
        get: function get() {
            initializeInstance(this);
            return this[prop];
        },
        set: function set(value) {
            initializeInstance(this);
            this[prop] = value;
        }
    });
}
function initializeInstance(target) {
    var e_1, _a;
    if (target[mobxDidRunLazyInitializersSymbol] === true) return;
    var decorators = target[mobxPendingDecorators];
    if (decorators) {
        addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
        // Build property key array from both strings and symbols
        var keys = __spread(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false) fail("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
                var inheritedDecorators = target[mobxPendingDecorators];
                addHiddenProp(target, mobxPendingDecorators, _assign({}, inheritedDecorators));
            }
            target[mobxPendingDecorators][prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        } else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && (typeof args[1] === "string" || typeof args[1] === "symbol") || args.length === 4 && args[3] === true;
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, { name: name });
    if (isPlainObject(v)) return observable.object(v, undefined, { name: name });
    if (isES6Map(v)) return observable.map(v, { name: name });
    if (isES6Set(v)) return observable.set(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v)) return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v)) return observable.map(v, { name: name, deep: false });
    if (isES6Set(v)) return observable.set(v, { name: name, deep: false });
    return fail("production" !== "production" && "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false) throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}

function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + stringifyKey(propertyName) + "\"), use @computed instead.");
        }
        var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : undefined;
        asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
    });
    var res =
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && process.env && "production" !== "production" ? function observableDecorator() {
        // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
        // and simply return the created prop decorator
        if (arguments.length < 2) return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
        return decorator.apply(null, arguments);
    } : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key)) fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined) return defaultCreateObservableOptions;
    if (typeof thing === "string") return { name: thing, deep: true, proxy: true };
    if (false) {
        if (typeof thing !== "object") return fail("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
function getEnhancerFromOptions(options) {
    return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : isES6Set(v) ? observable.set(v, arg2) : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v) return res;
    // otherwise, just box it
    fail("production" !== "production" && "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function box(value, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        if (o.proxy === false) {
            return extendObservable({}, props, decorators, o);
        } else {
            var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
            var base = extendObservable({}, undefined, undefined, o);
            var proxy = createDynamicObservableObject(base);
            extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
            return proxy;
        }
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) {
    return observable[name] = observableFactories[name];
});
function incorrectlyUsedAsDecorator(methodName) {
    fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get = descriptor.get,
        set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    asObservableObject(instance).addComputedProp(instance, propertyName, _assign({ get: get,
        set: set, context: instance }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}();
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE:
            {
                var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
                var obs = derivation.observing,
                    l = obs.length;
                for (var i = 0; i < l; i++) {
                    var obj = obs[i];
                    if (isComputedValue(obj)) {
                        if (globalState.disableErrorBoundaries) {
                            obj.get();
                        } else {
                            try {
                                obj.get();
                            } catch (e) {
                                // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                                untrackedEnd(prevUntracked);
                                return true;
                            }
                        }
                        // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                        // and `derivation` is an observer of `obj`
                        // invariantShouldCompute(derivation)
                        if (derivation.dependenciesState === IDerivationState.STALE) {
                            untrackedEnd(prevUntracked);
                            return true;
                        }
                    }
                }
                changeDependenciesStateTo0(derivation);
                untrackedEnd(prevUntracked);
                return false;
            }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.size > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers) fail("production" !== "production" && "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict")) fail("production" !== "production" && (globalState.enforceActions ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") + atom.name);
}
function checkIfStateReadsAreAllowed(observable) {
    if (false) {
        console.warn("[mobx] Observable " + observable.name + " being read outside a reactive context");
    }
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    } else {
        try {
            result = f.call(context);
        } catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (true) return;
    if (derivation.observing.length !== 0) return;
    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
    }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = derivation.observing = derivation.newObserving;
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0,
        l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--) {
        removeObserver(obs[i], derivation);
    }derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally {
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE) return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--) {
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
    }
}

// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
function createAction(actionName, fn, ref) {
    if (false) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName) fail("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function res() {
        return executeAction(actionName, fn, ref || this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error = err;
        throw err;
    } finally {
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy && "production" !== "production") {
        startTime = Date.now();
        var l = args && args.length || 0;
        var flattendArgs = new Array(l);
        if (l > 0) for (var i = 0; i < l; i++) {
            flattendArgs[i] = args[i];
        }spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) {
        fail("invalid action stack. did you forget to finish an action?");
    }
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) {
        globalState.suppressReactionErrors = true;
    }
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy && "production" !== "production") {
        spyReportEnd({ time: Date.now() - runInfo.startTime });
    }
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    } finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    } finally {
        globalState.computationDepth = prev;
    }
    return res;
}

var ObservableValue = /** @class */function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) {
            name = "ObservableValue@" + getNextId();
        }
        if (notifySpy === void 0) {
            notifySpy = true;
        }
        if (equals === void 0) {
            equals = comparer.default;
        }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled() && "production" !== "production") {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy && "production" !== "production") {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately) listener({
            object: this,
            type: "update",
            newValue: this.value,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ObservableValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        if (false) throw "[mobx] missing option for computed: get";
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set) this.setter = createAction(this.name + "-setter", options.set);
        this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing) fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) if (this.trackAndCompute()) propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res)) throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            } finally {
                this.isRunningSetter = false;
            }
        } else invariant(false, "production" !== "production" && "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled() && "production" !== "production") {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended =
        /* see #1208 */this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        } else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            } else {
                try {
                    res = this.derivation.call(this.scope);
                } catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true) return;
        if (this.requiresReaction === true) {
            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "spyListeners", "enforceActions", "computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "allowStateReads", "disableErrorBoundaries", "runId", "UNCHANGED"];
var MobXGlobals = /** @class */function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */
        this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */
        this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */
        this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */
        this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}();
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    } else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED) global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    } else {
        global.__mobxInstanceCount = 1;
        return global.__mobxGlobals = new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0) getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals) {
        if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    }globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.size > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers.add(node);
    if (observable.lowestObserverState > node.dependenciesState) observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers.delete(node);
    if (observable.observers.size === 0) {
        // deleting last observer
        queueForUnobservation(observable);
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    } else if (observable.observers.size === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE) return;
    observable.lowestObserverState = IDerivationState.STALE;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    });
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE) return;
    observable.lowestObserverState = IDerivationState.STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE) d.dependenciesState = IDerivationState.STALE;else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    });
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE) return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    });
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies) tree.dependencies.forEach(function (child) {
        return printDepTree(child, lines, depth + 1);
    });
}

var Reaction = /** @class */function () {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) {
            name = "Reaction@" + getNextId();
        }
        if (requiresObservable === void 0) {
            requiresObservable = false;
        }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled() && "production" !== "production") {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                } catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        if (this.isDisposed) {
            return;
            // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        }
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify && "production" !== "production") {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result)) this.reportExceptionInDerivation(result.cause);
        if (notify && "production" !== "production") {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        } else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) {
            return f(error, _this);
        });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) {
            enterBreakPoint = false;
        }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++) {
            remainingReactions[i].runReaction();
        }
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function () {
            return baseScheduler(f);
        });
    };
}

function isSpyEnabled() {
    return "production" !== "production" && !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (true) return; // dead code elimination can do the rest
    if (!globalState.spyListeners.length) return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](event);
    }
}
function spyReportStart(event) {
    if (true) return;
    var change = _assign(_assign({}, event), { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (true) return;
    if (change) spyReport(_assign(_assign({}, change), { spyReportEnd: true }));else spyReport(END_EVENT);
}
function spy(listener) {
    if (true) {
        console.warn("[mobx.spy] Is a no-op in production builds");
        return function () {};
    } else {
        globalState.spyListeners.push(listener);
        return once(function () {
            globalState.spyListeners = globalState.spyListeners.filter(function (l) {
                return l !== listener;
            });
        });
    }
}

function dontReassignFields() {
    fail("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function initializer() {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function get() {
                return undefined;
            },
            set: function set(value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function get() {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function set(v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function get() {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function") return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function") return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string") return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
    } else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName) fail("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) {
        opts = EMPTY_OBJECT;
    }
    if (false) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = opts && opts.name || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
    } else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function (f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) {
        opts = EMPTY_OBJECT;
    }
    if (false) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        } else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed) return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, r);
        if (!firstTime && changed === true) effectAction(value, r);
        if (firstTime) firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var listenersKey = hook + "Listeners";
    if (atom[listenersKey]) {
        atom[listenersKey].add(cb);
    } else {
        atom[listenersKey] = new Set([cb]);
    }
    var orig = atom[hook];
    if (typeof orig !== "function") return fail("production" !== "production" && "Not an atom that can be (un)observed");
    return function () {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) {
                delete atom[listenersKey];
            }
        }
    };
}

function configure(options) {
    var enforceActions = options.enforceActions,
        computedRequiresReaction = options.computedRequiresReaction,
        computedConfigurable = options.computedConfigurable,
        disableErrorBoundaries = options.disableErrorBoundaries,
        reactionScheduler = options.reactionScheduler,
        reactionRequiresObservable = options.reactionRequiresObservable,
        observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict") deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (reactionRequiresObservable !== undefined) {
        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    }
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) {
        globalState.computedConfigurable = !!computedConfigurable;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

function decorate(thing, decorators) {
    "production" !== "production" && invariant(isPlainObject(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function _loop_1(prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
        "production" !== "production" && invariant(propertyDecorators.every(function (decorator) {
            return typeof decorator === "function";
        }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) {
            return decorator(target, prop, accDescriptor);
        }, descriptor);
        if (newDescriptor) Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendObservable(target, properties, decorators, options) {
    if (false) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
    initializeInstance(target); // Fixes #1740
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    if (properties) extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
    return target;
}
function getDefaultDecoratorFromObjectOptions(options) {
    return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
}
function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
    var e_1, _a, e_2, _b;
    if (false) {
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators) {
            var keys = getPlainObjectKeys(decorators);
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    if (!(key in properties)) fail("Trying to declare a decorator for unspecified property '" + stringifyKey(key) + "'");
                }
            } catch (e_1_1) {
                e_1 = { error: e_1_1 };
            } finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                } finally {
                    if (e_1) throw e_1.error;
                }
            }
        }
    }
    startBatch();
    try {
        var keys = getPlainObjectKeys(properties);
        try {
            for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                var key = keys_2_1.value;
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
                if (false) {
                    if (!isPlainObject(properties)) fail("'extendObservabe' only accepts plain objects as second argument");
                    if (Object.getOwnPropertyDescriptor(target, key)) fail("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + stringifyKey(key) + "' already exists on '" + target + "'");
                    if (isComputed(descriptor.value)) fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
                }
                var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;
                if (false) fail("Not a valid decorator for '" + stringifyKey(key) + "', got: " + decorator);
                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
                ) Object.defineProperty(target, key, resultDescriptor);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
    } finally {
        endBatch();
    }
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0) result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
var FlowCancellationError = /** @class */function (_super) {
    __extends(FlowCancellationError, _super);
    function FlowCancellationError() {
        return _super.call(this, "FLOW_CANCELLED") || this;
    }
    return FlowCancellationError;
}(Error);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1) fail(!!"production" && "Flow expects 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function") promise.cancel();
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    } else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string") return fail("production" !== "production" && "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    } else {
        return fail("production" !== "production" && "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined) return fail("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function") return interceptProperty(thing, propOrHandler, handler);else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function _isComputed(value, property) {
    if (value === null || value === undefined) return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false) return false;
        if (!value[$mobx].values.has(property)) return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1) return fail("production" !== "production" && "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string") return fail("production" !== "production" && "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined) return false;
    if (property !== undefined) {
        if (false) return fail("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            return value[$mobx].values.has(property);
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    if (arguments.length !== 1) fail("production" !== "production" && "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string") return fail("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj[$mobx].getKeys();
    }
    if (isObservableMap(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) {
            return index;
        });
    }
    return fail("production" !== "production" && "'keys()' can only be used on observable objects, arrays, sets and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) {
            return obj[key];
        });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) {
            return obj.get(key);
        });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.values());
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail("production" !== "production" && "'values()' can only be used on observable objects, arrays, sets and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) {
            return [key, obj[key]];
        });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) {
            return [key, obj.get(key)];
        });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.entries());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) {
            return [index, key];
        });
    }
    return fail("production" !== "production" && "'entries()' can only be used on observable objects, arrays and maps");
}
function _set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1) {
                _set(obj, key_1, values_1[key_1]);
            }
        } finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj[$mobx];
        var existingObservable = adm.values.get(key);
        if (existingObservable) {
            adm.write(key, value);
        } else {
            adm.addObservableProp(key, value, adm.defaultEnhancer);
        }
    } else if (isObservableMap(obj)) {
        obj.set(key, value);
    } else if (isObservableSet(obj)) {
        obj.add(key);
    } else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else {
        return fail("production" !== "production" && "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        obj[$mobx].remove(key);
    } else if (isObservableMap(obj)) {
        obj.delete(key);
    } else if (isObservableSet(obj)) {
        obj.delete(key);
    } else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    } else {
        return fail("production" !== "production" && "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        return adm.has(key);
    } else if (isObservableMap(obj)) {
        return obj.has(key);
    } else if (isObservableSet(obj)) {
        return obj.has(key);
    } else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    } else {
        return fail("production" !== "production" && "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    } else if (isObservableMap(obj)) {
        return obj.get(key);
    } else if (isObservableArray(obj)) {
        return obj[key];
    } else {
        return fail("production" !== "production" && "'get()' can only be used on observable objects, arrays and maps");
    }
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function") return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles) map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source)) return source;
    if (typeof source !== "object") return source;
    // Directly return null if source is null
    if (source === null) return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date) return source;
    if (isObservableValue(source)) return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source)) keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) {
            return toJSHelper(value, options, __alreadySeen);
        });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++) {
            res_1[i] = toAdd[i];
        }return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function (value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        } else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function (value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        } else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    getPlainObjectKeys(source).forEach(function (key) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    });
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean") options = { detectCycles: options };
    if (!options) options = defaultOptions;
    options.detectCycles = options.detectCycles === undefined ? options.recurseEverything === true : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles) __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("production" !== "production" && "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) {
        thisArg = undefined;
    }
    startBatch();
    try {
        return action.apply(thisArg);
    } finally {
        endBatch();
    }
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError) opts.onError(error);else throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false) return fail("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, _assign(_assign({}, opts), { onError: reject }));
        cancel = function cancel() {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function getAdm(target) {
    return target[$mobx];
}
function isPropertyKey(val) {
    return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol) return true;
        var adm = getAdm(target);
        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
        // TODO: check performance stats!
        // if (adm.values.get(name as string)) return true
        if (isPropertyKey(name)) return adm.has(name);
        return name in target;
    },
    get: function get(target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol) return target[name];
        var adm = getAdm(target);
        var observable = adm.values.get(name);
        if (observable instanceof Atom) {
            var result = observable.get();
            if (result === undefined) {
                // This fixes #1796, because deleting a prop that has an
                // undefined value won't retrigger a observer (no visible effect),
                // the autorun wouldn't subscribe to future key changes (see also next comment)
                adm.has(name);
            }
            return result;
        }
        // make sure we start listening to future keys
        // note that we only do this here for optimization
        if (isPropertyKey(name)) adm.has(name);
        return target[name];
    },
    set: function set(target, name, value) {
        if (!isPropertyKey(name)) return false;
        _set(target, name, value);
        return true;
    },
    deleteProperty: function deleteProperty(target, name) {
        if (!isPropertyKey(name)) return false;
        var adm = getAdm(target);
        adm.remove(name);
        return true;
    },
    ownKeys: function ownKeys(target) {
        var adm = getAdm(target);
        adm.keysAtom.reportObserved();
        return Reflect.ownKeys(target);
    },
    preventExtensions: function preventExtensions(target) {
        fail("Dynamic observable objects cannot be frozen");
        return false;
    }
};
function createDynamicObservableObject(base) {
    var proxy = new Proxy(base, objectProxyTraps);
    base[$mobx].proxy = proxy;
    return proxy;
}

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = __spread(interceptable.interceptors || []);
        for (var i = 0, l = interceptors.length; i < l; i++) {
            change = interceptors[i](change);
            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
            if (!change) break;
        }
        return change;
    } finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners) return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        if (name === $mobx) return target[$mobx];
        if (name === "length") return target[$mobx].getArrayLength();
        if (typeof name === "number") {
            return arrayExtensions.get.call(target, name);
        }
        if (typeof name === "string" && !isNaN(name)) {
            return arrayExtensions.get.call(target, parseInt(name));
        }
        if (arrayExtensions.hasOwnProperty(name)) {
            return arrayExtensions[name];
        }
        return target[name];
    },
    set: function set(target, name, value) {
        if (name === "length") {
            target[$mobx].setArrayLength(value);
        }
        if (typeof name === "number") {
            arrayExtensions.set.call(target, name, value);
        }
        if (typeof name === "symbol" || isNaN(name)) {
            target[name] = value;
        } else {
            // numeric string
            arrayExtensions.set.call(target, parseInt(name), value);
        }
        return true;
    },
    preventExtensions: function preventExtensions(target) {
        fail("Observable arrays cannot be frozen");
        return false;
    }
};
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) {
        name = "ObservableArray@" + getNextId();
    }
    if (owned === void 0) {
        owned = false;
    }
    var adm = new ObservableArrayAdministration(name, enhancer, owned);
    addHiddenFinalProp(adm.values, $mobx, adm);
    var proxy = new Proxy(adm.values, arrayTraps);
    adm.proxy = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
}
var ObservableArrayAdministration = /** @class */function () {
    function ObservableArrayAdministration(name, enhancer, owned) {
        this.owned = owned;
        this.values = [];
        this.proxy = undefined;
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) {
            return enhancer(newV, oldV, name + "[..]");
        };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) {
            fireImmediately = false;
        }
        if (fireImmediately) {
            listener({
                object: this.proxy,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0) throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength) return;else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++) {
                newItems[i] = undefined;
            } // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        } else this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
        this.lastKnownLength += delta;
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined) index = 0;else if (index > length) index = length;else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) {
            return _this.enhancer(v, undefined);
        });
        if (false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        } else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.proxy,
            type: "update",
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.proxy,
            type: "splice",
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
    };
    return ObservableArrayAdministration;
}();
var arrayExtensions = {
    intercept: function intercept(handler) {
        return this[$mobx].intercept(handler);
    },
    observe: function observe(listener, fireImmediately) {
        if (fireImmediately === void 0) {
            fireImmediately = false;
        }
        var adm = this[$mobx];
        return adm.observe(listener, fireImmediately);
    },
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(0, adm.values.length, newItems);
    },
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    toJS: function toJS() {
        return this.slice();
    },
    toJSON: function toJSON() {
        // Used by JSON.stringify
        return this.toJS();
    },
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    splice: function splice(index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        var adm = this[$mobx];
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray(index);
            case 2:
                return adm.spliceWithArray(index, deleteCount);
        }
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    push: function push() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        if (false) {
            console.warn("[mobx] `observableArray.reverse()` will not update the array in place. Use `observableArray.slice().reverse()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().reverse())` to reverse & update in place");
        }
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    },
    sort: function sort(compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (false) {
            console.warn("[mobx] `observableArray.sort()` will not update the array in place. Use `observableArray.slice().sort()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().sort())` to sort & update in place");
        }
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues(adm.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    },
    get: function get(index) {
        var adm = this[$mobx];
        if (adm) {
            if (index < adm.values.length) {
                adm.atom.reportObserved();
                return adm.dehanceValue(adm.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    },
    set: function set(index, newValue) {
        var adm = this[$mobx];
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: adm.proxy,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        } else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        } else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    }
};
["concat", "every", "filter", "forEach", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some", "toString", "toLocaleString"].forEach(function (funcName) {
    arrayExtensions[funcName] = function () {
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var res = adm.dehanceValues(adm.values);
        return res[funcName].apply(res, arguments);
    };
});
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var _a;
var ObservableMapMarker = {};
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /** @class */function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) {
            enhancer = deepEnhancer;
        }
        if (name === void 0) {
            name = "ObservableMap@" + getNextId();
        }
        this.enhancer = enhancer;
        this.name = name;
        this[_a] = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        this[Symbol.toStringTag] = "Map";
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        var _this = this;
        if (!globalState.trackingDerivation) return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function () {
                return _this._hasMap.delete(key);
            });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        } else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: this._data.get(key).value,
                name: key
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            transaction(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "update",
                object: this,
                oldValue: observable.value,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            type: "add",
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key)) return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        return makeIterable({
            next: function next() {
                return nextIndex < keys.length ? { value: self.get(keys[nextIndex++]), done: false } : { done: true };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        return makeIterable({
            next: function next() {
                if (nextIndex < keys.length) {
                    var key = keys[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap.prototype[(_a = $mobx, Symbol.iterator)] = function () {
        return this.entries();
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var e_1, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2),
                    key = _e[0],
                    value = _e[1];
                callback.call(thisArg, value, key, this);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function (key) {
                return _this.set(key, other[key]);
            });else if (Array.isArray(other)) other.forEach(function (_b) {
                var _c = __read(_b, 2),
                    key = _c[0],
                    value = _c[1];
                return _this.set(key, value);
            });else if (isES6Map(other)) {
                if (other.constructor !== Map) fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                other.forEach(function (value, key) {
                    return _this.set(key, value);
                });
            } else if (other !== null && other !== undefined) fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_2, _b;
                try {
                    for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var key = _d.value;
                        _this.delete(key);
                    }
                } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                } finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                }
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = Array.from(_this.keys());
            var missingKeys = oldKeys.filter(function (k) {
                return newKeys.indexOf(k) === -1;
            });
            missingKeys.forEach(function (k) {
                return _this.delete(k);
            });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function get() {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var e_3, _b;
        var res = {};
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2),
                    key = _e[0],
                    value = _e[1];
                // We lie about symbol key types due to https://github.com/Microsoft/TypeScript/issues/1863
                res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return this.name + "[{ " + Array.from(this.keys()).map(function (key) {
            return stringifyKey(key) + ": " + ("" + _this.get(key));
        }).join(", ") + " }]";
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}();
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var _a$1;
var ObservableSetMarker = {};
var ObservableSet = /** @class */function () {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) {
            enhancer = deepEnhancer;
        }
        if (name === void 0) {
            name = "ObservableSet@" + getNextId();
        }
        this.name = name;
        this[_a$1] = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        this[Symbol.toStringTag] = "Set";
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) {
            return enhancer(newV, oldV, name);
        };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_1, _b;
                try {
                    for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var value = _d.value;
                        _this.delete(value);
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
            });
        });
    };
    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
        var e_2, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var value = _d.value;
                callbackFn.call(thisArg, value, value, this);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function get() {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change) return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "add",
                object: this,
                newValue: value
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(change);
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
        return this;
    };
    ObservableSet.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: value
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name }));
            transaction(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function () {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? { value: [keys[index], values[index]], done: false } : { done: true };
            }
        });
    };
    ObservableSet.prototype.keys = function () {
        return this.values();
    };
    ObservableSet.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues = Array.from(this._data.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false } : { done: true };
            }
        });
    };
    ObservableSet.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (Array.isArray(other)) {
                _this.clear();
                other.forEach(function (value) {
                    return _this.add(value);
                });
            } else if (isES6Set(other)) {
                _this.clear();
                other.forEach(function (value) {
                    return _this.add(value);
                });
            } else if (other !== null && other !== undefined) {
                fail("Cannot initialize set from " + other);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
        "production" !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function () {
        return this.name + "[ " + Array.from(this).join(", ") + " ]";
    };
    ObservableSet.prototype[(_a$1 = $mobx, Symbol.iterator)] = function () {
        return this.values();
    };
    return ObservableSet;
}();
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

var ObservableObjectAdministration = /** @class */function () {
    function ObservableObjectAdministration(target, values, name, defaultEnhancer) {
        if (values === void 0) {
            values = new Map();
        }
        this.target = target;
        this.values = values;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.keysAtom = new Atom(name + ".keys");
    }
    ObservableObjectAdministration.prototype.read = function (key) {
        return this.values.get(key).get();
    };
    ObservableObjectAdministration.prototype.write = function (key, newValue) {
        var instance = this.target;
        var observable = this.values.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: this.proxy || instance,
                name: key,
                newValue: newValue
            });
            if (!change) return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy ? {
                type: "update",
                object: this.proxy || instance,
                oldValue: observable.value,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.has = function (key) {
        var map = this.pendingKeys || (this.pendingKeys = new Map());
        var entry = map.get(key);
        if (entry) return entry.get();else {
            var exists = !!this.values.get(key);
            // Possible optimization: Don't have a separate map for non existing keys,
            // but store them in the values map instead, using a special symbol to denote "not existing"
            entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            map.set(key, entry);
            return entry.get(); // read to subscribe
        }
    };
    ObservableObjectAdministration.prototype.addObservableProp = function (propName, newValue, enhancer) {
        if (enhancer === void 0) {
            enhancer = this.defaultEnhancer;
        }
        var target = this.target;
        assertPropertyConfigurable(target, propName);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change) return;
            newValue = change.newValue;
        }
        var observable = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
        this.values.set(propName, observable);
        newValue = observable.value; // observableValue might have changed it
        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
        this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
    propName, options) {
        var target = this.target;
        options.name = options.name || this.name + "." + stringifyKey(propName);
        this.values.set(propName, new ComputedValue(options));
        if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName)) Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values.has(key)) return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: key,
                type: "remove"
            });
            if (!change) return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldObservable = this.values.get(key);
            var oldValue = oldObservable && oldObservable.get();
            oldObservable && oldObservable.set(undefined);
            // notify key and keyset listeners
            this.keysAtom.reportChanged();
            this.values.delete(key);
            if (this.pendingKeys) {
                var entry = this.pendingKeys.get(key);
                if (entry) entry.set(false);
            }
            // delete the prop
            delete this.target[key];
            var change = notify || notifySpy ? {
                type: "remove",
                object: this.proxy || target,
                oldValue: oldValue,
                name: key
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        } finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.notifyPropertyAddition = function (key, newValue) {
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy ? {
            type: "add",
            object: this.proxy || this.target,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
        if (this.pendingKeys) {
            var entry = this.pendingKeys.get(key);
            if (entry) entry.set(true);
        }
        this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var e_1, _a;
        this.keysAtom.reportObserved();
        // return Reflect.ownKeys(this.values) as any
        var res = [];
        try {
            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2),
                    key = _d[0],
                    value = _d[1];
                if (value instanceof ObservableValue) res.push(key);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return res;
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) {
        name = "";
    }
    if (defaultEnhancer === void 0) {
        defaultEnhancer = deepEnhancer;
    }
    if (Object.prototype.hasOwnProperty.call(target, $mobx)) return target[$mobx];
    "production" !== "production" && invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target)) name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name) name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), stringifyKey(name), defaultEnhancer);
    addHiddenProp(target, $mobx, adm);
    return adm;
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
        configurable: true,
        enumerable: true,
        get: function get() {
            return this[$mobx].read(propName);
        },
        set: function set(v) {
            this[$mobx].write(propName, v);
        }
    });
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner[$mobx];
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner[$mobx];
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
        configurable: globalState.computedConfigurable,
        enumerable: false,
        get: function get() {
            return getAdministrationForComputedPropOwner(this).read(propName);
        },
        set: function set(v) {
            getAdministrationForComputedPropOwner(this).write(propName, v);
        }
    });
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing[$mobx]);
    }
    return false;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) fail("production" !== "production" && "It is not possible to get index atoms from arrays");
            return thing[$mobx].atom;
        }
        if (isObservableSet(thing)) {
            return thing[$mobx];
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined) return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable) fail("production" !== "production" && "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing[$mobx]) thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property) return fail("production" !== "production" && "please specify a property");
            var observable = thing[$mobx].values.get(property);
            if (!observable) fail("production" !== "production" && "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    } else if (typeof thing === "function") {
        if (isReaction(thing[$mobx])) {
            // disposer function
            return thing[$mobx];
        }
    }
    return fail("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing) fail("Expecting some object");
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing[$mobx]) return thing[$mobx];
    fail("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);else named = getAtom(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) {
        depth = -1;
    }
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor,
            bCtor = b.constructor;
        if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
            return false;
        }
    }
    if (depth === 0) {
        return false;
    } else if (depth < 0) {
        depth = -1;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}

/*
The only reason for this file to exist is pure horror:
Without it rollup can make the bundling fail at any point in time; when it rolls up the files in the wrong order
it will cause undefined errors (for example because super classes or local variables not being hoisted).
With this file that will still happen,
but at least in this file we can magically reorder the imports with trial and error until the build succeeds again.
*/

/**
 * (c) Michel Weststrate 2015 - 2018
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
} catch (e) {
    var g = getGlobal();
    if (typeof process === "undefined") g.process = {};
    g.process.env = {};
}
(function () {
    function testCodeMinification() {}
    if (testCodeMinification.name !== "testCodeMinification" && "production" !== "production" && process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
        // trick so it doesn't get replaced
        var varName = ["process", "env", "NODE_ENV"].join(".");
        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "7AqT":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("ZHvQ");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var Iterators = __webpack_require__("dhak");
module.exports = __webpack_require__("zKeE").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "7Rdn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__("1+RE");

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__("v5/l");

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__("RnNb");

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__("avXi");

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__("Z8rO");

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__("WmEJ");

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),

/***/ "85ue":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("ZC1a");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),

/***/ "868B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),

/***/ "9kxq":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("BxvP");
var document = __webpack_require__("i1Q6").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "9qxo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("eW0v").createClass;

/***/ }),

/***/ "A+gr":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),

/***/ "A8RV":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("3w4y");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),

/***/ "Ag0p":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("FTXF");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "B9Lq":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("yS17");
var toIObject = __webpack_require__("Wyka");
var arrayIndexOf = __webpack_require__("LNnS")(false);
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "BblM":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),

/***/ "BxvP":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "C8N4":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("1RxS"),
    hashDelete = __webpack_require__("qBl2"),
    hashGet = __webpack_require__("hClK"),
    hashHas = __webpack_require__("YIaf"),
    hashSet = __webpack_require__("Ag0p");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),

/***/ "CYb7":
/***/ (function(module, exports, __webpack_require__) {

!function (t, n) {
   true ? module.exports = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }return t === o ? e : t;
  } : "function" == typeof define && define.amd ? define(function () {
    return function (t, n, e, i, o) {
      for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
        t = t ? t[n[i]] : o;
      }return t === o ? e : t;
    };
  }) : t.dlv = function (t, n, e, i, o) {
    for (n = n.split ? n.split(".") : n, i = 0; i < n.length; i++) {
      t = t ? t[n[i]] : o;
    }return t === o ? e : t;
  };
}(this);
//# sourceMappingURL=dlv.umd.js.map

/***/ }),

/***/ "E5Ce":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("ShN9");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "EKwp":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("BxvP");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "EiMJ":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("wtMJ");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),

/***/ "Ewuv":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("yEjJ");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),

/***/ "FFZn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("3v7p"), __esModule: true };

/***/ }),

/***/ "FTXF":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bViC");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),

/***/ "G3gK":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("ZC1a");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),

/***/ "GeoD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gfzd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("zotD");
var IE8_DOM_DEFINE = __webpack_require__("R6c1");
var toPrimitive = __webpack_require__("EKwp");
var dP = Object.defineProperty;

exports.f = __webpack_require__("6MLN") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "H1RQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("RsE0");
} else {
  module.exports = require('./cjs/react-is.development.js');
}

/***/ }),

/***/ "HHE0":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("yS17");
var toObject = __webpack_require__("mbLO");
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),

/***/ "InAa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__("H1RQ");

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ "JjU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__("rNh1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iconBar_js__ = __webpack_require__("0uzy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("vdRI");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h2",
  { "class": "section-header" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.header.item" })
  ),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.header.item2" })
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.desc.item" });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("br", null);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.desc.item2" });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.desc.link" });

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h3",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.first.title" })
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "ul",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.first.advantage.item" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.first.advantage.item1" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    { "class": "highlight" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.first.advantage.item2" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.first.advantage.item3" })
  )
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { "class": "price" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "class": "value" },
    "\u20AC29"
  ),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "class": "period" },
    "/ ",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "cart.month.full" })
  )
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { "class": "term" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.note" }),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.first.noteMonth" }),
    " ",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "cart.months.full" })
  )
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.btn" });

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h3",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.second.title" })
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "ul",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.second.advantage.item" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.second.advantage.item1" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    { "class": "highlight" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.second.advantage.item2" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.second.advantage.item3" })
  )
);

var _ref13 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { "class": "price" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "class": "value" },
    "\u20AC39"
  ),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "class": "period" },
    "/ ",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "cart.month.full" })
  )
);

var _ref14 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { "class": "term" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.note" }),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.second.noteMonth" }),
    " ",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "cart.months.full" })
  )
);

var _ref15 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.btn" });

var _ref16 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h3",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.third.title" })
);

var _ref17 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "ul",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.third.advantage.item" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.third.advantage.item1" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    { "class": "highlight" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.third.advantage.item2" })
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "li",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.third.advantage.item3" })
  )
);

var _ref18 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { "class": "price" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "class": "value" },
    "\u20AC79"
  ),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "span",
    { "class": "period" },
    "/ ",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "cart.month.full" })
  )
);

var _ref19 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "div",
  { "class": "term" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.note" }),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.third.noteMonth" }),
    " ",
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "cart.months.full" })
  )
);

var _ref20 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.items.btn" });

var _ref21 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h2",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.title" })
);

var _ref22 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.text.item" });

var _ref23 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "strong",
  null,
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.text.bold" })
);

var _ref24 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.text.item2" });

var _ref25 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.text.link" });

var _ref26 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "p",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.bezPVN" }),
  "\xA0",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "a",
    { href: "/assets/Dolphnet_liguma_kopsavilkums.pdf", target: "_blank" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: "plans.footer.bezPVNextra" })
  )
);

var Plans = function (_Component) {
  _inherits(Plans, _Component);

  function Plans() {
    var _temp, _this, _ret;

    _classCallCheck(this, Plans);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      persentage: [0, 0, 0]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Plans.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener("scroll", function () {
      return _this2.handleScroll();
    });
  };

  Plans.prototype.handleScroll = function handleScroll() {
    if (!this.container) return;
    if (this.container.getBoundingClientRect().y < 300) {
      this.setState({
        persentage: [10, 50, 100]
      });
    }
  };

  Plans.prototype.render = function render(props) {
    var _this3 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      props,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { "class": "container", ref: function ref(el) {
            return _this3.container = el;
          } },
        _ref,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "p",
          null,
          _ref2,
          _ref3,
          " ",
          _ref4,
          " ",
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_3_preact_router_match__["Link"],
            { href: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].prefix + "/availability" },
            _ref5
          ),
          "."
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "ul",
          { "class": "plans clearfix" },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "li",
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              { "class": "inner" },
              _ref6,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__iconBar_js__["a" /* default */], {
                color: "#69788d",
                number: "200",
                percent: this.state.persentage[0]
              }),
              _ref7,
              _ref8,
              _ref9
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "a",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].setDesiredService(1);
                  Object(__WEBPACK_IMPORTED_MODULE_4_preact_router__["route"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].prefix + "/availability");
                },
                href: "javascript:",
                "class": "button"
              },
              _ref10
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "li",
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              { "class": "inner" },
              _ref11,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__iconBar_js__["a" /* default */], {
                color: "#1dba16",
                number: "500",
                percent: this.state.persentage[1]
              }),
              _ref12,
              _ref13,
              _ref14
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "a",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].setDesiredService(2);
                  Object(__WEBPACK_IMPORTED_MODULE_4_preact_router__["route"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].prefix + "/availability");
                },
                href: "javascript:",
                "class": "button"
              },
              _ref15
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "li",
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              { "class": "inner" },
              _ref16,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__iconBar_js__["a" /* default */], {
                color: "#f03a47",
                number: "1000",
                percent: this.state.persentage[2]
              }),
              _ref17,
              _ref18,
              _ref19
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "a",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].setDesiredService(3);
                  Object(__WEBPACK_IMPORTED_MODULE_4_preact_router__["route"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].prefix + "/availability");
                },
                href: "javascript:",
                "class": "button"
              },
              _ref20
            )
          )
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { "class": "container plans" },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "article",
          null,
          !props.home && _ref21,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "p",
            null,
            _ref22,
            _ref23,
            _ref24,
            "\xA0",
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              __WEBPACK_IMPORTED_MODULE_3_preact_router_match__["Link"],
              { href: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].prefix + "/contact?service=leased&form=true" },
              _ref25
            ),
            "."
          ),
          _ref26
        )
      )
    );
  };

  return Plans;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Plans);

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/preloader.css
var preloader = __webpack_require__("GeoD");
var preloader_default = /*#__PURE__*/__webpack_require__.n(preloader);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/mobx-preact/lib/index.module.js
var index_module = __webpack_require__("mKeQ");

// EXTERNAL MODULE: ../node_modules/mobx/lib/mobx.module.js
var mobx_module = __webpack_require__("6uYi");

// EXTERNAL MODULE: ./components/asyncComponent.js
var asyncComponent = __webpack_require__("vGFV");

// EXTERNAL MODULE: ../node_modules/preact-i18n/dist/preact-i18n.esm.js
var preact_i18n_esm = __webpack_require__("rNh1");

// EXTERNAL MODULE: ./components/locals/lv.json
var lv = __webpack_require__("itUc");
var lv_default = /*#__PURE__*/__webpack_require__.n(lv);

// EXTERNAL MODULE: ./components/locals/en.json
var en = __webpack_require__("twDh");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./components/locals/ru.json
var ru = __webpack_require__("i7ze");
var ru_default = /*#__PURE__*/__webpack_require__.n(ru);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./store/index.js
var store = __webpack_require__("vdRI");

// CONCATENATED MODULE: ./components/header/index.js
var _class;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = Object(preact_min["h"])(
	'ul',
	{ 'class': 'contacts' },
	Object(preact_min["h"])(
		'li',
		null,
		Object(preact_min["h"])(
			'a',
			{ href: 'tel:+37169999999' },
			'+371-69-999-999'
		)
	),
	Object(preact_min["h"])(
		'li',
		null,
		Object(preact_min["h"])(
			'a',
			{ href: 'mailto:atbalsts@dolphnet.lv', 'class': 'email' },
			'atbalsts@dolphnet.lv'
		)
	)
);

var _ref2 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.links.cabinet' });

var _ref3 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.links.cabinet' });

var _ref4 = Object(preact_min["h"])(
	'svg',
	{ xmlns: 'http://www.w3.org/2000/svg', 'class': 'icon' },
	Object(preact_min["h"])('use', { xlinkhref: '/assets/img/icons.svg#rocket' })
);

var _ref5 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.links.availability' });

var _ref6 = Object(preact_min["h"])('img', { src: '/assets/img/logo-scroll.svg', alt: 'DolphNet Internet' });

var _ref7 = Object(preact_min["h"])(
	'span',
	null,
	Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.links.biznes.text' }),
	Object(preact_min["h"])('br', null),
	' ',
	Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.links.biznes.text2' })
);

var _ref8 = Object(preact_min["h"])(
	'svg',
	{ xmlns: 'http://www.w3.org/2000/svg', 'class': 'icon' },
	Object(preact_min["h"])('use', { xlinkhref: '/assets/img/icons.svg#rocket' })
);

var _ref9 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.links.availability' });

var _ref10 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.menu.item' });

var _ref11 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.menu.item2' });

var _ref12 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.menu.item3' });

var _ref13 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'header.menu.item4' });

var header_Header = Object(index_module["a" /* observer */])(_class = function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		_classCallCheck(this, Header);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Header.prototype.render = function render(props) {
		var prefix = '/' + store["a" /* default */].lang;
		var darkLogo = store["a" /* default */].activePage == '/internet' || store["a" /* default */].activePage == '/profile' || store["a" /* default */].activePage == '/startups';
		return Object(preact_min["h"])(
			'header',
			{ id: 'header' },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'top' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'container wide' },
					_ref,
					Object(preact_min["h"])(
						'ul',
						{ 'class': 'language-switcher' },
						store["a" /* default */].langs.map(function (lang) {
							return Object(preact_min["h"])(
								'li',
								{ 'class': store["a" /* default */].lang == lang ? "active" : '' },
								Object(preact_min["h"])(
									match["Link"],
									{ href: "/" + lang + store["a" /* default */].redirectTo },
									lang.toUpperCase()
								)
							);
						})
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': 'actions' },
						store["a" /* default */].loggedIn ? Object(preact_min["h"])(
							match["Link"],
							{ href: prefix + "/profile", 'class': 'profile' },
							_ref2
						) : Object(preact_min["h"])(
							'a',
							{ onClick: function onClick() {
									return store["a" /* default */].showModal('login');
								}, 'class': 'profile' },
							_ref3
						),
						Object(preact_min["h"])(
							match["Link"],
							{ href: prefix + "/availability", 'class': 'apply' },
							_ref4,
							_ref5
						)
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': store["a" /* default */].sticky && !store["a" /* default */].hideMenu ? 'main sticky' : 'main', ref: props.mainRef },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'container wide' },
					Object(preact_min["h"])(
						match["Link"],
						{ href: prefix, 'class': 'logo' },
						Object(preact_min["h"])('img', { src: darkLogo ? "/assets/img/logo2.svg" : "/assets/img/logo.svg", alt: 'DolphNet Internet' }),
						_ref6,
						_ref7
					),
					Object(preact_min["h"])(
						match["Link"],
						{ href: prefix + "/availability", 'class': 'apply' },
						_ref8,
						_ref9
					),
					Object(preact_min["h"])(
						'nav',
						{ id: 'nav', style: store["a" /* default */].hideMenu ? 'display:none' : '' },
						Object(preact_min["h"])('a', { onClick: function onClick() {
								store["a" /* default */].toggleMenu();
							}, 'class': 'menu-trigger' }),
						Object(preact_min["h"])(
							'ul',
							{ 'class': "main-menu" + (store["a" /* default */].mobileMenu ? ' active' : '') },
							Object(preact_min["h"])(
								'li',
								{ 'class': 'speedometer' },
								Object(preact_min["h"])(
									match["Link"],
									{ activeClassName: 'active', href: prefix + "/internet" },
									_ref10
								)
							),
							Object(preact_min["h"])(
								'li',
								null,
								Object(preact_min["h"])(
									match["Link"],
									{ activeClassName: 'active', href: prefix + "/telephone" },
									_ref11
								)
							),
							Object(preact_min["h"])(
								'li',
								null,
								Object(preact_min["h"])(
									match["Link"],
									{ activeClassName: 'active', href: prefix + "/services" },
									_ref12
								)
							),
							Object(preact_min["h"])(
								'li',
								null,
								Object(preact_min["h"])(
									match["Link"],
									{ activeClassName: 'active', href: prefix + "/support" },
									_ref13
								)
							)
						)
					)
				)
			)
		)
		// <header class={style.header}>
		// 	<h1>Preact App</h1>
		// 	<nav>
		// 		<Link activeClassName={style.active} href="/">Home</Link>
		// 		<Link activeClassName={style.active} href="/profile">Me</Link>
		// 		<Link activeClassName={style.active} href="/profile/john">John</Link>
		// 	</nav>
		// </header>
		;
	};

	return Header;
}(preact_min["Component"])) || _class;

;

/* harmony default export */ var header = (header_Header);
// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("Ukh+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/internet.js

		

		function internet_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("H7zq") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var internet = (async_default()(internet_load));
	
// CONCATENATED MODULE: ./routes/startups.js

		

		function startups_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("vUzY") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var startups = (async_default()(startups_load));
	
// CONCATENATED MODULE: ./routes/services/index.js

		

		function services_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("iWNf") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var services = (async_default()(services_load));
	
// CONCATENATED MODULE: ./routes/faq.js

		

		function faq_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("8vFA") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var faq = (async_default()(faq_load));
	
// CONCATENATED MODULE: ./routes/services/serviceWrapper.js


function serviceWrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function serviceWrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function serviceWrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var serviceWrapper_ServiceWrapper = function (_Component) {
	serviceWrapper__inherits(ServiceWrapper, _Component);

	function ServiceWrapper() {
		serviceWrapper__classCallCheck(this, ServiceWrapper);

		return serviceWrapper__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ServiceWrapper.prototype.componentDidMount = function componentDidMount() {
		if (typeof this.props.loading === 'function') this.props.loading();
	};

	ServiceWrapper.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ 'class': 'min_height_services' },
			Object(preact_min["h"])(
				'div',
				{ id: 'main' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'container' },
					this.props.children
				)
			)
		);
	};

	return ServiceWrapper;
}(preact_min["Component"]);

/* harmony default export */ var serviceWrapper = (serviceWrapper_ServiceWrapper);
// CONCATENATED MODULE: ./routes/services/email.js


function email__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function email__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function email__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var email__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'Uz\u0146\u0113muma e-pasta dom\u0113na un pastkast\u012B\u0161u uztur\u0113\u0161ana DolphinHost\u2122 m\u0101ko\u0146skait\u013Co\u0161anas datu centr\u0101.'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'\u0100trdarb\u012Bgs e-pastu serveris'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Dro\u0161a e-pastu uzglab\u0101\u0161ana'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Aizsardz\u012Bba pret v\u012Brusiem un m\u0113stul\u0113m'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja \u0113rti administr\u0113t e-pasta kast\u012Btes, izmantojot administr\u0113\u0161anas vidi'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un e-pasta infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		)
	)
);

var email__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC5'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var email__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'10% atlaide maks\u0101jot par 12 m\u0113ne\u0161iem'
	)
);

var email__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var email_aService = function (_Component) {
	email__inherits(aService, _Component);

	function aService() {
		email__classCallCheck(this, aService);

		return email__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			email__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				email__ref2,
				email__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=email&form=true', 'class': 'button' },
						email__ref4
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/phone.js


function phone__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function phone__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function phone__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var phone__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'Viens balss kan\u0101ls un viens telefona numurs, kas tiek nodro\u0161in\u0101ts, izmantojot interneta piesl\u0113gumu un ',
		Object(preact_min["h"])(
			'i',
			null,
			'SIP (Session Initiation Protocol) p\u0101rraides protokolu'
		),
		'.'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja izmantot t\u0101lruni jebkur\u0101 viet\u0101, kur pieejams interneta piesl\u0113gums. '
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja \u0113rti p\u0101rskat\u012Bt zvanu atskaites'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'T\u0101lru\u0146a numurs, kuru viegli atcer\u0113ties - patreiz v\u0113l pieejami numuri no DolphNet numuru diapazona - +371 69999 XXX, '
		)
	)
);

var phone__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC5'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var phone__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Sl\u0113dzot l\u012Bgumu uz 12 m\u0113ne\u0161iem d\u0101van\u0101 IP telefona apar\u0101ts.'
	)
);

var phone__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var phone__ref5 = Object(preact_min["h"])('div', { 'class': 'clearfix' });

var phone__ref6 = Object(preact_min["h"])(
	'h2',
	null,
	'Sarunu tarifi'
);

var phone_aService = function (_Component) {
	phone__inherits(aService, _Component);

	function aService() {
		phone__classCallCheck(this, aService);

		return phone__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			phone__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				phone__ref2,
				phone__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=phone&form=true', 'class': 'button' },
						phone__ref4
					)
				)
			),
			phone__ref5,
			Object(preact_min["h"])(
				'article',
				null,
				phone__ref6,
				Object(preact_min["h"])(asyncComponent["a" /* default */], { getComponent: function getComponent() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "khGl"));
					} })
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/hosting.js


function hosting__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hosting__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function hosting__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var hosting__ref = Object(preact_min["h"])(
  "article",
  { "class": "has-widget" },
  Object(preact_min["h"])(
    "p",
    null,
    "Izj\u016Btiet pa \u012Bstam lielisku \u0101trumu - t\u0101du, pie kura esam pieradu\u0161i, izmantojot iem\u012B\u013Cotos servisus YouTube, Instagram, Netflix, Gmail, Bolt Taxi un daudzus citus!"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "DolphNet klientiem ir pieejams m\u016Bsdien\u012Bgs m\u0101ko\u0146hostings, ar kura pal\u012Bdz\u012Bbu jebkur\u0101 pasaules viet\u0101 m\u0101jas lapai var piek\u013C\u016Bt maksim\u0101li \u0101tri."
  ),
  Object(preact_min["h"])("img", {
    style: "max-width: 200px;",
    src: "/assets/img/amazon-web-services.svg",
    alt: "AWS"
  }),
  Object(preact_min["h"])("img", {
    style: "max-width: 200px;margin: 15px 25px;",
    src: "/assets/img/google-cloud-services.svg",
    alt: "AWS"
  }),
  Object(preact_min["h"])(
    "p",
    null,
    "Pakalpojuma nodro\u0161in\u0101\u0161anai tiek izmantotas platformas Amazon Web Services (AWS), Google Cloud Platform (GCP) un citas, kuras izmanto veiksm\u012Bg\u0101kie pasaules z\u012Bmoli, t\u0101di k\u0101 Apple, McDonalds, GoPro, Verizon, Spotify, HSBC, Home Depot, Snapchat, HTC, Best Buy, Philips, Coca Cola, Domino's, Feedly, ShareThis, Sony Music, Ubisoft un The Washington Post."
  ),
  Object(preact_min["h"])(
    "h2",
    null,
    "Priek\u0161roc\u012Bbas"
  ),
  Object(preact_min["h"])(
    "ul",
    null,
    Object(preact_min["h"])(
      "li",
      null,
      "Pa\u0101trin\u0101ta m\u0101jas lapas iel\u0101de no jebkuras vietas pasaul\u0113;"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "Rezerves kopijas katru dienu;"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "Aizsardz\u012Bba pret hakeru uzbrukumiem;"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "\u0112rta iestat\u012Bjumu p\u0101rvalde hostinga administr\u0113\u0161anas vid\u0113;"
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "Datu centra un infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai."
    )
  )
);

var hosting__ref2 = Object(preact_min["h"])(
  "h3",
  null,
  Object(preact_min["h"])(
    "span",
    { "class": "from" },
    Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: "cart.from" })
  ),
  Object(preact_min["h"])(
    "span",
    { "class": "value" },
    "\u20AC160"
  ),
  Object(preact_min["h"])(
    "span",
    { "class": "term" },
    " ",
    Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: "cart.year.full" })
  )
);

var hosting__ref3 = Object(preact_min["h"])(
  "ul",
  { "class": "bullet" },
  Object(preact_min["h"])(
    "li",
    null,
    "Bezmaksas piesl\u0113g\u0161ana"
  ),
  Object(preact_min["h"])(
    "li",
    null,
    "Bezmaksas m\u0101jas lapas p\u0101rcel\u0161ana"
  ),
  Object(preact_min["h"])(
    "li",
    null,
    "10% atlaide, maks\u0101jot par 24 m\u0113ne\u0161iem"
  )
);

var hosting__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: "email.widget.list.btn" });

var hosting_aService = function (_Component) {
  hosting__inherits(aService, _Component);

  function aService() {
    hosting__classCallCheck(this, aService);

    return hosting__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  aService.prototype.render = function render() {
    return Object(preact_min["h"])(
      serviceWrapper,
      this.props,
      hosting__ref,
      Object(preact_min["h"])(
        "div",
        { "class": "widget plan" },
        hosting__ref2,
        hosting__ref3,
        Object(preact_min["h"])(
          "div",
          null,
          Object(preact_min["h"])(
            match["Link"],
            {
              href: store["a" /* default */].prefix + "/contact?service=hosting&form=true",
              "class": "button"
            },
            hosting__ref4
          )
        )
      )
    );
  };

  return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/pbx.js


function pbx__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function pbx__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function pbx__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var pbx__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'DolphinHost\u2122 m\u0101ko\u0146skait\u013Co\u0161anas datu centr\u0101 izvietota virtu\u0101l\u0101 telefona centr\u0101le.'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Tie\u0161ais optiskais piesl\u0113gums nodro\u0161ina izcilu sarunu kvalit\u0101ti.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Sveiciena teksts, valodas un sarunas veida izv\u0113les iesp\u0113ja klientam nospie\u017Eot tausti\u0146u (IVR)'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Katram darbiniekam iesp\u0113jams konfigur\u0113t savu balss paskast\u012Btiti.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Neierobe\u017Eots skaits iek\u0161\u0113jo t\u0101lru\u0146a numuru.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja \u0113rti administr\u0113t iek\u0161\u0113jos numurus, izmantojot administr\u0113\u0161anas vidi'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Zvanu ieraksta iesp\u0113ja un dro\u0161a ierakstu uzglab\u0101\u0161ana (visi dati tiek glab\u0101ti 3 kopij\u0101s uz fizisiki neatkar\u012Bg\u0101m iek\u0101rt\u0101m)'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un telefonijas infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		)
	)
);

var pbx__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC39'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var pbx__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Sl\u0113dzot l\u012Bgumu uz 12 m\u0113ne\u0161iem d\u0101van\u0101 16 l\u012Bniju telefona apar\u0101ts ar kr\u0101sainu displeju.'
	)
);

var pbx__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var pbx__ref5 = Object(preact_min["h"])('div', { 'class': 'clearfix' });

var pbx__ref6 = Object(preact_min["h"])(
	'h2',
	null,
	'Sarunu tarifi'
);

var pbx_aService = function (_Component) {
	pbx__inherits(aService, _Component);

	function aService() {
		pbx__classCallCheck(this, aService);

		return pbx__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			pbx__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				pbx__ref2,
				pbx__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=pbx&form=true', 'class': 'button' },
						pbx__ref4
					)
				)
			),
			pbx__ref5,
			Object(preact_min["h"])(
				'article',
				null,
				pbx__ref6,
				Object(preact_min["h"])(asyncComponent["a" /* default */], { getComponent: function getComponent() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "khGl"));
					} })
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/surveillance.js


function surveillance__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function surveillance__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function surveillance__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var surveillance__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'DolphinHost\u2122 m\u0101ko\u0146skait\u013Co\u0161anas datu centr\u0101 izvietots videonov\u0113ro\u0161anas kameru ieraksta serveris. Iesp\u0113ja apskat\u012Bt videonov\u0113ro\u0161anas kameras re\u0101l\u0101 laika re\u017E\u012Bm\u0101 piesl\u0113dzoties att\u0101lin\u0101ti ar lietot\u0101jv\u0101rdu, paroli un kodu kalkulatoru. '
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Dro\u0161s videonov\u0113ro\u0161anas serveris'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Aizsardz\u012Bba pret datu zudumiem (visi videoieraksti tiek glab\u0101ti 3 kopij\u0101s uz fizisiki neatkar\u012Bg\u0101m iek\u0101rt\u0101m).'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja \u0113rti p\u0101rskat\u012Bt video ierakstus'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un videoierakstu uzglab\u0101\u0161anas infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		)
	)
);

var surveillance__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC20'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var surveillance__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'10% atlaide maks\u0101jot par 12 m\u0113ne\u0161iem'
	)
);

var surveillance__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var surveillance_aService = function (_Component) {
	surveillance__inherits(aService, _Component);

	function aService() {
		surveillance__classCallCheck(this, aService);

		return surveillance__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			surveillance__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				surveillance__ref2,
				surveillance__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=surveillance&form=true', 'class': 'button' },
						surveillance__ref4
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/isdn.js


function isdn__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function isdn__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function isdn__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var isdn__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'Divi balss kan\u0101li un iesp\u0113ja aktiviz\u0113t neierobe\u017Eotu skaitu telefona numuru, kas tiek nodro\u0161in\u0101ta, izmantojot interneta piesl\u0113gumu un SIP (Session Initiation Protocol) p\u0101rraides protokolu. Pakalpojums ir savietojams ar vis\u0101m popul\u0101r\u0101kaj\u0101m ISDN2 biroju telefonu centr\u0101l\u0113m (Alcatel, Cisco, Panasonic, Siemens, Ericcson, Nortel, u.c.). Lai izmantotu pakalpojumu, uz\u0146\u0113mum\u0101 uzst\u0101d\u012Bto eso\u0161o centr\u0101li nav nepiecie\u0161ams main\u012Bt vai konfigur\u0113t.'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja izmantot eso\u0161o telefona centr\u0101li un t\u0101lru\u0146us, nav j\u0101p\u0101rb\u016Bv\u0113 eso\u0161\u0101 kabe\u013Cu infrastrukt\u016B\u0157a'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Tie\u0161ais optiskais piesl\u0113gums nodro\u0161ina izcilu sarunu kvalit\u0101ti.'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Nodro\u0161ina pak\u0101peniskas p\u0101rejas iesp\u0113ju uz IP telefoniju'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Zvanu ieraksta iesp\u0113ja un dro\u0161a ierakstu uzglab\u0101\u0161ana (visi dati tiek glab\u0101ti 3 kopij\u0101s uz fizisiki neatkar\u012Bg\u0101m iek\u0101rt\u0101m)'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un telefonijas infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		)
	)
);

var isdn__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC14'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var isdn__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'10% atlaide maks\u0101jot par 12 m\u0113ne\u0161iem'
	)
);

var isdn__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var isdn_aService = function (_Component) {
	isdn__inherits(aService, _Component);

	function aService() {
		isdn__classCallCheck(this, aService);

		return isdn__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			isdn__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				isdn__ref2,
				isdn__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=isdn&form=true', 'class': 'button' },
						isdn__ref4
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/files.js


function files__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function files__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function files__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var files__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'DolphinHost\u2122 m\u0101ko\u0146skait\u013Co\u0161anas datu centr\u0101 izvietots failu serveris, kas pieejams tikai no Abonenta iek\u0161\u0113j\u0101 t\u012Bkla un nodro\u0161ina visu saglab\u0101to failu \u0161ifr\u0113\u0161anu. Savietojams ar Windows, Macintosh un Linux darbstacij\u0101m. Administratoram iesp\u0113ja noteikt individu\u0101las piek\u013Cuves ties\u012Bbas map\u0113m un failiem. '
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'\u0100trdarb\u012Bgs failu serveris'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Aizsardz\u012Bba pret datu zudumiem (visi dati tiek glab\u0101ti 3 kopij\u0101s uz fizisiki neatkar\u012Bg\u0101m iek\u0101rt\u0101m).'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Aizsardz\u012Bba pret v\u012Brusiem'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja \u0113rti administr\u0113t lietot\u0101jus, izmantojot administr\u0113\u0161anas vidi'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un e-pasta infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		)
	)
);

var files__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC10'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var files__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'10% atlaide maks\u0101jot par 12 m\u0113ne\u0161iem'
	)
);

var files__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var files_aService = function (_Component) {
	files__inherits(aService, _Component);

	function aService() {
		files__classCallCheck(this, aService);

		return files__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			files__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				files__ref2,
				files__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=files&form=true', 'class': 'button' },
						files__ref4
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/serverless.js


function serverless__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function serverless__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function serverless__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var serverless__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'DolphinHost\u2122 m\u0101ko\u0146skait\u013Co\u0161anas datu centr\u0101 izvietots virtu\u0101lais serveris, kas pieejams tikai no Abonenta iek\u0161\u0113j\u0101 t\u012Bkla. Paredz\u0113ts specializ\u0113tas klienta programmat\u016Bras darbin\u0101\u0161anai. Atbalsta visas popul\u0101r\u0101k\u0101s biznesa aplik\u0101cijas (gr\u0101matved\u012Bbas sist\u0113mas Tildes Jumis, Zalktis, interneta banku serverus, sist\u0113mu \u201CHorizon\u201D u.c.)'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'\u0100trdarb\u012Bgs virtu\u0101lais serveris'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Aizsardz\u012Bba pret datu zudumiem (visi dati tiek glab\u0101ti 3 kopij\u0101s uz fizisiki neatkar\u012Bg\u0101m iek\u0101rt\u0101m).'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Aizsardz\u012Bba pret nesankcion\u0113tu piek\u013Cuvi'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un virtualiz\u0101cijas infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		)
	)
);

var serverless__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC20'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var serverless__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'10% atlaide maks\u0101jot par 12 m\u0113ne\u0161iem'
	)
);

var serverless__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var serverless_aService = function (_Component) {
	serverless__inherits(aService, _Component);

	function aService() {
		serverless__classCallCheck(this, aService);

		return serverless__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			serverless__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				serverless__ref2,
				serverless__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=serverless&form=true', 'class': 'button' },
						serverless__ref4
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/sip.js


function sip__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sip__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sip__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var sip__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'Publiskais telekomunik\u0101ciju t\u012Bkla numurs, kas tiek pie\u0161\u0137irts klientam, izmantojot SIP p\u0101rraides protokolu.'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja izmantot numuru jebkur\u0101 viet\u0101, kur pieejams interneta piesl\u0113gums'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja veikt un sa\u0146emt zvanus, izmantojot IP telefonu, datoru vai mobilo aplik\u0101ciju'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Iesp\u0113ja \u0113rti p\u0101rskat\u012Bt zvanu atskaites'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'T\u0101lru\u0146a numurs, kuru viegli atcer\u0113ties - patreiz v\u0113l pieejami numuri no DolphNet numuru diapazona - +371 69999 XXX'
		)
	)
);

var sip__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC5'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var sip__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Sl\u0113dzot l\u012Bgumu uz 12 m\u0113ne\u0161iem d\u0101van\u0101 IP telefona apar\u0101ts.'
	)
);

var sip__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var sip__ref5 = Object(preact_min["h"])('div', { 'class': 'clearfix' });

var sip__ref6 = Object(preact_min["h"])(
	'h2',
	null,
	'Sarunu tarifi'
);

var sip_aService = function (_Component) {
	sip__inherits(aService, _Component);

	function aService() {
		sip__classCallCheck(this, aService);

		return sip__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			sip__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				sip__ref2,
				sip__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=sip&form=true', 'class': 'button' },
						sip__ref4
					)
				)
			),
			sip__ref5,
			Object(preact_min["h"])(
				'article',
				null,
				sip__ref6,
				Object(preact_min["h"])(asyncComponent["a" /* default */], { getComponent: function getComponent() {
						return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "khGl"));
					} })
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/fax.js


function fax__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function fax__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function fax__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var fax__ref = Object(preact_min["h"])(
	'article',
	{ 'class': 'has-widget' },
	Object(preact_min["h"])(
		'p',
		null,
		'DolphinHost\u2122 m\u0101ko\u0146skait\u013Co\u0161anas datu centr\u0101 izvietots faksa numurs, kas nodro\u0161ina faksa pakalpojumus, izmantojot interneta p\u0101rl\u016Bku vai p\u0101rs\u016Btot sa\u0146emtos faksus uz e-pastu.'
	),
	Object(preact_min["h"])(
		'h2',
		null,
		'Priek\u0161roc\u012Bbas'
	),
	Object(preact_min["h"])(
		'ul',
		null,
		Object(preact_min["h"])(
			'li',
			null,
			'Nav nepiecie\u0161ams izdruk\u0101t dokumentus, lai tos nos\u016Bt\u012Btu pa faksu'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'\u0112rta faksu nos\u016Bt\u012B\u0161ana un piek\u013Cuve sa\u0146emtajiem faksiem no jebkuras vietas, izmantojot datoru vai mobilo t\u0101lruni'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Datu centra un faksu uzglab\u0101\u0161anas infrastrukt\u016Bras atbilst\u012Bba GDPR datu aizsardz\u012Bbas regulai'
		),
		Object(preact_min["h"])(
			'li',
			null,
			'Izdev\u012Bgi tarifi faksu nos\u016Bt\u012B\u0161anai uz \u0101rzem\u0113m (\u012Bpa\u0161i uz valst\u012Bm, kur fakss v\u0113ljoproj\u0101m tiek akt\u012Bvi izmantots)'
		)
	),
	Object(preact_min["h"])('p', null)
);

var fax__ref2 = Object(preact_min["h"])(
	'h3',
	null,
	Object(preact_min["h"])(
		'span',
		{ 'class': 'from' },
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.from' })
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'value' },
		'\u20AC5'
	),
	Object(preact_min["h"])(
		'span',
		{ 'class': 'term' },
		' ',
		Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'cart.month.full' })
	)
);

var fax__ref3 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Bezmaksas ier\u012Bko\u0161ana'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'10% atlaide maks\u0101jot par 12 m\u0113ne\u0161iem'
	)
);

var fax__ref4 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var fax_aService = function (_Component) {
	fax__inherits(aService, _Component);

	function aService() {
		fax__classCallCheck(this, aService);

		return fax__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			fax__ref,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				fax__ref2,
				fax__ref3,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=fax&form=true', 'class': 'button' },
						fax__ref4
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/services/equipment.js


function equipment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function equipment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function equipment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var equipment__ref = Object(preact_min["h"])(
	'p',
	null,
	'Papildus DolphNet pakalpojumiem ir iesp\u0113jams ar\u012B ieg\u0101d\u0101ties da\u017E\u0101das telekomunik\u0101ciju iek\u0101rtas par izdev\u012Bg\u0101m cen\u0101m.'
);

var equipment__ref2 = Object(preact_min["h"])(
	'h2',
	null,
	'Pieejam\u0101s iek\u0101rtas'
);

var equipment__ref3 = Object(preact_min["h"])(
	'ul',
	null,
	Object(preact_min["h"])(
		'li',
		null,
		'Grandstream IP telefoni'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Bezvadu r\u016Bteri'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'T\u012Bkla komutatori (Ubiquiti, Edge-core, Netgear)'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Mar\u0161rut\u0113t\u0101ji (Mikrotik, Ubiquiti u.c)'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Serveri un datu mas\u012Bvi'
	)
);

var equipment__ref4 = Object(preact_min["h"])(
	'ul',
	{ 'class': 'bullet' },
	Object(preact_min["h"])(
		'li',
		null,
		'Visai tehnikai pirmo gadu bezmaksas tehniskais atbalsts'
	),
	Object(preact_min["h"])(
		'li',
		null,
		'Atkar\u012Bb\u0101 no iek\u0101rtas veida, pieejama bezmaksas uzst\u0101d\u012B\u0161ana'
	)
);

var equipment__ref5 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: 'email.widget.list.btn' });

var equipment_aService = function (_Component) {
	equipment__inherits(aService, _Component);

	function aService() {
		equipment__classCallCheck(this, aService);

		return equipment__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	aService.prototype.render = function render() {
		return Object(preact_min["h"])(
			serviceWrapper,
			this.props,
			Object(preact_min["h"])(
				'article',
				{ 'class': 'has-widget' },
				equipment__ref,
				equipment__ref2,
				equipment__ref3,
				Object(preact_min["h"])(
					'p',
					null,
					'Lai uzzin\u0101tu vair\u0101k par pieejamajamaj\u0101m iek\u0101rt\u0101m, ',
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=equipment&form=true' },
						'sazinieties ar mums'
					),
					'. '
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': 'widget plan' },
				equipment__ref4,
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						match["Link"],
						{ href: store["a" /* default */].prefix + '/contact?service=equipment&form=true', 'class': 'button' },
						equipment__ref5
					)
				)
			)
		);
	};

	return aService;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/content.js

		

		function content_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("hsmE") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var content = (async_default()(content_load));
	
// CONCATENATED MODULE: ./routes/contact.js

		

		function contact_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("nEvm") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var contact = (async_default()(contact_load));
	
// CONCATENATED MODULE: ./routes/availability.js

		

		function availability_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("Bvz7") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var availability = (async_default()(availability_load));
	
// CONCATENATED MODULE: ./routes/support.js

		

		function support_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("nDiS") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var support = (async_default()(support_load));
	
// CONCATENATED MODULE: ./components/header/servicesHeader.js
var servicesHeader__class;



function servicesHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function servicesHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function servicesHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var servicesHeader_ServicesHeader = Object(index_module["a" /* observer */])(servicesHeader__class = function (_Component) {
  servicesHeader__inherits(ServicesHeader, _Component);

  function ServicesHeader() {
    servicesHeader__classCallCheck(this, ServicesHeader);

    return servicesHeader__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ServicesHeader.prototype.componentDidMount = function componentDidMount() {
    if (this.props.header && this.props.header.particles) {
      this.addParticles();
    }
  };

  ServicesHeader.prototype.addParticles = function addParticles() {
    var _this2 = this;

    if (typeof window !== "undefined" && this.particlesRef) {
      __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "6u1l")).then(function (res) {
        _this2.pJS = new res(_this2.particlesRef, {});
      });
    }
  };

  ServicesHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.header != this.props.header) {
      this.addParticles();
    }
  };

  ServicesHeader.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.pJS && this.pJS.pJS) this.pJS.pJS.fn.vendors.destroypJS();
    this.pJS = null;
  };

  ServicesHeader.prototype.render = function render() {
    var _this3 = this;

    var profile = this.props.header && this.props.header.profile ? "profile-header " : "";
    var particles = this.props.header && this.props.header.particles ? "header_with_particles " : "";
    var img = this.props.header && this.props.header.img ? "header_with_img " : "";
    var extended = this.props.header && this.props.header.extended ? "extended " : "";
    var clipped = this.props.header && this.props.header.clipped ? this.props.header.clipped == 2 ? "custom_header_with_clippath2 " : "custom_header_with_clippath " : "";
    var result = profile + particles + img + extended;
    return this.props.header && Object(preact_min["h"])(
      'div',
      { id: 'page-header', 'class': '' + result, style: { backgroundImage: this.props.header ? 'url(/assets/img/page-header/' + this.props.header.img + ')' : null } },
      Object(preact_min["h"])(
        'div',
        { 'class': 'container wide' },
        this.props.header && this.props.header.particles && Object(preact_min["h"])('canvas', { style: 'width:100%;height:100%;position:absolute;top:0;left:0;', ref: function ref(el) {
            return _this3.particlesRef = el;
          } }),
        Object(preact_min["h"])(
          'h1',
          { key: store["a" /* default */].lang, 'class': clipped },
          Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: this.props.header ? this.props.header.title : "" }),
          ' ',
          Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: this.props.header && this.props.header.title2 ? this.props.header.title2 : "" })
        )
      )
    );
  };

  return ServicesHeader;
}(preact_min["Component"])) || servicesHeader__class;

/* harmony default export */ var servicesHeader = (servicesHeader_ServicesHeader);
// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/app.js
var app__class;



function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







//LANG






// import Showcase from './showcase'

// Code-splitting is automated for routes






















// TODO - add api
// import Profile from '../routes/profile';






var locales = {
  lv: lv_default.a,
  ru: ru_default.a,
  en: en_default.a
};

var app__ref = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: "header.cookies.text" });

var app__ref2 = Object(preact_min["h"])(preact_i18n_esm["c" /* Text */], { id: "header.cookies.link" });

var app__ref3 = Object(preact_min["h"])(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", "class": "icon" },
  Object(preact_min["h"])("use", { xlinkhref: "/assets/img/icons.svg#close" })
);

/* harmony default export */ var app = (Object(index_module["a" /* observer */])(app__class = function (_Component) {
  app__inherits(App, _Component);

  App.prototype.componentDidMount = function componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", this.handleScroll);

      store["a" /* default */].loadGA();
    }
    var el = this.headerRef;
    if (el && el.offsetTop !== undefined && !this.headerOffset) {
      this.headerOffset = el.offsetTop + 250; //OLD VALUE = 30
    }
  };
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */


  App.prototype.componentWillUnmount = function componentWillUnmount() {
    if (typeof window !== "undefined") window.removeEventListener("scroll", this.handleScroll);
  };

  function App() {
    app__classCallCheck(this, App);

    var _this = app__possibleConstructorReturn(this, _Component.call(this));

    _this.state = { loading: false };
    _this.headerSettings = {
      "/:lang/": undefined,
      "/:lang/internet": { title: "plans.title", particles: true, clipped: true },
      "/:lang/startups": { title: "startups.title", particles: true, clipped: 2 },
      "/:lang/support": { title: "support.title", img: "009.jpg" },
      "/:lang/email": { title: "email.title", img: "005.jpg" },
      "/:lang/faq": { title: "faq.title", img: "002.jpg" },
      "/:lang/:section": undefined,
      "/:lang/contact": { title: "contacts.title", img: "008.jpg" },
      "/:lang/availability": {
        extended: true,
        title: "availability.title",
        img: "007.jpg"
      },
      "/:lang/profile/": {
        title: "header.links.cabinet",
        particles: true,
        profile: true
      },
      "/:lang/terms": { title: "termsofuse", img: "010.jpg" },
      "/:lang/privacy": { title: "footer.menu.site.item5", img: "010.jpg" },
      "/:lang/company": { title: "footer.menu.about", img: "006.jpg" },
      "/:lang/notfound": { title: "notfound", img: "010.jpg" },

      "/:lang/services": { title: "services.title", img: "001.jpg" },
      "/:lang/telephone": { title: "phone.title", img: "010.jpg" },
      "/:lang/hosting": {
        title: "services.services.item3.title",
        img: "010.jpg"
      },
      "/:lang/pbx": { title: "services.services.item4.title", img: "010.jpg" },
      "/:lang/surveillance": {
        title: "services.services.item5.title",
        img: "010.jpg"
      },
      "/:lang/isdn": {
        title: "services.services.item6.title",
        title2: "services.services.item6.title2",
        img: "010.jpg"
      },
      "/:lang/files": {
        title: "services.services.item7.title",
        title2: "services.services.item7.title2",
        img: "010.jpg"
      },
      "/:lang/serverless-office": {
        title: "services.services.item8.title",
        title2: "services.services.item8.title2",
        img: "010.jpg"
      },
      "/:lang/sip": { title: "services.services.item9.title", img: "010.jpg" },
      "/:lang/fax": { title: "services.services.item10.title", img: "010.jpg" },
      "/:lang/equipment": {
        title: "services.services.item11.title",
        title2: "services.services.item11.title2",
        img: "009.jpg"
      }
    };

    _this.handleRoute = function (e) {
      if (e.current.attributes.path.indexOf("/:lang") == 0) {
        store["a" /* default */].setRedirect(e.current.attributes.path.split("/:lang")[1]);
      }
      if (e.url != _this.prevPath) {
        if (e.current && e.current.attributes && e.current.attributes.path) {
          if (typeof window !== "undefined" && window.ga && typeof window.ga == "function") {
            var pageTitle = "DolphNet";
            if (_this.headerSettings[e.current.attributes.path]) pageTitle = _this.headerSettings[e.current.attributes.path].title;
            // console.log(e);
            ga("send", { hitType: "pageview", page: e.url, title: pageTitle });
          }
          // Dont show loader or scroll to top when navigation is within the same component
          if (_this.prevComponent != e.current.attributes.path) {
            _this.prevComponent = e.current.attributes.path;
            _this.setState({ loading: true });
            if (_this.headerSettings[e.current.attributes.path]) {
              // console.log('setup header',this.headerSettings[e.current.attributes.path]);
              _this.setState({
                headerInfo: _this.headerSettings[e.current.attributes.path]
              });
            } else {
              _this.setState({ headerInfo: undefined });
            }

            if (typeof window !== "undefined") window.scrollTo(0, 0);
          }
        }
        Object(mobx_module["h" /* runInAction */])(function () {
          _this.prevPath = e.url;
          store["a" /* default */].hideMenu = e.url.includes("/profile");
          e.url == "/" || e && e.current && e.current.attributes && !store["a" /* default */].langs.includes(e.current.attributes.lang) ? Object(preact_router_es["route"])("/lv/") : null;
          if (e.current && e.current.attributes && e.current.attributes.matches.lang) {
            var thisLang = e.current.attributes.matches.lang;
            if (store["a" /* default */].lang != thisLang) {
              _this.setState({ loading: false });
              store["a" /* default */].setLang(thisLang);
              setTimeout(function () {
                return _this.forceUpdate();
              });
            }
          }
          store["a" /* default */].activePage = e.url.substring(3);
          store["a" /* default */].toggleMenu(true);
        });
      }
    };

    _this.handleScroll = function () {
      if (typeof window !== "undefined") store["a" /* default */].setSticky(window.matchMedia("(min-width: 992px)").matches && window.pageYOffset > _this.headerOffset);
    };

    _this.loading = function (e) {
      setTimeout(function () {
        return _this.setState({ loading: false });
      });
    };

    return _this;
  }

  App.prototype.render = function render(props, state) {
    var _this2 = this;

    var prefix = "/" + store["a" /* default */].lang;
    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        preact_i18n_esm["a" /* IntlProvider */],
        { definition: locales[store["a" /* default */].lang] },
        Object(preact_min["h"])(
          "div",
          null,
          !store["a" /* default */].cookiebarDismissed && Object(preact_min["h"])(
            "div",
            { id: "privacy-policy-note" },
            Object(preact_min["h"])(
              "div",
              { "class": "container wide" },
              Object(preact_min["h"])(
                "p",
                null,
                app__ref,
                "\xA0",
                Object(preact_min["h"])(
                  preact_router_es["Link"],
                  { href: prefix + "/privacy" },
                  app__ref2
                ),
                "."
              ),
              Object(preact_min["h"])(
                "a",
                { "class": "close", onClick: function onClick() {
                    return store["a" /* default */].dismissCookiebar();
                  } },
                app__ref3
              )
            )
          ),
          Object(preact_min["h"])(header, { mainRef: function mainRef(el) {
              return _this2.headerRef = el;
            } }),
          Object(preact_min["h"])(servicesHeader, { header: this.state.headerInfo }),
          Object(preact_min["h"])(
            "div",
            {
              style: (state.loading ? "min-height:100vh;" : "") + "position:relative;"
            },
            Object(preact_min["h"])("div", {
              "class": "preloader-small" + (state.loading ? " loading" : "")
            }),
            Object(preact_min["h"])(
              preact_router_es["Router"],
              { onChange: this.handleRoute },
              Object(preact_min["h"])(home, { "default": true, path: "/:lang/", loading: this.loading }),
              Object(preact_min["h"])(internet, { path: "/:lang/internet", loading: this.loading }),
              Object(preact_min["h"])(startups, { path: "/:lang/startups", loading: this.loading }),
              Object(preact_min["h"])(support, { path: "/:lang/support", loading: this.loading }),
              Object(preact_min["h"])(services, { path: "/:lang/services", loading: this.loading }),
              Object(preact_min["h"])(phone_aService, { path: "/:lang/telephone", loading: this.loading }),
              Object(preact_min["h"])(email_aService, { path: "/:lang/email", loading: this.loading }),
              Object(preact_min["h"])(hosting_aService, { path: "/:lang/hosting", loading: this.loading }),
              Object(preact_min["h"])(pbx_aService, { path: "/:lang/pbx", loading: this.loading }),
              Object(preact_min["h"])(surveillance_aService, {
                path: "/:lang/surveillance",
                loading: this.loading
              }),
              Object(preact_min["h"])(isdn_aService, { path: "/:lang/isdn", loading: this.loading }),
              Object(preact_min["h"])(files_aService, { path: "/:lang/files", loading: this.loading }),
              Object(preact_min["h"])(serverless_aService, {
                path: "/:lang/serverless-office",
                loading: this.loading
              }),
              Object(preact_min["h"])(sip_aService, { path: "/:lang/sip", loading: this.loading }),
              Object(preact_min["h"])(fax_aService, { path: "/:lang/fax", loading: this.loading }),
              Object(preact_min["h"])(equipment_aService, { path: "/:lang/equipment", loading: this.loading }),
              Object(preact_min["h"])(faq, { path: "/:lang/faq", loading: this.loading }),
              Object(preact_min["h"])(content, {
                path: "/:lang/terms",
                section: "terms",
                loading: this.loading
              }),
              Object(preact_min["h"])(content, {
                path: "/:lang/privacy",
                section: "privacy",
                loading: this.loading
              }),
              Object(preact_min["h"])(content, {
                path: "/:lang/company",
                section: "company",
                loading: this.loading
              }),
              Object(preact_min["h"])(content, {
                path: "/:lang/notfound",
                section: "notfound",
                loading: this.loading
              }),
              Object(preact_min["h"])(content, { path: "/:lang/:section", loading: this.loading }),
              Object(preact_min["h"])(contact, { path: "/:lang/contact", loading: this.loading }),
              Object(preact_min["h"])(availability, {
                path: "/:lang/availability",
                loading: this.loading
              })
            )
          ),
          Object(preact_min["h"])(asyncComponent["a" /* default */], { getComponent: function getComponent() {
              return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "OgI3"));
            } }),
          Object(preact_min["h"])(asyncComponent["a" /* default */], {
            getComponent: function getComponent() {
              return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "Ahgo"));
            },
            prefix: prefix
          }),
          Object(preact_min["h"])(asyncComponent["a" /* default */], { getComponent: function getComponent() {
              return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "XkE4"));
            } }),
          Object(preact_min["h"])(asyncComponent["a" /* default */], { getComponent: function getComponent() {
              return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "rix2"));
            } })
        )
      )
    );
  };

  return App;
}(preact_min["Component"])) || app__class);
// CONCATENATED MODULE: ./index.js
// import './style';




/* harmony default export */ var index = __webpack_exports__["default"] = (app);

// export default class Index extends Component {
// 	state = {
// 		loaded:false
// 	}
// 	async componentDidMount() {
// 		if (!this.App) {
// 			let app = await import('./components/app');
// 			this.App = app.default;
// 			this.setState({loaded:true});
// 		}
// 	}
// 	render() {
// 		return this.state.loaded ? h(this.App) : <div id="preloader"/>
// 	}
// }

/***/ }),

/***/ "K8wh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),

/***/ "K9uV":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bViC"),
    root = __webpack_require__("MIhM");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KxjL":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "LIpy":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),

/***/ "LNnS":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("Wyka");
var toLength = __webpack_require__("S7IM");
var toAbsoluteIndex = __webpack_require__("Zwq5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "Lli7":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("Ug9I")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),

/***/ "MIhM":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("j3D9");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),

/***/ "Mgpy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),

/***/ "MpYs":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "N484":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__("3zRh");
var $export = __webpack_require__("vSO4");
var toObject = __webpack_require__("mbLO");
var call = __webpack_require__("hEIm");
var isArrayIter = __webpack_require__("af0K");
var toLength = __webpack_require__("S7IM");
var createProperty = __webpack_require__("vUQk");
var getIterFn = __webpack_require__("7AqT");

$export($export.S + $export.F * !__webpack_require__("Lli7")(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),

/***/ "NB7d":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("zKeE");
var global = __webpack_require__("i1Q6");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("1kq3") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "Nk5W":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),

/***/ "O35A":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("i+u+");
__webpack_require__("N484");
module.exports = __webpack_require__("zKeE").Array.from;

/***/ }),

/***/ "Ocr3":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "OuyB":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "Q5Lm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),

/***/ "R6c1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("6MLN") && !__webpack_require__("wLcK")(function () {
  return Object.defineProperty(__webpack_require__("9kxq")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "RQ0L":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("bgO7");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = toKey;

/***/ }),

/***/ "RnNb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _util = __webpack_require__("868B");

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__("1+RE");

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$", 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),

/***/ "RsE0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


Object.defineProperty(exports, "__esModule", { value: !0 });
var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.fundamental") : 60117,
    w = b ? Symbol.for("react.responder") : 60118,
    x = b ? Symbol.for("react.scope") : 60119;function y(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;switch (u) {case c:
        switch (a = a.type, a) {case l:case m:case e:case g:case f:case p:
            return a;default:
            switch (a = a && a.$$typeof, a) {case k:case n:case t:case r:case h:
                return a;default:
                return u;}}case d:
        return u;}
  }
}function z(a) {
  return y(a) === m;
}
exports.typeOf = y;exports.AsyncMode = l;exports.ConcurrentMode = m;exports.ContextConsumer = k;exports.ContextProvider = h;exports.Element = c;exports.ForwardRef = n;exports.Fragment = e;exports.Lazy = t;exports.Memo = r;exports.Portal = d;exports.Profiler = g;exports.StrictMode = f;exports.Suspense = p;
exports.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w || a.$$typeof === x);
};exports.isAsyncMode = function (a) {
  return z(a) || y(a) === l;
};exports.isConcurrentMode = z;exports.isContextConsumer = function (a) {
  return y(a) === k;
};exports.isContextProvider = function (a) {
  return y(a) === h;
};
exports.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};exports.isForwardRef = function (a) {
  return y(a) === n;
};exports.isFragment = function (a) {
  return y(a) === e;
};exports.isLazy = function (a) {
  return y(a) === t;
};exports.isMemo = function (a) {
  return y(a) === r;
};exports.isPortal = function (a) {
  return y(a) === d;
};exports.isProfiler = function (a) {
  return y(a) === g;
};exports.isStrictMode = function (a) {
  return y(a) === f;
};exports.isSuspense = function (a) {
  return y(a) === p;
};

/***/ }),

/***/ "S7IM":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("MpYs");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "ShN9":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "SsUF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),

/***/ "T4f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("gc0D");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "TNJq":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("zotD");
var dPs = __webpack_require__("gjjs");
var enumBugKeys = __webpack_require__("KxjL");
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("9kxq")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("ebIA").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),

/***/ "Tnr5":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("p/0c"),
    isKey = __webpack_require__("2ibm"),
    stringToPath = __webpack_require__("jXGU"),
    toString = __webpack_require__("A8RV");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

/***/ }),

/***/ "U72i":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "UY82":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("ZC1a");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),

/***/ "Ug9I":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("NB7d")('wks');
var uid = __webpack_require__("X6va");
var Symbol = __webpack_require__("i1Q6").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "VHgz":
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__("mV+j");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/***/ }),

/***/ "VuZO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("O35A"), __esModule: true };

/***/ }),

/***/ "WmEJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("868B");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),

/***/ "Wyka":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("E5Ce");
var defined = __webpack_require__("U72i");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "X6va":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "XJYD":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),

/***/ "XOCG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "Xk23":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("s9iF"),
    listCacheDelete = __webpack_require__("+bWy"),
    listCacheGet = __webpack_require__("Ewuv"),
    listCacheHas = __webpack_require__("xDQX"),
    listCacheSet = __webpack_require__("h0zV");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),

/***/ "Xos8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "YD0x":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("vSO4");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("uj5A") });

/***/ }),

/***/ "YIaf":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("FTXF");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),

/***/ "Z8rO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("868B");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),

/***/ "ZC1a":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("XJYD");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),

/***/ "ZHvQ":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("ShN9");
var TAG = __webpack_require__("Ug9I")('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ "ZShz":
/***/ (function(module, exports, __webpack_require__) {

!function (n, t) {
   true ? t(exports, __webpack_require__("KM04")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";
  var _i = function i(n, t) {
    return (_i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  };function r(n, t) {
    function r() {
      this.constructor = n;
    }_i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }var e = { register: function register(n) {
      console.warn("Consumer used without a Provider");
    }, unregister: function unregister(n) {}, val: function val(n) {} };function u(n) {
    var t = n.children;return { child: 1 === t.length ? t[0] : null, children: t };
  }function o(n) {
    return u(n).child || "render" in n && n.render;
  }var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;function a(n, i) {
    var a = "_preactContextProvider-" + s++;return { Provider: function (n) {
        function e(t) {
          var r = n.call(this, t) || this;return r.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };return { register: function register(n) {
                i.push(n), n(r, e(r));
              }, unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              }, val: function val(n) {
                if (void 0 === n || n == r) return r;var t = e(n);return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              } };
          }(t.value, i || f), r;
        }return r(e, n), e.prototype.getChildContext = function () {
          var n;return (n = {})[a] = this.t, n;
        }, e.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, e.prototype.render = function () {
          var n = u(this.props),
              i = n.child,
              r = n.children;return i || t.h("span", null, r);
        }, e;
      }(t.Component), Consumer: function (t) {
        function i(i, r) {
          var e = t.call(this, i, r) || this;return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;0 != ((r |= 0) & t) && e.setState({ value: n });
          }, e.state = { value: e.u().val() || n }, e;
        }return r(i, t), i.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, i.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, i.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, i.prototype.componentDidUpdate = function (n, t, i) {
          var r = i[a];r !== this.context[a] && ((r || e).unregister(this.i), this.componentDidMount());
        }, i.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, i.prototype.u = function () {
          return this.context[a] || e;
        }, i;
      }(t.Component) };
  }var h = a;n.default = a, n.createContext = h, Object.defineProperty(n, "__esModule", { value: !0 });
});

/***/ }),

/***/ "Zwq5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("MpYs");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "af0K":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("dhak");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ "akPY":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("Gfzd");
var createDesc = __webpack_require__("0WCH");
module.exports = __webpack_require__("6MLN") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "avXi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("868B");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),

/***/ "b6bE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),

/***/ "b7H7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),

/***/ "b7Q2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__("TNJq");
var descriptor = __webpack_require__("0WCH");
var setToStringTag = __webpack_require__("11Ut");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("akPY")(IteratorPrototype, __webpack_require__("Ug9I")('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),

/***/ "bViC":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("iEGD"),
    getValue = __webpack_require__("Nk5W");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),

/***/ "bgO7":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("e5TX"),
    isObjectLike = __webpack_require__("OuyB");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),

/***/ "cDyG":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("ZC1a");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),

/***/ "d05+":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("kAdy");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),

/***/ "dACh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "dRuq":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("e5TX"),
    isObject = __webpack_require__("u9vI");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),

/***/ "dUvY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("868B");

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),

/***/ "dhak":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "e5TX":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("wppe"),
    getRawTag = __webpack_require__("uiOY"),
    objectToString = __webpack_require__("lPmd");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1_preact__, "createRef")) __webpack_require__.d(__webpack_exports__, "createRef", function() { return __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context__ = __webpack_require__("ZShz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_context__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2_preact_context__, "createContext")) __webpack_require__.d(__webpack_exports__, "createContext", function() { return __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"]; });







var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	hydrate: render$1,
	createClass: createClass,
	createContext: __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"],
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	createRef: __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"],
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "ebIA":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("i1Q6").document;
module.exports = document && document.documentElement;

/***/ }),

/***/ "fR9K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _util = __webpack_require__("868B");

var _validator = __webpack_require__("w1My");

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__("Mgpy");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),

/***/ "g31e":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "g55O":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),

/***/ "gc0D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("vcHl"), __esModule: true };

/***/ }),

/***/ "gjjs":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("Gfzd");
var anObject = __webpack_require__("zotD");
var getKeys = __webpack_require__("knrM");

module.exports = __webpack_require__("6MLN") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),

/***/ "gojl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("akPY");

/***/ }),

/***/ "h0zV":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("yEjJ");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "hClK":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("FTXF");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),

/***/ "hEIm":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("zotD");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ "hgI7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),

/***/ "htFH":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("vSO4");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("6MLN"), 'Object', { defineProperty: __webpack_require__("Gfzd").f });

/***/ }),

/***/ "i+u+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__("lytE")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("uRfg")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),

/***/ "i1Q6":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "i7ze":
/***/ (function(module, exports) {

module.exports = {"avail":{"city":{"btn":"Выбрать","item":"Тип","item2":"Бизнес центр","item3":"Индустриальный парк","item4":"супермаркет"},"note":{"link":"Свяжитесь с нами","link2":"введя свой адрес","text":"Если вы не нашли свой объект на карте -","text2":"или проверьте наличие,"},"option":"город","title":"Наличие интернета DolphNet ™"},"availability":{"config":{"item":{"title":"интернет"},"item2":{"title":"Телефон"},"item3":{"title":"Почтовые ящики"},"options":{"item":"Долгий технический сервис 4","item2":"Долгий технический сервис 5","item3":"Долгий технический сервис 6","item4":{"link":"\"PROMO-1\"","title":"По этому адресу доступно  предложение для молодых предпринимателей и стартапов."}}},"desc":"Пожалуйста, выберите услуги, к которым вы хотите подключиться по этому адресу","form":{"btn":"Выбрать","placeholder":"Пожалуйста, введите адрес, чтобы проверить наличие","placeholderSmall":"Пожалуйста, введите адрес"},"subTitle":"Доступные услуги","title":"Проверьте наличие DolphNet™"},"cart":{"from":"от","year":{"full":"в год"},"month":{"cut":"месяца","full":"в месяц"},"months":{"cut":"месяца","full":"месяца"}},"contactForm":{"adres":"Пожалуйста, введите адрес, по которому вы хотите сообщить о проблеме или повреждении","checkbox":{"link":"Политике конфиденциальности","text":"Я согласен на обработку моих персональных данных согласно "},"error":"Ошибка при отправке вопроса! Повторите попытку позже или позвоните в службу поддержки DolphNet 24/7","errorLink":"немедленно!","form":{"apply":{"captionText":"Подать заявку на услуги по выбранному адресу","contentText":"Заявка на услуги","descriptionText":"","sentText":"Наши менеджеры свяжутся с вами в течение одного рабочего дня.","submitText":"Сообщить о проблеме"},"standart":{"captionText":"Связаться или задать вопрос","contentText":"Вопрос или комментарий","descriptionText":"Отправьте нам вопрос, и наши менеджеры свяжутся с вами в течение одного рабочего дня!","sentText":"Наши менеджеры свяжутся с вами в течение одного рабочего дня.","submitText":"Отправить заявку"},"support":{"captionText":"Сообщить о технической проблеме или сбое","contentText":"Пожалуйста опишите суть проблемы","descriptionText":"","sentText":"Наши технические специалисты свяжутся с вами в течение часа.","submitText":"Сообщить о проблеме"}},"mail":"Электронная почта","name":"Ваше имя","phone":"Телефон","policy":"Вы должны согласиться с политикой конфиденциальности, чтобы отправить вопрос!","title":"Ваша заявка отправлена!"},"calcForm":{"header":"Узнайте, переплачиваете ли вы за бизнес-интернет!","currentPriceSubtitle":"Сколько вы ежемесячно платите за интернет?","currentSpeedSubtitle":"Какая у вас скорость интернета?","specifyOther":"Указать","buttons":{"calculate":"Рассчитать","submit":"Запросить звонок"},"nowPrice":"На данный момент <strong>{{speed}} Мбит</strong> стоит вам <strong>&euro;{{price}}</strong>.","ourPrice":"Стоимость <strong>{{speed}} Мбит</strong> у DolphNet - <strong>&euro;{{price}}</strong>!","phone":"Оставьте свой нр. телефона","percentText":"Вы можете иметь интернет на <strong>{{percent}}%</strong> дешевле","promoText":"С DolphNet вы можете иметь мега-быстрый интернет с гораздо лучшим предложением!","promoTextExtended":"Похоже, у вас уже есть отличное интернет-предложение.<br />Хотели бы вы иметь еще больше скорость?","suggested":"Рекомендуемый пакет","offerText":"<strong>{{speed}} Mbit</strong> интернет за <strong>&euro;{{price}} / месяц</strong>","sent":"Спасибо! Ваш запрос был успешно отправлен."},"contacts":{"title":"Свяжитесь с нами"},"email":{"body":{"desc":"","list":{"item":"","item2":"","item3":{"link":"","text":""},"label":"Детали компании"},"text":"","title":""},"title":"Email хостинг","widget":{"list":{"btn":"Подписаться","item":"","item2":""},"price":"5"}},"faq":{"title":"Часто задаваемые вопросы"},"footer":{"copy":"2019 Copyright © DolphNet ™ Интернет. Все права защищены.","menu":{"about":"О нас","adres":"Офис","adresText":"Улица Krišjāņa Barona 20, Рига","desc":"DolphNet™ - современные услуги связи для бизнеса и профессионалов.","link":"Отправить сообщение","map":"Показать на карте","services":{"item":"Интернет","item2":"Телефон","item3":"E-mail хостинг","item4":"Хостинг сайтов","item5":"Все услуги","label":"Услуги"},"site":{"item":"Проверить наличие","item2":"Личный кабинет","item3":"Служба поддержки","item4":"Часто задаваемые вопросы","item5":"Конфиденциальность","label":"Ссылки"},"support":"Поддержка"},"note":"Маркетинг и дизайн:","noteLink":"AL&C"},"header":{"cookies":{"link":"политикой конфиденциальности","text":"Этот сайт использует куки (Cookies). Продолжая просматривать сайт, вы соглашаетесь с нашей "},"links":{"availability":"Подать заявку на подключение","biznes":{"text":"Для бизнеса и","text2":"профессионалов"},"cabinet":"Личный кабинет"},"menu":{"item":"интернет","item2":"Телефон","item3":"Другие услуги","item4":"Поддержка"}},"home":{"advantage":{"item":{"text":"Выгодный и быстрый","text2":"оптический интернет","text3":"до","text4":"1 Гбит/с"},"item2":{"text":"Соответствует требованиям","text2":"самых требовательных","text3":"пользователей и технологических компаний"},"item3":{"text":"Доступно в основных","text2":"бизнес-центрах Латвии","text3":"и не только"}},"btn":"Смотреть все","cards":{"btn":"Показать больше","item":{"title":"Телефонная","title2":"линия"},"item2":{"title":"Email хостинг"},"item3":{"title":"Хостинг сайтов"},"item4":{"title":"Виртуальная АТС"},"item5":{"title":"Сервер видеонаблюдения"},"item6":{"title":"Линия","title2":"ISDN2"}},"desc":"Помимо интернет-сервиса, мы также предоставляем телефонную линию, хранилище электронной почты и другие полезные услуги.","subTitle":"Услуги","subTitle2":""},"iconBar":"ДО","locSlider":{"link":"Подключиться","text":"Доступен высокоскоростной интернет DolphNet™"},"loginForm":{"error":"Неправильная почта или пароль","cabinet":"кабинет","client":"Личный","login":"Войти ","reset":"Сбросить ","resetPass":"пароль","mail":"Эл-почта","pass":"Пароль"},"phone":{"article":{"desc":"","list":{"item":"","item2":"","item3":{"link":"","text":""}},"subTitle":"Детали компании","text":"","title":""},"title":"Телефонная линия для бизнеса","widget":{"from":"от","item":"","item2":"","link":"Задать вопрос","price":"7"}},"plans":{"title":"СКОРОСТНОЙ ИНТЕРНЕТ","desc":{"item":"Все интернет-услуги включают круглосуточную поддержку клиентов.","item2":"Если у вас есть какие-либо вопросы, свяжитесь с нами, или ","link":"проверьте доступность услуги."},"footer":{"text":{"bold":"40 Гбит.","item":"В дополнение к стандартным интернет-пакетам DolphNet предоставляет корпоративные сервисы: гарантированную пропускную способность интернет – каналов MPLS, от 20 Мбит до ","item2":" Чтобы обсудить индивидуальное решение, ","link":"свяжитесь с нами"},"title":"Не нашли то, что вам нужно? Закажите индивидуальное решение!","bezPVN":"* Все цены указаны без учета НДС. С существенными условиями договора можно ознакомиться","bezPVNextra":"здесь."},"header":{"advantage":{"item":{"text":"Без платы","text2":"за подключение"},"item2":{"text":"Современный и","text2":"быстрый "},"item3":{"text":"Подходит для самых требовательных","text2":"клиентов"}},"item":"Интернет","item2":"пакеты"},"items":{"btn":"Заказать","first":{"advantage":{"item":"Доступность 99,99%+","item1":"Гарантированная скорость 40Mbit","item2":"Бесплатная установка","item3":"Круглосуточная поддержка"},"noteMonth":"3","price":"29","title":"Скорость 1"},"note":"Минимальный срок","second":{"advantage":{"item":"Доступность 99,99%+","item1":"Гарантированная скорость 100Mbit","item2":"Бесплатная установка","item3":"Круглосуточная поддержка"},"noteMonth":"2","price":"39","title":"Скорость 2"},"third":{"advantage":{"item":"Доступность 99,99%+","item1":"Гарантированная скорость 160Mbit","item2":"Бесплатная установка","item3":"Круглосуточная поддержка"},"noteMonth":"2","price":"79","title":"Скорость 3"}}},"profile":{"actionLink":"Подключить дополнительные услуги","agree":{"item":"Я согласен с","item2":"политикой конфиденциальности","item3":"и","item4":"условиями использования"},"agree2":"Я согласен получать специальные предложения","client":{"adres":"Адрес","bank":"Банковский счет","city":"Город","country":"Страна","index":"Почтовый индекс","mail":"Электронная почта","mailNote":"ОТПРАВИТЬ ЗАПРОС НА E-MAIL","name":"Компания","nr":"Регистрационный номер","person":"Контактное лицо","phone":"Телефон","swift":"SWIFT код","title":"Информация о клиенте"},"note":"Изменение данных аутентификации требует ручного подтверждения по электронной почте, указанной при регистрации профиля.","payInfo":"Текущий счет","payOff":"Оплаченный","payOn":"Оплатить","subTitle":"Счета","title":"Услуги"},"reviews":{"first":{"company":"SIA «Advanced Learning & Communications»","name":"Дмитрий Красновский, директор","text":"Мы требовательны к качеству и скорости интернета, и интернет от DolphNet помогает нам работать быстро и без простоев. Мы довольны услугой и всем рекомендуем DolphNet!"},"second":{"company":"SOS BĒRNU CIEMATU ASOCIĀCIJA","name":"Райвис Рагис, IT координатор","text":"После перехода на интернет – подключение от DolphNet, мы смогли снизить ежемесячную стоимость оптического интернет-соединения, без потери качества."},"third":{"company":"MAGNET MEDIA","name":"Андрис Михельсон, председатель совета","text":"Интернету подключение от DolphNet, а также обслуживание электронной почты, повысили эффективность нашей ежедневной работы; также значительно улучшилась скорость и стабильность. Эти усовершенствования позволяют нам быстро и удобно обмениваться большими рабочими файлами с деловыми партнерами как в Латвии, так и за рубежом."}},"services":{"services":{"btn":"Узнать","item":{"title":"Телефонная","title2":"линия"},"item10":{"title":"Виртуальный факс"},"item11":{"title":"Телекоммуникационное","title2":"оборудование"},"item2":{"title":"Email хостинг"},"item3":{"title":"Хостинг сайтов"},"item4":{"title":"Виртуальная АТС"},"item5":{"title":"Сервер видеонаблюдения"},"item6":{"title":"Линия","title2":"ISDN2"},"item7":{"title":"Безопасный файловый","title2":"сервер"},"item8":{"title":"«Офис без ","title2":"сервера»"},"item9":{"title":"Номер SIP"}},"title":"Услуги"},"slider":{"first":{"button":"посмотреть особое предложение ","small_text":{"first":"Доступен в 87% ","second":"точках подключения "},"text_field":{"first":"Самый ","second":"быстрый ","third":"интернет "}},"second":{"button":"посмотреть особое предложение ","small_text":{"first":"Привлекательное предложение ","second":"для молодых предпринимателей. "},"text_field":{"first":"Новичкам ","second":"и ","third":"стартапам "}},"third":{"button":"посмотреть особое предложение ","small_text":{"first":"Переходи на DolphNet ","second":"и пользуйся хостингом ","third":"6 месяцев бесплатно "},"text_field":{"first":"облачный ","second":"хостинг ","third":"€0,- "}},"social":"Следуйте за нами"},"startups":{"body":{"link":{"item":"Проверить наличие","item2":"Популярные вопросы о подключении","item3":"Подать заявку на подключение к интернету"},"subTitle":"Условия акции","text":"Предложение открыто для компаний, работающих до 18 месяцев. Адресом подключения к Интернету может быть либо зарегистрированный офис компании, имеющей право на акцию, либо зарегистрированный филиал этой компании. Рекламное предложение доступно, если адрес имеет техническую возможность настроить Предложение открыто для компаний, работающих до 18 месяцев. Адресом подключения к Интернету может быть либо зарегистрированный офис компании, имеющей право на акцию, либо зарегистрированный филиал этой компании. Рекламное предложение доступно, если адрес имеет техническую возможность настроить услугу.","title":"Полезные ссылки"},"features":{"card":{"advantage":{"item":"99,99%+ доступности","item2":"Бесплатная установка","item3":"Круглосуточная поддержка"},"btn":"Воспользоваться этой возможностью.","month":"2","newPrice":"29","note":"Минимальный срок","oldPrice":"39","title":"«PROMO-1»"},"item":"Тарифный план действует в течение 18 месяцев после регистрации компании.","item2":"Современный, стабильный и быстрый","item3":"С гарантированной максимальной скоростью 500 Мбит / с"}},"support":{"article":{"adres":"Maskavas iela 146, Rīga","desc":"Обнаружены проблемы с подключением к интернету. В настоящее время решаются.","mail":"E-mail хостинг","note":"У некоторых клиентов возникли проблемы с электронной почтой. До 13:00 (GMT + 2) проблемы будут исправлены.","title":"Адреса и услуги с возможными перебоями связи"},"title":"Техническая поддержка"}}

/***/ }),

/***/ "iEGD":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("dRuq"),
    isMasked = __webpack_require__("1qpN"),
    isObject = __webpack_require__("u9vI"),
    toSource = __webpack_require__("g55O");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),

/***/ "itUc":
/***/ (function(module, exports) {

module.exports = {"avail":{"city":{"btn":"Atlasīt","item":"Veids","item2":"Biznesa centrs","item3":"Industriālais parks","item4":"Lielveikals"},"note":{"link":"sazinieties ar mums","link2":"ievadot savu adresi","text":"Ja neatradāt savu objektu uz kartes -","text2":"vai pārbaudiet pieejamību,"},"option":"Pilsēta","title":"DolphNet™ interneta pieejamība"},"availability":{"config":{"item":{"title":"Internets"},"item2":{"title":"Telefons"},"item3":{"title":"E-pasta kastītes"},"options":{"item":"Garais tehniskais pakalpojums 4","item2":"Garais tehniskais pakalpojums 5","item3":"Garais tehniskais pakalpojums 6","item4":{"link":"«PROMO-1»","title":"Šaja adresē pieejams akcijas piedāvājums internetam januniem uzņēmējiem un startapiem "}}},"desc":"Lūdzu izvēlieties pakalpojumus, kurus vēlāties pieslēgt šajā adresē","form":{"btn":"Atlasīt","placeholder":"Lūdzu ievadiet adresi, lai noskaidrotu pakalpojumu pieejamību","placeholderSmall":"Lūdzu ievadiet adresi"},"subTitle":"Pieejamie pakalpojumi","title":"Pārbaudīt DolphNet™ pieejamību"},"cart":{"from":"no","year":{"full":"gadā"},"month":{"cut":"mēn.","full":"mēnesī"},"months":{"cut":"mēn.","full":"mēneši"}},"contactForm":{"adres":"Lūdzu ievadiet adresi, kurā vēlāties pieteikt problēmu vai bojājumu","checkbox":{"link":"Konfidencialitātes politiku","text":"Piekrītu manu personas datu apstrādei saskaņā ar "},"error":"Nosūtot jautājumu notika kļūda! Lūdzu mēģiniet vēlreiz vēlāk, vai zvaniet uz DolphNet diennakts klientu apkalpošanas tālruni ","errorLink":"tūlīt!","form":{"apply":{"captionText":"Pieteikt pakalpojumus izvēlētajā adresē","contentText":"Pakalpojumu pieteikums","descriptionText":"","sentText":"Mūsu menedžeri sazināsies ar Jums vienas darba dienas laikā.","submitText":"Pieteikt bojājumu"},"standart":{"captionText":"Sazināties vai uzdot jautājumu","contentText":"Jautājums vai komentārs","descriptionText":"Nosūtiet mums jautājumu un mūsu menedžeri sazināsies ar Jums vienas darba dienas laikā!","sentText":"Mūsu menedžeri sazināsies ar Jums vienas darba dienas laikā.","submitText":"Nosūtīt pieteikumu"},"support":{"captionText":"Pieteikt tehnisku problēmu vai bojājumu","contentText":"Lūdzu aprakstiet problēmas būtību","descriptionText":"","sentText":"Mūsu tehniskie speciālisti sazināsies ar Jums vienas stundas laikā.","submitText":"Pieteikt bojājumu"}},"mail":"E-pasts","name":"Jūsu vārds, uzvārds","phone":"Tālrunis","policy":"Lai nosūtītu jautājumu, Jums jāpiekrīt konfidencialitātes politikas noteikumiem!","title":"Jūsu pieteikums ir nosūtīts!"},"calcForm":{"header":"Uzzini cik Tu pārmaksā par biznesa internetu!","currentPriceSubtitle":"Cik šobrīd tu maksā mēnesī par internetu?","currentSpeedSubtitle":"Kāds Tev ir interneta ātrums?","specifyOther":"Norādīt citu","buttons":{"calculate":"Aprēķināt","submit":"Pieteikt zvanu"},"nowPrice":"Šobrīd <strong>{{speed}} Mbit</strong> ātrums izmaksā Tev <strong>&euro;{{price}}</strong>.","ourPrice":"<strong>{{speed}} Mbit</strong> ātruma izmaksas DolphNet tiklā - <strong>&euro;{{price}}</strong>!","phone":"Atstājiet Jūsu telefona numuru","percentText":"Tu vari lietot par <strong>{{percent}}%</strong> izdevīgāku pieslēgumu","promoText":"Ar DolphNet Tu vari lietot mega ātru biznesa internetu daudz izdevīgāk!","promoTextExtended":"Izskatās, ka Tev jau ir lielisks interneta pieslegums.<br />Vēlies vēl lielāku ātrumu?","suggested":"Ieteicamais pieslēgums","offerText":"<strong>{{speed}} Mbit</strong> internets par <strong>&euro;{{price}} / mēn.</strong>","sent":"Paldies! Jūsu pieprasījums tika veiksmīgi nosūtīts."},"contacts":{"title":"Sazināties ar mums"},"email":{"body":{"desc":"","list":{"item":"","item2":"","item3":{"link":"","text":""},"label":"Rekvizīti"},"text":"","title":""},"title":"E-pastu uzturēšana","widget":{"list":{"btn":"Pieteikties","item":"","item2":""},"price":"5"}},"faq":{"title":"Biežāk uzdotie jautājumi"},"footer":{"copy":"2019 Copyright © DolphNet™ Internet. Visas tiesības aizsargātas.","menu":{"about":"Par mums","adres":"Birojs","adresText":"Krišjāņa Barona iela 20, Rīga","desc":"DolphNet™ ir mūsdienīgs sakaru pakalpojumu sniedzējs biznesam un profesionāļiem.","link":"Nosūtīt ziņu","map":"Parādīt uz kartes","services":{"item":"Internets","item2":"Telefons","item3":"E-pastu hostings","item4":"Mājas lapu hostings","item5":"Visi pakalpojumi","label":"Pakalpojumi"},"site":{"item":"Pārbaudīt pieejamību","item2":"Mans DolphNet","item3":"Atbalsta dienests","item4":"Biežāk uzdotie jautājumi","item5":"Privātuma politika","label":"Saites"},"support":"Atbalsts"},"note":"Mārketings un dizains: ","noteLink":"AL&C"},"header":{"cookies":{"link":"privātuma politikai","text":"Mēs izmantojam sīkdatnes. Turpinot izmantot šo lapu jūs piekrītat mūsu"},"links":{"availability":"Pieteikt pieslēgumu","biznes":{"text":"Biznesam un","text2":"profesionāļiem"},"cabinet":"Mans DolphNet"},"menu":{"item":"Ātrgaitas internets","item2":"Telefons","item3":"Citi pakalpojumi","item4":"Atbalsts"}},"home":{"advantage":{"item":{"text":"Izdevīgs un ātrs","text2":"optiskais internets","text3":"līdz","text4":"1 Gbit/s"},"item2":{"text":"Atbilst prasīgāko","text2":"lietotāju un tehnoloģisko","text3":"kompāniju vēlmēm"},"item3":{"text":"Pieejams lielākajos","text2":"latvijas biznesa centros","text3":"un ne tikai"}},"btn":"Skatīt visus","cards":{"btn":"Vairāk","item":{"title":"Tālruņa","title2":"līnija"},"item2":{"title":"E-pastu uzturēšana"},"item3":{"title":"Mājas lapu hostings"},"item4":{"title":"Virtuālā telefona centrāle"},"item5":{"title":"Videonovērošanas serveris"},"item6":{"title":"ISDN2","title2":"līnija"}},"desc":"Papildus interneta pakalpojumam nodrošinām arī tālruņa līniju, e-pastu glabāšanu un citus noderīgus pakalpojumus.","subTitle":"Pakalpojumi","subTitle2":""},"iconBar":"LĪDZ","locSlider":{"link":"Pieslēgties","text":"Pieejams ātrgaitas Internets DolphNet™"},"loginForm":{"error":"Nepareizs e-pasts vai parole!","cabinet":"DolphNet","client":"Mans","login":"Ienākt","reset":"Atgādināt","resetPass":"paroli","mail":"E-pasts","pass":"Parole"},"phone":{"article":{"desc":"","list":{"item":"","item2":"","item3":{"link":"","text":""}},"subTitle":"Rekvizīti","text":"","title":""},"title":"Biznesa tālruņa līnija","widget":{"from":"no","item":"","item2":"","link":"","price":"7"}},"plans":{"title":"ĀTRGAITAS INTERNETS","desc":{"item":"Visi interneta pieslēgumi iekļauj 24/7 klientu atbalsta dienestu.","item2":"Ja Jums ir jautājumi, sazinieties ar mums, lai","link":"pārbaudītu pieejamību"},"footer":{"text":{"bold":"40 Gbit","item":"Papildus standarta interneta pakām, DolphNet nodrošina arī individuāli pielāgotu interneta pakalpojumu. Uzņēmumiem pieejami dažādi interneta pieslēguma un izdalīto datu kanālu ātrumi, sākot no 20Mbit līdz pat ","item2":". Lai vienotos par tieši Jūsu uzņēmumam vispiemērotāko individuālo risinājumu,","link":"sazinieties ar mums"},"title":"Neatradāt vajadzīgo? Pasūtiet individuālu risinājumu!","bezPVN":"* Visas cenas norādītas bez PVN. Ar līguma būtiskākajiem nosacījumiem var iepazīties","bezPVNextra":"šeit."},"header":{"advantage":{"item":{"text":"Bez pieslēguma","text2":"maksas"},"item2":{"text":"Mūsdienīgs un","text2":"ātrs"},"item3":{"text":"Der visprasīgākajiem","text2":"klientiem"}},"item":"Interneta","item2":"Pakas"},"items":{"btn":"Pieteikt","first":{"advantage":{"item":"99.99%+ pieejamība","item1":"Simetrisks garantētais ātrums 40Mbit","item2":"Bezmaksas ierīkošana","item3":"24/7 atbalsts"},"noteMonth":"3","price":"29","title":"Ātrums 1"},"note":"Minimālais termiņš","second":{"advantage":{"item":"99.99%+ pieejamība","item1":"Simetrisks garantētais ātrums 100Mbit","item2":"Bezmaksas ierīkošana","item3":"24/7 atbalsts"},"noteMonth":"2","price":"39","title":"Ātrums 2"},"third":{"advantage":{"item":"99.99%+ pieejamība","item1":"Simetrisks garantētais ātrums 160Mbit","item2":"Bezmaksas ierīkošana","item3":"24/7 atbalsts"},"noteMonth":"2","price":"79","title":"Ātrums 3"}}},"profile":{"actionLink":"Pieslēgt papildus pakalpojumus","agree":{"item":"Piekrītu ","item2":"Konfidencialitātes politikai","item3":"un","item4":"Lietošanas noteikumiem"},"agree2":"Piekrītu saņemt īpašus piedāvājumus","client":{"adres":"Adrese","bank":"Bankas konts","city":"Pilsēta","country":"Valsts","index":"Pasta indekss","mail":"E-pasts","mailNote":"NOSŪTĪT PIEPRASĪJUMU UZ E-PASTU","name":"Uzņēmums","nr":"Reģistrācijas nr.","person":"Kontaktpersona","phone":"Tālrunis","swift":"SWIFT kods","title":"Informācija par klientu"},"note":"Lai nomainītu autentifikācijas datus, nepieciešams sniegt manuālu apstiprinājumu pa e-pastu, kas norādīts profila reģistrācijas brīdī.","payInfo":"Tekošais rēķins","payOff":"Apmaksa veikta","payOn":"Apmaksāt","subTitle":"Rēķini","title":"Pakalpojumi"},"reviews":{"first":{"company":"SIA «Advanced Learning & Communications»","name":"Dmitrijs Krasnovskis","text":"Esam ļoti prasīgi pret interneta kvalitāti un ātrumu. DolphNet risinājums palīdzēja mums strādāt bez dīkstāvēm, tāpēc ar sniegto pakalpojumu esam apmierināti. Iesakām visiem DolphNet!"},"second":{"company":"SOS BĒRNU CIEMATU ASOCIĀCIJA","name":"Raivis Raģis, IT koordinators","text":"Pārejot uz DolphNet interneta pieslēgumu varējām samazināt ikmēneša optiskā interneta pieslēguma izmaksas, nezaudējot kvalitāti."},"third":{"company":"MAGNET MEDIA","name":"Andris Mihelsons, valdes priekšsēdētājs","text":"DolphNet interneta pieslēgums un e-pastu uzturēšanas pakalpojums uzlaboja ikdienas darba efektivitāti, jo pēc pāriešanas uz DolphNet interneta ātrums un stabilitāte būtiski uzlabojusies. Šie uzlabojumi ļauj mums ātri un ēŗti apmainīties ar liela izmēra darba failiem ar mūsu sadarbības partneriem gan ārzemēs, gan arī Latvijā."}},"services":{"services":{"btn":"Vairāk","item":{"title":"Tālruņa","title2":"līnija"},"item10":{"title":"Virtuālais fakss"},"item11":{"title":"Telekomunikāciju","title2":"iekārtas"},"item2":{"title":"E-pastu uzturēšana"},"item3":{"title":"Mājas lapu hostings"},"item4":{"title":"Virtuālā telefona centrāle"},"item5":{"title":"Videonovērošanas serveris"},"item6":{"title":"ISDN2","title2":"līnija"},"item7":{"title":"Drošais failu","title2":"serveris"},"item8":{"title":"\"Birojs bez","title2":"servera\""},"item9":{"title":"SIP numurs"}},"title":"Pakalpojumi"},"slider":{"first":{"button":"Aplūkot pieejamību Rīgas biznesa centros ","small_text":{"first":"Pieejams >87% jau esošo ","second":"pieslēgumu vietās "},"text_field":{"first":"pa   īstam ","second":"ātrs ","third":"internets "}},"second":{"button":"Aplūkot īpašo piedāvājumu ","small_text":{"first":"īpaši pievilcīgi nosacījumi ","second":"jauniem un it uzņēmumiem "},"text_field":{"first":"jauniem ","second":"un ","third":"startapiem "}},"third":{"button":"Aplūkot īpašo piedāvājumu ","small_text":{"first":"Pārej uz Dolphnet un ","second":"lieto mega ātru hostingu ","third":"6 mēnešus par brīvu "},"text_field":{"first":"mākoņ- ","second":"hostings ","third":"€0,- "}},"social":"Sekojiet mums"},"startups":{"title":"JAUNIEM UN STARTAPIEM","body":{"link":{"item":"Pārbaudīt pieejamību","item2":"Populāri jautājumi par pieslēgumu","item3":"Pieteikt interneta pieslēgumu"},"subTitle":"Akcijas noteikumi","text":"Piedāvājumu var izmantot uzņēmumi, kuri darbojas ne ilgāk kā 18 mēnešus. Akcijas piedāvājuma pieslēguma adrese var būt akcijas noteikumiem atbilstošā uzņēmuma juridiskā adrese vai arī šī uzņēmuma reģistrētas struktūrvienības adrese. Akcijas piedāvājums pieejams, ja uzņēmuma adresē ir tehniskas iespējas ierīkot pakalpojumu. ","title":"Noderīgas saites"},"features":{"card":{"advantage":{"item":"99.99%+ pieejamība","item2":"Bezmaksas ierīkošana","item3":"24/7 atbalsts"},"btn":"Izmantot iespēju","month":"2","newPrice":"29","note":"Minimālais termiņš","oldPrice":"39","title":"«PROMO-1»"},"item":"Tarifu plāns spēkā 18 mēnešus pēc uzņēmuma reģistrācijas","item2":"Mūsdienīgs, stabils un ātrs","item3":"Ar garantētu maksimālo ātrumu 500 Mbit/s"}},"support":{"article":{"adres":"Maskavas iela 146, Rīga","desc":"Konstatētas problēmas ar interneta pieslēgumu. Tiek risinātas.","mail":"E-pastu kastītes","note":"Dažiem klientiem ir konstatētas problēmas ar e-pasta kastītēm. Līdz plkst. 13:00 (GMT+2) tiks izlabots.","title":"Adreses un pakalpojumi ar iespējamiem sakaru traucējumiem"},"title":"Tehniskais atbalsts"},"notfound":"Lapa nav atrasta","termsofuse":"Lietošanas noteikumi"}

/***/ }),

/***/ "j3D9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "j3UF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),

/***/ "jXGU":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("2Axb");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

module.exports = stringToPath;

/***/ }),

/***/ "jx4H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "kAdy":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("bViC");

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),

/***/ "knrM":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("B9Lq");
var enumBugKeys = __webpack_require__("KxjL");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "lBq7":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("C8N4"),
    ListCache = __webpack_require__("Xk23"),
    Map = __webpack_require__("K9uV");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),

/***/ "lPmd":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "lXHz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),

/***/ "lytE":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("MpYs");
var defined = __webpack_require__("U72i");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),

/***/ "mKeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observer; });
/* unused harmony export Observer */
/* unused harmony export useStaticRendering */
/* unused harmony export connect */
/* unused harmony export inject */
/* unused harmony export Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("6uYi");



function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render) && !__WEBPACK_IMPORTED_MODULE_0_preact__["Component"].isPrototypeOf(component);
}

function makeDisplayName(component) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
        _ref$suffix = _ref.suffix,
        suffix = _ref$suffix === undefined ? '' : _ref$suffix;

    var displayName = component.displayName || component.name || component.constructor && component.constructor.name || '<component>';
    return prefix + displayName + suffix;
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};

var createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var isUsingStaticRendering = false;

var logger = console; // eslint-disable-line no-console

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 Workaround

 allowStateChanges from mobX must be patched so that props, state and args are passed to the render() function
 */

function allowStateChangesStart(allowStateChanges) {
    var prev = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* _getGlobalState */])().allowStateChanges;
    Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* _getGlobalState */])().allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* _getGlobalState */])().allowStateChanges = prev;
}

function allowStateChanges(allowStateChanges, func, props, state, context) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res = void 0;
    try {
        res = func(props, state, context);
    } finally {
        allowStateChangesEnd(prev);
    }
    return res;
}

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function isObjectShallowModified(prev, next) {
    if (null == prev || null == next || (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) !== 'object' || (typeof next === 'undefined' ? 'undefined' : _typeof(next)) !== 'object') {
        return prev !== next;
    }
    var keys = Object.keys(prev);
    if (keys.length !== Object.keys(next).length) {
        return true;
    }
    var key = void 0;
    for (var i = keys.length - 1; key = keys[i]; i--) {
        if (next[key] !== prev[key]) {
            return true;
        }
    }
    return false;
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) {
            return;
        }
        // Generate friendly name for debugging
        var initialName = makeDisplayName(this);

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["e" /* createAtom */])('reactive ' + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && isObjectShallowModified(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, 'props');
        // make state an observable reference
        makePropertyObservableReference.call(this, 'state');

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_1_mobx__["a" /* Reaction */](initialName + '.render()', function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === 'function') {
                        _this.componentWillReact();
                    } // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) {
                                __WEBPACK_IMPORTED_MODULE_0_preact__["Component"].prototype.forceUpdate.call(_this);
                            }
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) {
                                reaction.dispose();
                            }
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender(_this.props, _this.state, _this.context);
        };

        var reactiveRender = function reactiveRender(props, state, context) {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                try {
                    rendering = allowStateChanges(false, baseRender, props, state, context);
                } catch (e) {
                    exception = e;
                }
            });
            if (exception) {
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) {
            return;
        }
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
    },

    componentDidMount: function componentDidMount() {},

    componentDidUpdate: function componentDidUpdate() {},

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            logger.warn('[mobx-preact] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.');
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return isObjectShallowModified(this.props, nextProps);
    }
};

/**
 * Observer function / decorator
 */
function observer(componentClass) {
    if (arguments.length > 1) {
        logger.warn('Mobx observer: Using observer to inject stores is not supported. Use `@connect(["store1", "store2"]) ComponentClass instead or preferably, use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))``');
    }

    if (componentClass.isMobxInjector === true) {
        logger.warn('Mobx observer: You are trying to use \'observer\' on a component that already has \'inject\'. Please apply \'observer\' before applying \'inject\'');
    }

    // Stateless function component:
    if (isStateless(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: 'render',
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.displayName = makeDisplayName(componentClass), _temp));
    }

    if (!componentClass) {
        throw new Error('Please pass a valid component to \'observer\'');
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, 'componentWillMount', true);
    patch(target, 'componentDidMount');

    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

var Observer = observer(function (_ref) {
    var children = _ref.children;
    return children[0]();
});

Observer.displayName = 'Observer';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
    /**
     * Copyright 2015, Yahoo! Inc.
     * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
     */
    (function (global, factory) {
        module.exports = factory();
    })(commonjsGlobal, function () {

        var REACT_STATICS = {
            childContextTypes: true,
            contextTypes: true,
            defaultProps: true,
            displayName: true,
            getDefaultProps: true,
            getDerivedStateFromProps: true,
            mixins: true,
            propTypes: true,
            type: true
        };

        var KNOWN_STATICS = {
            name: true,
            length: true,
            prototype: true,
            caller: true,
            callee: true,
            arguments: true,
            arity: true
        };

        var defineProperty = Object.defineProperty;
        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var getPrototypeOf = Object.getPrototypeOf;
        var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

        return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
            if (typeof sourceComponent !== 'string') {
                // don't hoist over string (html) components

                if (objectPrototype) {
                    var inheritedComponent = getPrototypeOf(sourceComponent);
                    if (inheritedComponent && inheritedComponent !== objectPrototype) {
                        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                    }
                }

                var keys = getOwnPropertyNames(sourceComponent);

                if (getOwnPropertySymbols) {
                    keys = keys.concat(getOwnPropertySymbols(sourceComponent));
                }

                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                        try {
                            // Avoid failures from read-only properties
                            defineProperty(targetComponent, key, descriptor);
                        } catch (e) {}
                    }
                }

                return targetComponent;
            }

            return targetComponent;
        };
    });
});

var proxiedInjectorProps = {
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }
};

/**
 * Store Injection
 */
function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp;

    var prefix = 'inject-';
    var suffix = injectNames ? '-with-' + injectNames : '';
    var displayName = makeDisplayName(component, { prefix: prefix, suffix: suffix });

    var Injector = (_temp = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            classCallCheck(this, Injector);
            return possibleConstructorReturn(this, (Injector.__proto__ || Object.getPrototypeOf(Injector)).apply(this, arguments));
        }

        createClass(Injector, [{
            key: 'render',
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }
                var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key in additionalProps) {
                    newProps[_key] = additionalProps[_key];
                }

                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.displayName = displayName, _temp);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            // prefer props over stores
            if (storeName in nextProps) {
                return;
            }
            if (!(storeName in baseStores)) {
                throw new Error('MobX injector: Store \'' + storeName + '\' is not available! Make sure it is provided by some Provider');
            }
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === 'function') {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // suppress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }
        grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join('-'));
        };
    }
}

function connect(arg1, arg2) {
    if (typeof arg1 === 'string') {
        throw new Error('Store names should be provided as array');
    }
    if (Array.isArray(arg1)) {
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return connect(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(connect(arg2));
        }
    }
    return observer(arg1);
}

var specialReactKeys = { children: true, key: true, ref: true };

var logger$1 = console; // eslint-disable-line no-console

var Provider = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: 'render',
        value: function render(_ref) {
            var children = _ref.children;

            return children.length > 1 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', null, ' ', children, ' ') : children[0];
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) {
                for (var key in baseStores) {
                    stores[key] = baseStores[key];
                }
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== 'suppressChangedStoreWarning') {
                    stores[_key] = this.props[_key];
                }
            }

            return {
                mobxStores: stores
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) {
                logger$1.warn('MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children');
            }
            if (!nextProps.suppressChangedStoreWarning) {
                for (var key in nextProps) {
                    if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) {
                        logger$1.warn('MobX Provider: Provided store \'' + key + '\' has changed. Please avoid replacing stores as the change might not propagate to all children');
                    }
                }
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

if (!__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]) {
    throw new Error('mobx-preact requires Preact to be available');
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "mV+j":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("p/s9"),
    castPath = __webpack_require__("Tnr5"),
    isIndex = __webpack_require__("A+gr"),
    isObject = __webpack_require__("u9vI"),
    toKey = __webpack_require__("RQ0L");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;

/***/ }),

/***/ "mYpx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("VuZO");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "mbLO":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("U72i");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "p/0c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),

/***/ "p/s9":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("d05+"),
    eq = __webpack_require__("LIpy");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "q3B8":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("MIhM");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),

/***/ "qBl2":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),

/***/ "rNh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlProvider; });
/* unused harmony export Localizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MarkupText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Text; });
/* unused harmony export intl */
/* unused harmony export withText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv__ = __webpack_require__("CYb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dlv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dlv__);



/** Check if an object is not null or undefined
 *	@private
 */
function defined(obj) {
  return obj !== null && obj !== undefined;
}

/** A simpler Object.assign
 *  @private
 */
function assign(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }
  return obj;
}

/** Recursively copy keys from `source` to `target`, skipping truthy values already in `target`.
 *	@private
 */
function deepAssign(target, source) {
  var out = assign({}, target);
  for (var i in source) {
    if (source.hasOwnProperty(i)) {
      if (target[i] && source[i] && typeof target[i] === 'object' && typeof source[i] === 'object') {
        out[i] = deepAssign(target[i], source[i]);
      } else {
        out[i] = target[i] || source[i];
      }
    }
  }
  return out;
}

/** select('foo,bar') creates a mapping: `{ foo, bar }`
 *	@private
 */
function select(properties) {
  properties = properties || {};
  if (typeof properties === 'string') {
    properties = properties.split(',');
  }
  if ('join' in properties) {
    var selected = {};
    for (var i = 0; i < properties.length; i++) {
      var val = properties[i].trim();
      if (val) {
        selected[val.split('.').pop()] = val;
      }
    }
    return selected;
  }
  return properties;
}

var URL_FLAG = /[?&#]intl=show/;

/** `<IntlProvider>` is a nestable internationalization definition provider.
 *	It exposes an Intl scope & definition into the tree,
 *	making them available to descendant components.
 *
 *	> **Note:** When nested, gives precedence to keys higher up the tree!
 *	> This means lower-level components can set their defaults by wrapping themselves
 *	> in an `<IntlProvider>`, but still remain localizable by their parent components.
 *
 *	@name IntlProvider
 *	@param props
 *	@param {String} [props.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param {Boolean} [props.mark=false]		If `true`, all `<Text>` elements will be shown with a red/green background indicating whether they have valid Intl keys.
 *	@param {Object} [props.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 *
 *	@example
 *	// generally imported from a JSON file:
 *	let definition = {
 *		foo: 'Le Feux'
 *	};
 *
 *	<IntlProvider scope="weather" definition={definition}>
 *		<Text key="foo">The Foo</Text>
 *	</IntlProvider>
 *
 *	// This will render the text:
 *	"Le Feux"
 */
var IntlProvider = /*@__PURE__*/function (Component) {
  function IntlProvider() {
    Component.apply(this, arguments);
  }

  if (Component) IntlProvider.__proto__ = Component;
  IntlProvider.prototype = Object.create(Component && Component.prototype);
  IntlProvider.prototype.constructor = IntlProvider;

  IntlProvider.prototype.getChildContext = function getChildContext() {
    var ref = this.props;
    var scope = ref.scope;
    var definition = ref.definition;
    var mark = ref.mark;
    var intl = assign({}, this.context.intl || {});

    // set active scope for the tree if given
    if (scope) {
      intl.scope = scope;
    }

    // merge definition into current with lower precedence
    if (definition) {
      intl.dictionary = deepAssign(intl.dictionary || {}, definition);
    }

    if (mark || typeof location !== 'undefined' && String(location).match(URL_FLAG)) {
      intl.mark = true;
    }

    return { intl: intl };
  };

  IntlProvider.prototype.render = function render(ref) {
    var children = ref.children;

    return children && children[0] || null;
  };

  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/**
 * Higher-order function that creates an `<IntlProvider />` wrapper component for the given component.  It
 * takes two forms depending on how many arguments it's given:
 * It can take a functional form like:
 * intl(ComponentToWrap, options)
 *
 * or it can take an annotation form like:
 * @intl(options)
 * class ComponentToWrap extends Component {}
 *
 *	@param {Component or Object} args[0] If there are two arguments, the first argument is the Component to wrap in `<IntlProvider/>`. If there is just one argument, this is the options object to pass as `props` to `<IntlProvider/>`. See the definition of the options param below for details.
 *	@param {Object} options If there are two arguments, the second argument is Passed as `props` to `<IntlProvider />`
 *	@param [options.scope]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *	@param [options.definition={}]	Merge the given definition into the current intl definition, giving the *current* definition precedence (i.e., only adding keys, acting as defaults)
 */
function intl(Child, options) {
  if (arguments.length < 2) {
    options = Child;
    return function (Child) {
      return intl(Child, options);
    };
  }
  function IntlProviderWrapper(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(IntlProvider, options || {}, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, props));
  }

  IntlProviderWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
    return Child;
  };
  return IntlProviderWrapper;
}

var EMPTY = {};

/** Populate {{template.fields}} within a given string.
 *
 *	@private
 *	@param {String} template	The string containing fields to be resolved
 *	@param {Object} [fields={}]	Optionally nested object of fields, referencable from `template`.
 *	@example
 *		template('foo{{bar}}', { bar:'baz' }) === 'foobaz'
 */
function template(template, fields, scope, dictionary) {
  return template && template.replace(/\{\{([\w.-]+)\}\}/g, replacer.bind(null, fields || EMPTY, scope, dictionary));
}

/** Replacement callback for injecting fields into a String
 *	@private
 */
function replacer(currentFields, scope, dictionary, s, field) {
  var parts = field.split('.'),
      v = currentFields;
  for (var i = 0; i < parts.length; i++) {
    v = v[parts[i]];
    if (v == null) {
      return '';
    } // eslint-disable-line eqeqeq

    //allow field values to be <Text /> nodes
    if (v && v.nodeName === Text) {
      return translate(v.attributes.id, scope, dictionary, v.attributes.fields, v.attributes.plural, v.attributes.fallback);
    }
  }
  // allow for recursive {{config.xx}} references:
  if (typeof v === 'string' && v.match(/\{\{/)) {
    v = template(v, currentFields);
  }
  return v;
}

/** Attempts to look up a translated value from a given dictionary.
 *  Also supports json templating using the format: {{variable}}
 *	Falls back to default text.
 *
 *	@private
 *	@param {String} id				Intl field name/id (subject to scope)
 *	@param {String} [scope='']		Scope, which prefixes `id` with `${scope}.`
 *	@param {Object} dictionary		A nested object containing translations
 *	@param {Object} [fields={}]		Template fields for use by translated strings
 *	@param {Number} [plural]		Indicates a quantity, used to trigger pluralization
 *	@param {String|Array} [fallback]	Text to return if no translation is found
 *	@returns {String} translated
 */
function translate(id, scope, dictionary, fields, plural, fallback) {
  if (scope) {
    id = scope + '.' + id;
  }

  var value = dictionary && __WEBPACK_IMPORTED_MODULE_1_dlv___default()(dictionary, id);

  // plural forms:
  // key: ['plural', 'singular']
  // key: { none, one, many }
  // key: { singular, plural }
  if ((plural || plural === 0) && value && typeof value === 'object') {
    if (value.splice) {
      value = value[plural] || value[0];
    } else if (plural === 0 && defined(value.none)) {
      value = value.none;
    } else if (plural === 1 && defined(value.one || value.singular)) {
      value = value.one || value.singular;
    } else {
      value = value.some || value.many || value.plural || value.other || value;
    }
  }

  return value && template(value, fields, scope, dictionary) || fallback || null;
}

/** Highlight/colorize the i18n'd node if `mark` is set on `intl` in context.  If not, just returns `value`
 *
 *	@private
 *	@param {String|VNode} value	The l10n'd text/vnode to highlight or pass through
 *	@param {string} id	The key used to lookup the value in the intl dictionary
 */
function HighlightI18N(ref, ref$1) {
  var value = ref.value;
  var id = ref.id;
  var intl = ref$1.intl;

  if (intl && intl.mark) {
    var dictionaryKey = "dictionary" + (intl && intl.scope ? "." + intl.scope : '') + "." + id;
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('mark', {
      style: 'background: ' + (value ? __WEBPACK_IMPORTED_MODULE_1_dlv___default()(intl, dictionaryKey) ? 'rgba(119,231,117,.5)' // Green = this string is fully internationalized
      : 'rgba(229,226,41,.5)' // Yellow = this string does not have a value in the dictionary, but it has a fallback value
      : 'rgba(228,147,51,.5)' // Red = this string has no value and no fallback
      ),
      title: id
    }, value);
  }

  return value;
}

/** `<Text>` renders internationalized text.
 *	It attempts to look up translated values from a dictionary in context.
 *
 *	Template strings can contain `{{field}}` placeholders,
 *	which injects values from the `fields` prop.
 *
 *	When string lookup fails, renders its children as fallback text.
 *
 *	@param {Object} props				props
 *	@param {String} props.id			Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {Object} [props.fields={}]	Values to inject into template `{{fields}}`.  Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number} [props.plural]		Integer "count", used to select plural forms
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<Text id="foo">The Foo</Text>
 *	// ..produces the text:
 *	"The Foo"
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux {{bar}}' }}>
 *		<Text id="foo" fields={{ bar: 'BEAR' }}>The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux BEAR"
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le Feux' }}>
 *		<Text id="foo">The Foo</Text>
 *	</IntlProvider>
 *	// ..produces the text:
 *	"Le Feux"
 */
function Text(ref, ref$1) {
  var id = ref.id;
  var children = ref.children;
  var plural = ref.plural;
  var fields = ref.fields;
  var intl = ref$1.intl;

  var fallback = children && children[0];

  var value = translate(id, intl && intl.scope, intl && intl.dictionary, fields, plural, fallback);

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(HighlightI18N, { id: id, value: value });
}

/** Translates the property values in an Object, returning a copy.
 *	**Note:** By default, `String` keys will be treated as Intl ID's.
 *	Pass `true` to return an Object containing *only* translated
 *	values where the prop is a <Text /> node.
 *
 *	@private
 *	@param {Object} props	An object with values to translate
 *	@param {Object} intl	An intl context object (eg: `context.intl`)
 *	@param {Boolean} [onlyTextNodes=false]	Only process `<Text />` values
 *	@returns {Object} translatedProps
 */
function translateMapping(props, intl, onlyTextNodes) {
  var out = {};
  intl = intl || {};
  props = select(props);
  for (var name in props) {
    if (props.hasOwnProperty(name) && props[name]) {
      var def = props[name];

      // if onlyTextNodes=true, skip any props that aren't <Text /> vnodes
      if (!onlyTextNodes && typeof def === 'string') {
        out[name] = translate(def, intl.scope, intl.dictionary);
      } else if (def.nodeName === Text) {
        // it's a <Text />, just grab its props:
        var c = def.children;
        def = assign({
          //no fallback if there are no children.  Return first child if there is only 1, or array of children if there are more than one
          fallback: c.length && (c.length === 1 ? c[0] : c)
        }, def.attributes);
        out[name] = translate(def.id, intl.scope, intl.dictionary, def.fields, def.plural, def.fallback);
      }
    }
  }
  return out;
}

/** `<Localizer />` is a Compositional Component.
 *	It "renders" out any `<Text />` values in its child's props.
 *
 *	@name Localizer
 *	@param {Object} props
 *	@param {Object} props.children	Child components with props to localize.
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *	@example
 *	<Localizer>
 *		<input placeholder={<Text id="username.placeholder" />} />
 *	</Localizer>
 *	// produces:
 *	<input placeholder="foo" />
 *
 *	@example
 *	<Localizer>
 *		<abbr title={<Text id="oss-title">Open Source Software</Text>}>
 *			<Text id="oss">OSS</Text>
 *		</abbr>
 *	</Localizer>
 *	// produces:
 *	<abbr title="Open Source Software">OSS</abbr>
 */
function Localizer(ref, ref$1) {
  var children = ref.children;
  var intl = ref$1.intl;

  var child = children && children[0];
  return child && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(child, translateMapping(child.attributes, intl, true));
}

/* eslint-disable react/no-danger */

/** `<MarkupText>` is just like {@link Text} but it can also contain html markup in rendered strings.  It wraps its contents in a `<span>` tag.
 *
 *	@param {Object} props				props
 *	@param {String} props.id			Key to look up in intl dictionary, within any parent scopes (`$scope1.$scope2.$id`)
 *	@param {Object} [props.fields={}]	Values to inject into template `{{fields}}`.  Values in the `fields` object will be coerced to strings, with the exception of `<Text/>` nodes which will be resolved to their translated value
 *	@param {Number} [props.plural]		Integer "count", used to select plural forms
 *	@param {Object} context
 *	@param {Object} context.intl		[internal] dictionary and scope info
 *
 *	@example
 *	// If there is no dictionary in context..
 *	<MarkupText id="foo"><b>The Foo</b></MarkupText>
 *	// ..produces the vnode:
 *	<span><b>The Foo</b></span>
 *
 *	@example
 *	// Given a dictionary and some fields..
 *	<IntlProvider definition={{ foo:'Le Feux <b>{{bar}}</b>' }}>
 *		<MarkupText id="foo" fields={{ bar: 'BEAR' }}>The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le Feux <b>BEAR</b></span>
 *
 *	@example
 *	// Within a scope, both `id` and the definition are namespaced..
 *	<IntlProvider scope="weather" definition={{ foo:'Le <a href="http://foo.com">Feux</a>' }}>
 *		<MarkupText id="foo">The Foo</MarkupText>
 *	</IntlProvider>
 *	// ..produces the vnode:
 *	<span>Le <a href="http://foo.com">Feux</a></span>
 *
 *	@example
 *	// renders nothing if there is no key match and no fallback
 *	<div><MarkupText /></div>
 *	// ..produces the vnode:
 *	<div/>
 */
function MarkupText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Localizer, null, Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Html, { html: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Text, props), id: props.id }));
}

function Html(ref) {
  var html = ref.html;
  var id = ref.id;

  var value = !html ? html : typeof html === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { dangerouslySetInnerHTML: { __html: html } }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', null, html);
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(HighlightI18N, { id: id, value: value });
}

/** `@withText()` is a Higher Order Component, often used as a decorator.
 *
 *	It wraps a child component and passes it translations
 *	based on a mapping to the dictionary & scope in context.
 *
 *	@param {Object|Function|String} mapping		Maps prop names to intl keys (or `<Text>` nodes).
 *
 *	@example @withText({
 *		placeholder: 'user.placeholder'
 *	})
 *	class Foo {
 *		// now the `placeholder` prop is our localized String:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText({
 *		placeholder: <Text id="user.placeholder">fallback text</Text>
 *	})
 *	class Foo {
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example @withText('user.placeholder')
 *	class Foo {
 *		// for Strings/Arrays, the last path segment becomes the prop name:
 *		render({ placeholder }) {
 *			return <input placeholder={placeholder} />
 *		}
 *	}
 *
 *	@example <caption>Works with functional components, too</caption>
 *	const Foo = withText('user.placeholder')( props =>
 *		<input placeholder={props.placeholder} />
 *	)
 *
 * 	@example <caption>getWrappedComponent() returns wrapped child Component</caption>
 *	const Foo = () => <div/>;
 *	const WrappedFoo = withText('user.placeholer')(Foo);
 *	WrappedFoo.getWrappedComponent() === Foo; // true
 */
function withText(mapping) {
  return function withTextWrapper(Child) {
    function WithTextWrapper(props, context) {
      var map = typeof mapping === 'function' ? mapping(props, context) : mapping;
      var translations = translateMapping(map, context.intl);
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Child, assign(assign({}, props), translations));
    }

    WithTextWrapper.getWrappedComponent = Child && Child.getWrappedComponent || function () {
      return Child;
    };
    return WithTextWrapper;
  };
}

intl.intl = intl;
intl.IntlProvider = IntlProvider;
intl.Text = Text;
intl.MarkupText = MarkupText;
intl.Localizer = Localizer;
intl.withText = withText;

/* unused harmony default export */ var _unused_webpack_default_export = (intl);

//# sourceMappingURL=preact-i18n.esm.js.map

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s9iF":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),

/***/ "spZd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "twDh":
/***/ (function(module, exports) {

module.exports = {"avail":{"city":{"btn":"Search","item":"Type","item2":"Business Center","item3":"Industrial park","item4":"Supermarket"},"note":{"link":"Contact Us","link2":"by entering your address","text":"If you didn't find your object on the map -","text2":"or check availability,"},"option":"city","title":"DolphNet ™ Internet availability"},"availability":{"config":{"item":{"title":"Internet"},"item2":{"title":"Phone"},"item3":{"title":"Email boxes"},"options":{"item":"Long technical service 4","item2":"Long technical service 5","item3":"Long technical service 6","item4":{"link":"«PROMO-1»","title":"This address qualifies for our promotional offer on Fiber Internet service for new entrepreneurs and startups"}}},"desc":"Please select the services you would like to sign-up for at this address","form":{"btn":"Search","placeholder":"Please enter an address to check availability","placeholderSmall":"Enter your address"},"subTitle":"Available services","title":"Check for DolphNet™ availability"},"cart":{"from":"from","year":{"full":"per year"},"month":{"cut":"mo","full":"per month"},"months":{"cut":"mo","full":"months"}},"contactForm":{"adres":"Please enter the address where you would like to report the problem or outage","checkbox":{"link":"Privacy Policy","text":"I agree to the processing of my personal data pursuant to"},"error":"Error sending question! Please try again later, or call DolphNet's 24/7 customer support","errorLink":"now!","form":{"apply":{"captionText":"Apply for services at the selected address","contentText":"Application for Services","descriptionText":"","sentText":"Our managers will contact you within one business day.","submitText":"Report problem"},"standart":{"captionText":"Contact or ask a question","contentText":"Question or comment","descriptionText":"Send us a question and our managers will contact you within one business day!","sentText":"Our managers will contact you within one business day.","submitText":"Send application"},"support":{"captionText":"Report a technical problem or outage","contentText":"Please describe the nature of the problem","descriptionText":"","sentText":"Our technician will contact you within one hour.","submitText":"Report damage"}},"mail":"E-mail","name":"Your Name","phone":"Phone","policy":"You must agree to the privacy policy to post a question!","title":"Your application has been sent!"},"calcForm":{"header":"Find out if you overpay for the business internet!","currentPriceSubtitle":"What is your current monthly fee?","currentSpeedSubtitle":"What is your internet speed?","specifyOther":"Other","buttons":{"calculate":"Calculate","submit":"Request a call"},"nowPrice":"At the moment, <strong>{{speed}} Mbit</strong> costs you <strong>&euro;{{price}}</strong>.","ourPrice":"Cost of <strong>{{speed}} Mbit</strong> on DolphNet - <strong>&euro;{{price}}</strong>!","phone":"Leave your phone number","percentText":"You can have <strong>{{percent}}%</strong> cheaper internet","promoText":"With DolphNet you can have mega-fast internet with much better offer!","promoTextExtended":"It looks like you already have a great internet offer.<br />Would you like to have even more speed?","suggested":"Recommended package","offerText":"<strong>{{speed}} Mbit</strong> internet for <strong>&euro;{{price}} / month</strong>","sent":"Thank you! Your request was successfully sent."},"contacts":{"title":"Contact Us"},"email":{"body":{"desc":"","list":{"item":"","item2":"","item3":{"link":"","text":""},"label":"Company information"},"text":"","title":""},"title":"Email hosting","widget":{"list":{"btn":"Sign up","item":"","item2":""},"price":"5"}},"faq":{"title":"Frequently Asked Questions"},"footer":{"copy":"2019 Copyright © DolphNet ™ Internet. All rights reserved.","menu":{"about":"About us","adres":"Office","adresText":"20 Krisjanis Barons str., Riga","desc":"DolphNet™ is a modern communications provider for business and professionals.","link":"Send us a message","map":"Show on map","services":{"item":"Internet","item2":"Phone","item3":"Email hosting","item4":"Website hosting","item5":"All services","label":"Services"},"site":{"item":"Check availability","item2":"My DolphNet","item3":"Support Service","item4":"FAQ","item5":"Privacy Policy","label":"Links"},"support":"Support"},"note":"Marketing and design:","noteLink":"AL&C"},"header":{"cookies":{"link":"Privacy Policy","text":"This website uses cookies. By continuing to browse the site, you agree to our"},"links":{"availability":"Apply for a connection","biznes":{"text":"For business and","text2":"professionals"},"cabinet":"My DolphNet"},"menu":{"item":"High speed internet","item2":"Phone","item3":"Other Services","item4":"Support"}},"home":{"advantage":{"item":{"text":"Cost-effective and fast","text2":"fiber internet","text3":"up to","text4":"1 Gbit/s"},"item2":{"text":"Meets the needs","text2":"of the most demanding","text3":"users and companies"},"item3":{"text":"Available in major","text2":"Latvian business centers","text3":"and elsewhere"}},"btn":"See all","cards":{"btn":"More","item":{"title":"Phone","title2":"line"},"item2":{"title":"Email hosting"},"item3":{"title":"Website hosting"},"item4":{"title":"Virtual PBX"},"item5":{"title":"Video surveillance server"},"item6":{"title":"ISDN2","title2":"line"}},"desc":"In addition to the Internet service, we also provide telephone line, email storage and other useful services.","subTitle":"Services","subTitle2":""},"iconBar":"Up to","locSlider":{"link":"Connect","text":"High Speed Internet DolphNet™ Available"},"loginForm":{"error":"Mail or password is invalid","cabinet":"DolphNet","client":"My","login":"Sign-in","reset":"Reset","resetPass":"password","mail":"E-mail","pass":"Password"},"phone":{"article":{"desc":"","list":{"item":"","item2":"","item3":{"link":"","text":""}},"subTitle":"Company information","text":"","title":""},"title":"Business phone line","widget":{"from":"from","item":"","item2":"","link":"Sign-up","price":"7"}},"plans":{"title":"FAST INTERNET","desc":{"item":"All internet connections include 24/7 customer support.","item2":"If you have any questions, contact us to","link":"check availability"},"footer":{"text":{"bold":"40 Gbit","item":"In addition to standard Internet packages, DolphNet also provides enterprise services. We provide guaranteed bandwidth Internet services and MPLS channels from 20Mbit up to","item2":". To discuss the best customized solution for your business,","link":"contact us"},"title":"Didn't find what you need? Order a custom solution!","bezPVN":"* All prices exclusive of VAT."},"header":{"advantage":{"item":{"text":"No setup","text2":"fee"},"item2":{"text":"Modern and","text2":"fast"},"item3":{"text":"Suitable for the most demanding","text2":"customers"}},"item":"Internet","item2":"Packages"},"items":{"btn":"Sign-up","first":{"advantage":{"item":"99.99%+ availability","item1":"Guaranteed speed 40Mbit","item2":"Free installation","item3":"24/7 support"},"noteMonth":"3","price":"29","title":"Speed 1"},"note":"Minimum term","second":{"advantage":{"item":"99.99%+ availability","item1":"Guaranteed speed 100Mbit","item2":"Free installation","item3":"24/7 support"},"noteMonth":"2","price":"39","title":"Speed 2"},"third":{"advantage":{"item":"99.99%+ availability","item1":"Guaranteed speed 160Mbit","item2":"Free installation","item3":"24/7 support"},"noteMonth":"2","price":"79","title":"Speed 3"}}},"profile":{"actionLink":"Connect additional services","agree":{"item":"I agree with the","item2":"Privacy Policy","item3":"and","item4":"terms of service"},"agree2":"I agree to receive special offers","client":{"adres":"Address","bank":"Bank Account","city":"City","country":"Country","index":"Postcode","mail":"E-mail","mailNote":"SEND REQUEST TO E-MAIL","name":"Company","nr":"Registration number","person":"Contact person","phone":"Phone","swift":"SWIFT code","title":"Customer information"},"note":"Changing your authentication data requires manual confirmation via the email provided at the time of profile registration.","payInfo":"Current invoice","payOff":"Paid","payOn":"Pay","subTitle":"Invoices","title":"Services"},"reviews":{"first":{"company":"Advanced Learning & Communications Ltd.","name":"Dmitry Krasnovsky","text":"We have very high requirements regarding internet connection quality and speed. DolphNet solution allowed us to work without interruptions, therefore we are happy with the service. We would recommend DolphNet to everyone!"},"second":{"company":"SOS Children's villages Latvia","name":"Raivis Raģis, IT coordinator","text":"By moving to DolphNet we were able to save on monthly fiber internet expenses without losing quality."},"third":{"company":"MAGNET MEDIA","name":"Andris Mihelson, chairman of the board","text":"DolphNet internet and e-mail hosting service allowed us to increase efficiency. After moving to DolphNet internet speed and stability significantly improved. These improvements now allow us to quickly and conveniently exchange large files with our partners in Latvia and abroad."}},"services":{"services":{"btn":"More","item":{"title":"Phone","title2":"line"},"item10":{"title":"Virtual fax"},"item11":{"title":"Telecommunication","title2":"equipment"},"item2":{"title":"Email hosting"},"item3":{"title":"Website hosting"},"item4":{"title":"Virtual PBX"},"item5":{"title":"Video surveillance server"},"item6":{"title":"ISDN2","title2":"line"},"item7":{"title":"Secure file","title2":"server"},"item8":{"title":"\"Office without","title2":"a server\""},"item9":{"title":"SIP number"}},"title":"Services"},"slider":{"first":{"button":"view special offer ","small_text":{"first":"Covers more than ","second":"87% locations "},"text_field":{"first":"The fastest ","second":"fiber ","third":"internet "}},"second":{"button":"view special offer ","small_text":{"first":"attractive conditions ","second":"for new and IT companies "},"text_field":{"first":"for new ","second":"and ","third":"startups "}},"third":{"button":"View special offer ","small_text":{"first":"Become a DolphNet ","second":"customer and get free ","third":"hosting for 6 months "},"text_field":{"first":"Cloud ","second":"hosting ","third":"€0,- "}},"social":"Follow us"},"startups":{"body":{"link":{"item":"Check availability","item2":"Popular questions about the connection","item3":"Apply for an Internet connection"},"subTitle":"Promotion terms","text":"The offer is open to companies operating for up to 18 months. The Internet connection address can be either the registered office of the company eligible for the promotion or a registered branch office of that company. The promotional offer is available if the address has the technical capability to set up the service.","title":"Useful links"},"features":{"card":{"advantage":{"item":"99.99%+ availability","item2":"Free installation","item3":"24/7 support"},"btn":"Seize the opportunity","month":"2","newPrice":"29","note":"Minimum term","oldPrice":"39","title":"«PROMO-1»"},"item":"The monthly price is valid for 18 months after the registration of the company","item2":"Modern, stable and fast","item3":"With a guaranteed maximum speed of 500 Mbit/s"}},"support":{"article":{"adres":"Maskavas iela 146, Rīga","desc":"Problems with internet connection detected. Are being addressed.","mail":"Email hosting","note":"Some customers have encountered problems with email. Until 1 pm (GMT+2) they will be corrected.","title":"Addresses and services with possible service interruptions"},"title":"Technical support"}}

/***/ }),

/***/ "u9vI":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ "uRfg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__("1kq3");
var $export = __webpack_require__("vSO4");
var redefine = __webpack_require__("gojl");
var hide = __webpack_require__("akPY");
var Iterators = __webpack_require__("dhak");
var $iterCreate = __webpack_require__("b7Q2");
var setToStringTag = __webpack_require__("11Ut");
var getPrototypeOf = __webpack_require__("HHE0");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),

/***/ "ue9D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),

/***/ "uiOY":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("wppe");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "uj5A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__("6MLN");
var getKeys = __webpack_require__("knrM");
var gOPS = __webpack_require__("Ocr3");
var pIE = __webpack_require__("z7R8");
var toObject = __webpack_require__("mbLO");
var IObject = __webpack_require__("E5Ce");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("wLcK")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),

/***/ "v5/l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("868B");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),

/***/ "vGFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LazyComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/*
* <LazyComponent 
*   getComponent={import('./exapmle')}    // Callback for loading the component
*   showLoader={true}                     // Show loader while the component is loading
*   scroll={true}                         // Start loading only when the component is about to come into view
*   onLoad={()=>console.log('done')}      // Callback for when the component is loaded
*   expectedHeight={200}                  // Expected height of the loaded component, used for min-height of the loader. 
* />
*
*/

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'preloader-small loading' });

var LazyComponent = function (_Component) {
  _inherits(LazyComponent, _Component);

  function LazyComponent() {
    var _temp, _this, _ret;

    _classCallCheck(this, LazyComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.loadComponentNow = function () {
      if (!_this.loading) {
        _this.loading = true;
        _this.props.getComponent().then(function (module) {
          _this.setState({ component: module.default });
          if (_this.props.onLoad && typeof _this.props.onLoad == 'function') {
            _this.props.onLoad();
          }
          if (_this.props.scroll) window.removeEventListener('scroll', _this.handleScroll);
        });
      }
    }, _this.handleScroll = function () {
      var _this2 = _this,
          ref = _this2.ref;

      if (ref) {
        var bufferArea = window.innerHeight * 0.3,
            scrollY = window.scrollY > bufferArea ? window.scrollY - bufferArea : 0,
            scrollYbottom = window.scrollY + window.innerHeight + bufferArea,
            offsetTop = ref.offsetTop,
            offsetBottom = offsetTop + (ref.clientHeight ? _this.ref.clientHeight : 200);
        if (scrollY < offsetBottom && scrollYbottom > offsetTop) {
          _this.loadComponent();
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LazyComponent.prototype.componentDidMount = function componentDidMount() {
    this.state.component = undefined;
    this.loading = false;
    if (this.props.scroll && window) {
      window.addEventListener('scroll', this.handleScroll);
      if (document.readyState === 'complete') {
        this.handleScroll();
      } else {
        window.addEventListener('load', this.handleScroll);
      }
    } else {
      this.loadComponent();
    }
  };

  LazyComponent.prototype.loadComponent = function loadComponent() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.loadComponentNow);
    } else {
      this.loadComponentNow();
    }
  };

  LazyComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('load', this.handleScroll);
  };

  LazyComponent.prototype.render = function render(props) {
    var _this3 = this;

    return this.state.component ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(this.state.component, props) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      _extends({ style: "min-height:" + (props.expectedHeight ? props.expectedHeight : 200) + "px;position: relative;" }, props, { ref: function ref(_ref2) {
          return _this3.ref = _ref2;
        } }),
      props.showLoader && _ref
    );
  };

  return LazyComponent;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "vSO4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var core = __webpack_require__("zKeE");
var ctx = __webpack_require__("3zRh");
var hide = __webpack_require__("akPY");
var has = __webpack_require__("yS17");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "vUQk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__("Gfzd");
var createDesc = __webpack_require__("0WCH");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),

/***/ "vcHl":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("YD0x");
module.exports = __webpack_require__("zKeE").Object.assign;

/***/ }),

/***/ "vdRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__("6uYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router__ = __webpack_require__("/QC5");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Store = (_dec = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec2 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec3 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec4 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec5 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec6 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec7 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec8 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, _dec9 = __WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */].bound, (_class = function () {
  // client = {
  // 	info: {
  // 		name: "SIA «Advanced Learning & Communications»",
  // 		nr: "40006857846",
  // 		adres: "Brīvības gatve 214m-2",
  // 		country: "Latvija",
  // 		city: "Rīga",
  // 		index: "LV-1021",
  // 		bank: "LV50HABALV24536451241",
  // 		swift: "NABALV50",
  // 		person: "Dmitrijs Krasnovskis",
  // 	},
  // 	cart: {
  // 	   orders: [
  // 			 { status: true, price: 100, date: '16.03.2019'},
  // 			 { status: false, price: 99.99, date: '16.03.2019'},
  // 			 { status: false, price: 99.99, date: '16.03.2019'},
  // 			 { status: false, price: 99.99, date: '16.03.2019'}
  // 		 ]
  // 	}
  // }

  function Store() {
    var _this = this;

    _classCallCheck(this, Store);

    _initDefineProp(this, "cookiebarDismissed", _descriptor, this);

    _initDefineProp(this, "sticky", _descriptor2, this);

    _initDefineProp(this, "servicesHeaderInfo", _descriptor3, this);

    _initDefineProp(this, "lang", _descriptor4, this);

    _initDefineProp(this, "langContent", _descriptor5, this);

    _initDefineProp(this, "activePage", _descriptor6, this);

    _initDefineProp(this, "modalState", _descriptor7, this);

    _initDefineProp(this, "user", _descriptor8, this);

    _initDefineProp(this, "loggedIn", _descriptor9, this);

    _initDefineProp(this, "loginEmail", _descriptor10, this);

    _initDefineProp(this, "loginPassword", _descriptor11, this);

    _initDefineProp(this, "modalLoading", _descriptor12, this);

    _initDefineProp(this, "loginError", _descriptor13, this);

    _initDefineProp(this, "hideMenu", _descriptor14, this);

    _initDefineProp(this, "stuck", _descriptor15, this);

    _initDefineProp(this, "desiredService", _descriptor16, this);

    _initDefineProp(this, "desiredAddress", _descriptor17, this);

    _initDefineProp(this, "foundAddress", _descriptor18, this);

    _initDefineProp(this, "searchRunning", _descriptor19, this);

    _initDefineProp(this, "haveResults", _descriptor20, this);

    _initDefineProp(this, "redirectTo", _descriptor21, this);

    _initDefineProp(this, "foundServices", _descriptor22, this);

    _initDefineProp(this, "foundTitle", _descriptor23, this);

    _initDefineProp(this, "foundFly", _descriptor24, this);

    _initDefineProp(this, "mobileMenu", _descriptor25, this);

    _initDefineProp(this, "client", _descriptor26, this);

    _initDefineProp(this, "activeLocationSlider", _descriptor27, this);

    _initDefineProp(this, "locations", _descriptor28, this);

    this.langs = ["lv", "en", "ru"];

    if (typeof window !== "undefined") {
      this.cookiebarDismissed = !!localStorage.cookiebarDismissed;
      // this.desiredAddress = localStorage.desiredAddress;
      if (!localStorage.calcModalDismissed) setTimeout(function () {
        return _this.showModal("calc");
      }, 10000);
    }
  }

  Store.prototype.dismissCookiebar = function dismissCookiebar() {
    if (typeof window !== "undefined") localStorage.cookiebarDismissed = this.cookiebarDismissed = true;
  };

  Store.prototype.setServicesHeaderInfo = function setServicesHeaderInfo(val) {
    this.servicesHeaderInfo = val;
  };

  Store.prototype.setSticky = function setSticky(val) {
    this.sticky = val;
    if (val) this.stuck = true;
  };

  Store.prototype.setLang = function setLang(val) {
    if (this.lang == val) return;
    this.lang = val;
    if (typeof document !== "undefined") document.getElementsByTagName("html")[0].setAttribute("lang", val);
  };

  Store.prototype.setActiveLocationSlider = function setActiveLocationSlider(val) {
    this.activeLocationSlider = val;
  };

  Store.prototype.showModal = function showModal() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    this.modalState = state;
  };

  Store.prototype.setRedirect = function setRedirect(val) {
    this.redirectTo = val;
  };

  Store.prototype.doLogin = function doLogin() {
    var _this2 = this;

    var creds = {
      email: this.loginEmail,
      password: this.loginPassword
    };
    this.loginError = "";
    this.loginPassword = "";
    //fetch()
    this.modalLoading = true;
    setTimeout(function () {
      _this2.modalLoading = false;
      // this.modalState = '';
      _this2.loginError = "Nepareizs e-pasts vai parole!";
      // route('/lv/profile');
    }, 1000);
  };

  Store.prototype.setContent = function setContent(val) {
    this.langContent = val;
  };

  Store.prototype.setDesiredService = function setDesiredService(value) {
    this.desiredService = value;
  };

  Store.prototype.setDesiredAddress = function setDesiredAddress(value) {
    this.desiredAddress = value;
  };

  Store.prototype.getData1 = function getData1(url) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetch(url)).then(function ($await_2) {
        try {
          response = $await_2;
          return Promise.resolve(response.json()).then($return, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };

  Store.prototype.loadAddressInfo = function loadAddressInfo(id) {
    return new Promise(function ($return, $error) {
      var _this3, data;

      _this3 = this;

      this.haveResults = false;
      this.searchRunning = true;
      Object(__WEBPACK_IMPORTED_MODULE_1_preact_router__["route"])(store.prefix + "/availability?sid=" + id, true);
      return Promise.resolve(this.getData1("https://api.dev.dolphnet.lv/services.php?id=" + id)).then(function ($await_4) {
        try {
          data = $await_4;
          Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* runInAction */])(function () {
            if (data && data.d && data.d.services) {
              _this3.foundServices = data.d.services;
              if (data.d.location) {
                if (data.d.location.address) {
                  _this3.desiredAddress = _this3.foundTitle = data.d.location.address;
                }
                if (data.d.location.geom && data.d.location.geom.coordinates) _this3.foundFly = data.d.location.geom.coordinates;
              }
            }
            _this3.haveResults = true;
            _this3.searchRunning = false;
          });
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    }.bind(this));
  };

  Store.prototype.resetAddressInfo = function resetAddressInfo() {
    this.foundServices = false;
    this.foundFly = false;
    this.foundTitle = false;
    this.haveResults = false;
    this.searchRunning = false;
    Object(__WEBPACK_IMPORTED_MODULE_1_preact_router__["route"])(store.prefix + "/availability", true);
  };

  Store.prototype.resetAddressInfoWithoutRoute = function resetAddressInfoWithoutRoute() {
    this.foundServices = false;
    this.foundFly = false;
    this.foundTitle = false;
    this.haveResults = false;
    this.searchRunning = false;
  };

  Store.prototype.toggleMenu = function toggleMenu() {
    var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (hide) this.mobileMenu = false;else this.mobileMenu = !this.mobileMenu;
  };

  /**/
  Store.prototype.sendForm = function sendForm() {
    var $args = arguments;return new Promise(function ($return, $error) {
      var formName, values, req, response;
      formName = $args.length > 0 && $args[0] !== undefined ? $args[0] : "contact";
      values = $args[1];
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };var $Try_1_Catch = function (e) {
        try {
          return $return(false);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      // console.log('Sending form',formName,'values',values);
      try {
        return Promise.resolve(fetch("https://www.dolphnet.lv/pieteikumi.php", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          method: "POST",
          body: JSON.stringify(_extends({}, values, { formName: formName }))
        })).then(function ($await_5) {
          try {
            req = $await_5;

            return Promise.resolve(req.json()).then(function ($await_6) {
              try {
                response = $await_6;
                // console.log('got response',response);
                return $return(response && response.d && response.d.ok);
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }, $Try_1_Catch);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (e) {
        $Try_1_Catch(e)
      }
    });
  };

  Store.prototype.fetchBC = function fetchBC() {
    return new Promise(function ($return, $error) {
      var _this4, req;

      _this4 = this;

      // Fetch only once, also don't initiate two requests
      if (this.locationsFetching || this.locations && this.locations.length) return $return(new Promise(function (resolve) {
        return resolve(_this4.locations);
      }));
      this.locationsFetching = true;
      return Promise.resolve(fetch("https://api.dev.dolphnet.lv/bc.php")).then(function ($await_7) {
        try {
          req = $await_7;
          return Promise.resolve(req.json()).then(function ($await_8) {
            try {
              return $return(this.locations = $await_8.features);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }.bind(this));
  };

  Store.prototype.loadGA = function loadGA() {
    /* GA*/
    setTimeout(function () {
      (function (i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, "script", "https://www.google-analytics.com/analytics.js", "ga");
      ga("create", "UA-139699233-1", "auto");
      ga("send", "pageview");
    }, 1000);
    /* END GA */
  };

  _createClass(Store, [{
    key: "loginFormValid",
    get: function get() {
      return this.loginEmail && this.loginPassword;
    }
  }, {
    key: "prefix",
    get: function get() {
      return "/" + this.lang;
    }
  }]);

  return Store;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cookiebarDismissed", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sticky", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "servicesHeaderInfo", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "lang", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "lv";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "langContent", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "activePage", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "/";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "modalState", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "user", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "loggedIn", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "loginEmail", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "loginPassword", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "modalLoading", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "loginError", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hideMenu", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "stuck", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "desiredService", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "desiredAddress", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "foundAddress", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "searchRunning", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "haveResults", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "redirectTo", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "foundServices", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "foundTitle", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "foundFly", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "mobileMenu", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "client", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "activeLocationSlider", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "locations", [__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* observable */]], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "dismissCookiebar", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "dismissCookiebar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setServicesHeaderInfo", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "setServicesHeaderInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSticky", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "setSticky"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLang", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "setLang"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setActiveLocationSlider", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "setActiveLocationSlider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showModal", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "showModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRedirect", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "setRedirect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doLogin", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "doLogin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setContent", [__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, "setContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDesiredService", [__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, "setDesiredService"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDesiredAddress", [__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, "setDesiredAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadAddressInfo", [__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, "loadAddressInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetAddressInfo", [__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, "resetAddressInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetAddressInfoWithoutRoute", [__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]], Object.getOwnPropertyDescriptor(_class.prototype, "resetAddressInfoWithoutRoute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMenu", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loginFormValid", [__WEBPACK_IMPORTED_MODULE_0_mobx__["d" /* computed */]], Object.getOwnPropertyDescriptor(_class.prototype, "loginFormValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prefix", [__WEBPACK_IMPORTED_MODULE_0_mobx__["d" /* computed */]], Object.getOwnPropertyDescriptor(_class.prototype, "prefix"), _class.prototype)), _class));


var store = new Store();
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "w1My":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__("SsUF");

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__("j3UF");

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__("Q5Lm");

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__("dUvY");

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__("xjMG");

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__("hgI7");

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__("ue9D");

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__("b6bE");

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__("b7H7");

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__("spZd");

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__("wUs9");

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__("0zpp");

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__("lXHz");

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__("K8wh");

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),

/***/ "wLcK":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "wUs9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "wppe":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("MIhM");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

/***/ }),

/***/ "wtMJ":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("lBq7"),
    mapCacheDelete = __webpack_require__("cDyG"),
    mapCacheGet = __webpack_require__("G3gK"),
    mapCacheHas = __webpack_require__("85ue"),
    mapCacheSet = __webpack_require__("UY82");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),

/***/ "xDQX":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("yEjJ");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),

/***/ "xjMG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("7Rdn");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("868B");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),

/***/ "yAn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("zCAL");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("Xos8");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("T4f3");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("mYpx");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/preact-compat/lib/create-react-class.js
var create_react_class = __webpack_require__("9qxo");
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// CONCATENATED MODULE: ../node_modules/rc-util/es/unsafeLifecyclesPolyfill.js


var unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!preact_compat_es["default"].Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ var es_unsafeLifecyclesPolyfill = (unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill);
// EXTERNAL MODULE: ../node_modules/async-validator/es/index.js
var es = __webpack_require__("fR9K");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ../node_modules/warning/warning.js
var warning_warning = __webpack_require__("XOCG");
var warning_default = /*#__PURE__*/__webpack_require__.n(warning_warning);

// EXTERNAL MODULE: ../node_modules/lodash/get.js
var get = __webpack_require__("5U5Y");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ../node_modules/lodash/set.js
var set = __webpack_require__("VHgz");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ../node_modules/lodash/eq.js
var eq = __webpack_require__("LIpy");
var eq_default = /*#__PURE__*/__webpack_require__.n(eq);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("dACh");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("jx4H");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ../node_modules/rc-form/es/createFormField.js



var createFormField_Field = function Field(fields) {
  classCallCheck_default()(this, Field);

  extends_default()(this, fields);
};

function isFormField(obj) {
  return obj instanceof createFormField_Field;
}

function createFormField(field) {
  if (isFormField(field)) {
    return field;
  }
  return new createFormField_Field(field);
}
// EXTERNAL MODULE: ../node_modules/rc-form/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("InAa");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ../node_modules/rc-form/es/utils.js




function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return hoist_non_react_statics_cjs_default()(Container, WrappedComponent);
}

function identity(obj) {
  return obj;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function treeTraverse() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tree = arguments[1];
  var isLeafNode = arguments[2];
  var errorMessage = arguments[3];
  var callback = arguments[4];

  if (isLeafNode(path, tree)) {
    callback(path, tree);
  } else if (tree === undefined || tree === null) {
    // Do nothing
  } else if (Array.isArray(tree)) {
    tree.forEach(function (subTree, index) {
      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
    });
  } else {
    // It's object and not a leaf node
    if (typeof tree !== 'object') {
      warning_default()(false, errorMessage);
      return;
    }
    Object.keys(tree).forEach(function (subTreeKey) {
      var subTree = tree[subTreeKey];
      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
    });
  }
}

function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
  var fields = {};
  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
    fields[path] = node;
  });
  return fields;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = extends_default()({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}

function getValidateTriggers(validateRules) {
  return validateRules.filter(function (item) {
    return !!item.rules && item.rules.length;
  }).map(function (item) {
    return item.trigger;
  }).reduce(function (pre, curr) {
    return pre.concat(curr);
  }, []);
}

function getValueFromEvent(e) {
  // To support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var options = opt;
  var callback = cb;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(names)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    options: options,
    callback: callback
  };
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}
// CONCATENATED MODULE: ../node_modules/rc-form/es/createFieldsStore.js








function partOf(a, b) {
  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
}

function internalFlattenFields(fields) {
  return flattenFields(fields, function (_, node) {
    return isFormField(node);
  }, 'You must wrap field data with `createFormField`.');
}

var createFieldsStore_FieldsStore = function () {
  function FieldsStore(fields) {
    classCallCheck_default()(this, FieldsStore);

    createFieldsStore__initialiseProps.call(this);

    this.fields = internalFlattenFields(fields);
    this.fieldsMeta = {};
  }

  createClass_default()(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      this.fields = internalFlattenFields(fields);
    }
  }, {
    key: 'flattenRegisteredFields',
    value: function flattenRegisteredFields(fields) {
      var validFieldsName = this.getAllFieldsName();
      return flattenFields(fields, function (path) {
        return validFieldsName.indexOf(path) >= 0;
      }, 'You cannot set a form field before rendering a field associated with the value.');
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = extends_default()({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = _this.getFieldMeta(f);
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = extends_default()({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var fields = this.fields;

      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
      return names.reduce(function (acc, name) {
        var field = fields[name];
        if (field && 'value' in field) {
          acc[name] = {};
        }
        return acc;
      }, {});
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'setFieldsAsDirty',
    value: function setFieldsAsDirty() {
      var _this2 = this;

      Object.keys(this.fields).forEach(function (name) {
        var field = _this2.fields[name];
        var fieldMeta = _this2.fieldsMeta[name];
        if (field && fieldMeta && hasRules(fieldMeta.validate)) {
          _this2.fields[name] = extends_default()({}, field, {
            dirty: true
          });
        }
      });
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
      return this.fieldsMeta[name];
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.getFieldMeta(name);
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var _this3 = this;

      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !_this3.getFieldMeta(name).hidden;
      }) : [];
    }
  }, {
    key: 'getAllFieldsName',
    value: function getAllFieldsName() {
      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta) : [];
    }
  }, {
    key: 'getValidFieldsFullName',
    value: function getValidFieldsFullName(maybePartialName) {
      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
      return this.getValidFieldsName().filter(function (fullName) {
        return maybePartialNames.some(function (partialName) {
          return fullName === partialName || startsWith(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
        });
      });
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;

      var field = this.getField(name);
      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return defineProperty_default()({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return extends_default()({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getNotCollectedFields',
    value: function getNotCollectedFields() {
      var _this4 = this;

      var fieldsName = this.getValidFieldsName();
      return fieldsName.filter(function (name) {
        return !_this4.fields[name];
      }).map(function (name) {
        return {
          name: name,
          dirty: false,
          value: _this4.getFieldMeta(name).initialValue
        };
      }).reduce(function (acc, field) {
        return set_default()(acc, field.name, createFormField(field));
      }, {});
    }
  }, {
    key: 'getNestedAllFields',
    value: function getNestedAllFields() {
      var _this5 = this;

      return Object.keys(this.fields).reduce(function (acc, name) {
        return set_default()(acc, name, createFormField(_this5.fields[name]));
      }, this.getNotCollectedFields());
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getNestedFields',
    value: function getNestedFields(names, getter) {
      var fields = names || this.getValidFieldsName();
      return fields.reduce(function (acc, f) {
        return set_default()(acc, f, getter(f));
      }, {});
    }
  }, {
    key: 'getNestedField',
    value: function getNestedField(name, getter) {
      var fullNames = this.getValidFieldsFullName(name);
      if (fullNames.length === 0 || // Not registered
      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
      ) {
          return getter(name);
        }
      var isArrayValue = fullNames[0][name.length] === '[';
      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
      return fullNames.reduce(function (acc, fullName) {
        return set_default()(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
      }, isArrayValue ? [] : {});
    }
  }, {
    key: 'isValidNestedFieldName',

    // @private
    // BG: `a` and `a.b` cannot be use in the same form
    value: function isValidNestedFieldName(name) {
      var names = this.getAllFieldsName();
      return names.every(function (n) {
        return !partOf(n, name) && !partOf(name, n);
      });
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);

  return FieldsStore;
}();

var createFieldsStore__initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.setFieldsInitialValue = function (initialValues) {
    var flattenedInitialValues = _this6.flattenRegisteredFields(initialValues);
    var fieldsMeta = _this6.fieldsMeta;
    Object.keys(flattenedInitialValues).forEach(function (name) {
      if (fieldsMeta[name]) {
        _this6.setFieldMeta(name, extends_default()({}, _this6.getFieldMeta(name), {
          initialValue: flattenedInitialValues[name]
        }));
      }
    });
  };

  this.getAllValues = function () {
    var fieldsMeta = _this6.fieldsMeta,
        fields = _this6.fields;

    return Object.keys(fieldsMeta).reduce(function (acc, name) {
      return set_default()(acc, name, _this6.getValueFromFields(name, fields));
    }, {});
  };

  this.getFieldsValue = function (names) {
    return _this6.getNestedFields(names, _this6.getFieldValue);
  };

  this.getFieldValue = function (name) {
    var fields = _this6.fields;

    return _this6.getNestedField(name, function (fullName) {
      return _this6.getValueFromFields(fullName, fields);
    });
  };

  this.getFieldsError = function (names) {
    return _this6.getNestedFields(names, _this6.getFieldError);
  };

  this.getFieldError = function (name) {
    return _this6.getNestedField(name, function (fullName) {
      return getErrorStrs(_this6.getFieldMember(fullName, 'errors'));
    });
  };

  this.isFieldValidating = function (name) {
    return _this6.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this6.getValidFieldsName();
    return names.some(function (n) {
      return _this6.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this6.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this6.getValidFieldsName();
    return names.some(function (n) {
      return _this6.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new createFieldsStore_FieldsStore(fields);
}
// CONCATENATED MODULE: ../node_modules/rc-form/es/createBaseForm.js




/* eslint-disable react/prefer-es6-class */
/* eslint-disable prefer-promise-reject-errors */












var DEFAULT_TRIGGER = 'onChange';

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? identity : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      formName = option.name,
      withRef = option.withRef;

  return function decorate(WrappedComponent) {
    var Form = create_react_class_default()({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = createFieldsStore(fields || {});

        this.instances = {};
        this.cachedBind = {};
        this.clearedFieldMetaCache = {};

        this.renderFields = {};
        this.domFields = {};

        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          _this[key] = function () {
            var _fieldsStore;

            if (false) {
              warning(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            }
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentDidMount: function componentDidMount() {
        this.cleanUpUselessFields();
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      componentDidUpdate: function componentDidUpdate() {
        this.cleanUpUselessFields();
      },
      onCollectCommon: function onCollectCommon(name, action, args) {
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, toConsumableArray_default()(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, toConsumableArray_default()(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, toConsumableArray_default()(args)) : getValueFromEvent.apply(undefined, toConsumableArray_default()(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          var valuesAll = this.fieldsStore.getAllValues();
          var valuesAllSet = {};
          valuesAll[name] = value;
          Object.keys(valuesAll).forEach(function (key) {
            return set_default()(valuesAllSet, key, valuesAll[key]);
          });
          onValuesChange(extends_default()(defineProperty_default()({}, formPropName, this.getForm()), this.props), set_default()({}, name, value), valuesAllSet);
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: extends_default()({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;

        this.fieldsStore.setFieldsAsDirty();

        var newField = extends_default()({}, field, {
          dirty: hasRules(validate)
        });
        this.setFields(defineProperty_default()({}, name, newField));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var newField = extends_default()({}, field, {
          dirty: true
        });

        this.fieldsStore.setFieldsAsDirty();

        this.validateFieldsInternal([newField], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        if (!this.cachedBind[name]) {
          this.cachedBind[name] = {};
        }
        var cache = this.cachedBind[name];
        if (!cache[action] || cache[action].oriFn !== fn) {
          cache[action] = {
            fn: fn.bind(this, name, action),
            oriFn: fn
          };
        }
        return cache[action].fn;
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          // We should put field in record if it is rendered
          _this2.renderFields[name] = true;

          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            warning(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            warning(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          return preact_compat_es["default"].cloneElement(fieldElem, extends_default()({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }
        if (false) {
          warning(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`. Check field: ' + name);
          warning(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
        }

        delete this.clearedFieldMetaCache[name];

        var fieldOption = extends_default()({
          name: name,
          trigger: DEFAULT_TRIGGER,
          valuePropName: 'value',
          validate: []
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            validate = fieldOption.validate;

        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var inputProps = extends_default()({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = formName ? formName + '_' + name : name;
        }

        var validateRules = normalizeValidateRules(validate, rules, validateTrigger);
        var validateTriggers = getValidateTriggers(validateRules);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = extends_default()({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        // This field is rendered, record it
        this.renderFields[name] = true;

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return flattenArray(actionRules);
      },
      setFields: function setFields(maybeNestedFields, callback) {
        var _this4 = this;

        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = Object.keys(fields).reduce(function (acc, name) {
            return set_default()(acc, name, _this4.fieldsStore.getField(name));
          }, {});
          onFieldsChange(extends_default()(defineProperty_default()({}, formPropName, this.getForm()), this.props), changedFields, this.fieldsStore.getNestedAllFields());
        }
        this.forceUpdate(callback);
      },
      setFieldsValue: function setFieldsValue(changedValues, callback) {
        var fieldsMeta = this.fieldsStore.fieldsMeta;

        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
        var newFields = Object.keys(values).reduce(function (acc, name) {
          var isRegistered = fieldsMeta[name];
          if (false) {
            warning(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
          if (isRegistered) {
            var value = values[name];
            acc[name] = {
              value: value
            };
          }
          return acc;
        }, {});
        this.setFields(newFields, callback);
        if (onValuesChange) {
          var allValues = this.fieldsStore.getAllValues();
          onValuesChange(extends_default()(defineProperty_default()({}, formPropName, this.getForm()), this.props), changedValues, allValues);
        }
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          var _fieldMeta = this.fieldsStore.getFieldMeta(name);
          if (!_fieldMeta.preserve) {
            // after destroy, delete data
            this.clearedFieldMetaCache[name] = {
              field: this.fieldsStore.getField(name),
              meta: _fieldMeta
            };
            this.clearField(name);
          }
          delete this.domFields[name];
          return;
        }
        this.domFields[name] = true;
        this.recoverClearedField(name);
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            } else if (typeof ref === 'function') {
              ref(component);
            } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
              ref.current = component;
            }
          }
        }
        this.instances[name] = component;
      },
      cleanUpUselessFields: function cleanUpUselessFields() {
        var _this5 = this;

        var fieldList = this.fieldsStore.getAllFieldsName();
        var removedList = fieldList.filter(function (field) {
          var fieldMeta = _this5.fieldsStore.getFieldMeta(field);
          return !_this5.renderFields[field] && !_this5.domFields[field] && !fieldMeta.preserve;
        });
        if (removedList.length) {
          removedList.forEach(this.clearField);
        }
        this.renderFields = {};
      },
      clearField: function clearField(name) {
        this.fieldsStore.clearField(name);
        delete this.instances[name];
        delete this.cachedBind[name];
      },
      resetFields: function resetFields(ns) {
        var _this6 = this;

        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
        if (ns) {
          var names = Array.isArray(ns) ? ns : [ns];
          names.forEach(function (name) {
            return delete _this6.clearedFieldMetaCache[name];
          });
        } else {
          this.clearedFieldMetaCache = {};
        }
      },
      recoverClearedField: function recoverClearedField(name) {
        if (this.clearedFieldMetaCache[name]) {
          this.fieldsStore.setFields(defineProperty_default()({}, name, this.clearedFieldMetaCache[name].field));
          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
          delete this.clearedFieldMetaCache[name];
        }
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this7 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              set_default()(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
          var newField = extends_default()({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this7.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this7.fieldsStore.getFieldValue(f);
        });
        if (callback && isEmptyObject(allFields)) {
          callback(isEmptyObject(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
          return;
        }
        var validator = new es_default.a(allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = extends_default()({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var errorFieldName = e.field;
              var fieldName = errorFieldName;

              // Handle using array validation rule.
              // ref: https://github.com/ant-design/ant-design/issues/14275
              Object.keys(allRules).some(function (ruleFieldName) {
                var rules = allRules[ruleFieldName] || [];

                // Exist if match rule
                if (ruleFieldName === errorFieldName) {
                  fieldName = ruleFieldName;
                  return true;
                }

                // Skip if not match array type
                if (rules.every(function (_ref2) {
                  var type = _ref2.type;
                  return type !== 'array';
                }) || errorFieldName.indexOf(ruleFieldName + '.') !== 0) {
                  return false;
                }

                // Exist if match the field name
                var restPath = errorFieldName.slice(ruleFieldName.length + 1);
                if (/^\d+$/.test(restPath)) {
                  fieldName = ruleFieldName;
                  return true;
                }

                return false;
              });

              var field = get_default()(errorsGroup, fieldName);
              if (typeof field !== 'object' || Array.isArray(field)) {
                set_default()(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = get_default()(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = get_default()(errorsGroup, name);
            var nowField = _this7.fieldsStore.getField(name);
            // avoid concurrency problems
            if (!eq_default()(nowField.value, allValues[name])) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this7.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref3) {
                var name = _ref3.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                set_default()(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback(isEmptyObject(errorsGroup) ? null : errorsGroup, _this7.fieldsStore.getFieldsValue(fieldNames));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this8 = this;

        var pending = new Promise(function (resolve, reject) {
          var _getParams = getParams(ns, opt, cb),
              names = _getParams.names,
              options = _getParams.options;

          var _getParams2 = getParams(ns, opt, cb),
              callback = _getParams2.callback;

          if (!callback || typeof callback === 'function') {
            var oldCb = callback;
            callback = function callback(errors, values) {
              if (oldCb) {
                oldCb(errors, values);
              }
              if (errors) {
                reject({ errors: errors, values: values });
              } else {
                resolve(values);
              }
            };
          }
          var fieldNames = names ? _this8.fieldsStore.getValidFieldsFullName(names) : _this8.fieldsStore.getValidFieldsName();
          var fields = fieldNames.filter(function (name) {
            var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
            return hasRules(fieldMeta.validate);
          }).map(function (name) {
            var field = _this8.fieldsStore.getField(name);
            field.value = _this8.fieldsStore.getFieldValue(name);
            return field;
          });
          if (!fields.length) {
            callback(null, _this8.fieldsStore.getFieldsValue(fieldNames));
            return;
          }
          if (!('firstFields' in options)) {
            options.firstFields = fieldNames.filter(function (name) {
              var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
              return !!fieldMeta.validateFirst;
            });
          }
          _this8.validateFieldsInternal(fields, {
            fieldNames: fieldNames,
            options: options
          }, callback);
        });
        pending['catch'](function (e) {
          // eslint-disable-next-line no-console
          if (console.error && "production" !== 'production') {
            // eslint-disable-next-line no-console
            console.error(e);
          }
          return e;
        });
        return pending;
      },
      isSubmitting: function isSubmitting() {
        if (false) {
          warning(false, '`isSubmitting` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
        }
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this9 = this;

        if (false) {
          warning(false, '`submit` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
        }
        var fn = function fn() {
          _this9.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = objectWithoutProperties_default()(_props, ['wrappedComponentRef']); // eslint-disable-line


        var formProps = defineProperty_default()({}, formPropName, this.getForm());
        if (withRef) {
          if (false) {
            warning(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          }
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, extends_default()({}, formProps, restProps));
        return preact_compat_es["default"].createElement(WrappedComponent, props);
      }
    });

    return argumentContainer(es_unsafeLifecyclesPolyfill(Form), WrappedComponent);
  };
}

/* harmony default export */ var es_createBaseForm = (createBaseForm);
// CONCATENATED MODULE: ../node_modules/rc-form/es/createForm.js


var mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return es_createBaseForm(options, [mixin]);
}

/* harmony default export */ var es_createForm = (createForm);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/rc-form/es/propTypes.js


var formShape = prop_types_default.a.shape({
  getFieldsValue: prop_types_default.a.func,
  getFieldValue: prop_types_default.a.func,
  getFieldInstance: prop_types_default.a.func,
  setFieldsValue: prop_types_default.a.func,
  setFields: prop_types_default.a.func,
  setFieldsInitialValue: prop_types_default.a.func,
  getFieldDecorator: prop_types_default.a.func,
  getFieldProps: prop_types_default.a.func,
  getFieldsError: prop_types_default.a.func,
  getFieldError: prop_types_default.a.func,
  isFieldValidating: prop_types_default.a.func,
  isFieldsValidating: prop_types_default.a.func,
  isFieldsTouched: prop_types_default.a.func,
  isFieldTouched: prop_types_default.a.func,
  isSubmitting: prop_types_default.a.func,
  submit: prop_types_default.a.func,
  validateFields: prop_types_default.a.func,
  resetFields: prop_types_default.a.func
});

/* harmony default export */ var propTypes = (formShape);
// CONCATENATED MODULE: ../node_modules/rc-form/es/index.js
/* unused concated harmony import createFormField */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createFormField; });
/* unused concated harmony import formShape */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return propTypes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return es_createForm; });
// export this package's api






/***/ }),

/***/ "yEjJ":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("LIpy");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),

/***/ "yS17":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "yeiR":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("Tnr5"),
    toKey = __webpack_require__("RQ0L");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

module.exports = baseGet;

/***/ }),

/***/ "yez4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("vdRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_form__ = __webpack_require__("yAn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_i18n__ = __webpack_require__("rNh1");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "span",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["c" /* Text */], { id: "contactForm.error" }),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "a",
    {
      style: "color:white;font-weight:bold",
      href: "tel:+371 69 999 999"
    },
    "69 999 999"
  ),
  " ",
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["c" /* Text */], { id: "contactForm.errorLink" })
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h2",
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["c" /* Text */], { id: "contactForm.title" })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", "class": "icon" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("use", { xlinkhref: "/assets/img/icons.svg#marker" })
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["c" /* Text */], { id: "contactForm.checkbox.text" });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4_preact_i18n__["c" /* Text */], { id: "contactForm.checkbox.link" });

var ContactForm = function (_Component) {
  _inherits(ContactForm, _Component);

  function ContactForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, ContactForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.submit = function () {
      _this.props.form.validateFields(function (error, value) {
        if (!error) {
          _this.setState({ loading: true });
          var extraData = _this.props.extraData ? _this.props.extraData : {};
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].sendForm(_this.props.type, _extends({}, value, extraData)).then(function (res) {
            if (res) _this.setState({ loading: false, sent: true });else _this.setState({
              loading: false,
              sendError: _ref
            });
            document.getElementById("page-header").scrollIntoView({ block: "center", behavior: "smooth" });
          });
        } else console.error(error);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ContactForm.prototype.render = function render(props) {
    var _this2 = this;

    var type = props.type,
        contentText = this.context.intl.dictionary.contactForm.form.standart.contentText,
        submitText = this.context.intl.dictionary.contactForm.form.standart.submitText,
        captionText = this.context.intl.dictionary.contactForm.form.standart.captionText,
        descriptionText = this.context.intl.dictionary.contactForm.form.standart.descriptionText,
        sentText = this.context.intl.dictionary.contactForm.form.standart.sentText;

    switch (type) {
      case "support":
        contentText = this.context.intl.dictionary.contactForm.form.support.contentText, submitText = this.context.intl.dictionary.contactForm.form.support.submitText, captionText = this.context.intl.dictionary.contactForm.form.support.captionText, descriptionText = this.context.intl.dictionary.contactForm.form.support.descriptionText, sentText = this.context.intl.dictionary.contactForm.form.support.sentText;
        break;
      case "apply":
        contentText = this.context.intl.dictionary.contactForm.form.apply.contentText, captionText = this.context.intl.dictionary.contactForm.form.apply.captionText, descriptionText = this.context.intl.dictionary.contactForm.form.apply.descriptionText, sentText = this.context.intl.dictionary.contactForm.form.apply.sentText;
        break;
    }
    var _props$form = this.props.form,
        getFieldProps = _props$form.getFieldProps,
        getFieldError = _props$form.getFieldError;

    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { id: "main", "class": props.class, style: "position:relative" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", {
        "class": "preloader-small" + (this.state.loading ? " loading" : "")
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { "class": "container" },
        this.state.sent ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "article",
          null,
          _ref2,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "p",
            null,
            sentText
          )
        ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "article",
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "h2",
            null,
            captionText
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "p",
            null,
            descriptionText
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { "class": "feedback-form" },
            type == "support" && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "label",
              { "class": "field-icon address" },
              _ref3,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", _extends({}, getFieldProps("address", {
                rules: [{ required: true }]
              }), {
                "class": getFieldError("name") ? "input-error" : "",
                type: "text",
                placeholder: this.context.intl.dictionary.contactForm.adres,
                title: this.context.intl.dictionary.contactForm.adres
              }))
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "fieldset",
              { "class": "clearfix" },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", _extends({}, getFieldProps("name", { rules: [{ required: true }] }), {
                "class": getFieldError("name") ? "input-error" : "",
                type: "text",
                placeholder: this.context.intl.dictionary.contactForm.name,
                title: this.context.intl.dictionary.contactForm.name
              })),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", _extends({}, getFieldProps("email", {
                rules: [{ required: true, type: "email" }]
              }), {
                "class": getFieldError("email") ? "input-error" : "",
                type: "email",
                placeholder: this.context.intl.dictionary.contactForm.mail,
                title: this.context.intl.dictionary.contactForm.mail
              })),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", _extends({}, getFieldProps("phone", {
                rules: [{
                  required: true,
                  type: "string",
                  min: 8,
                  pattern: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g
                }]
              }), {
                "class": getFieldError("phone") ? "input-error" : "",
                type: "tel",
                placeholder: this.context.intl.dictionary.contactForm.phone,
                title: this.context.intl.dictionary.contactForm.phone
              }))
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("textarea", _extends({}, getFieldProps("text", {
              rules: [{
                required: true,
                type: "string",
                max: 1000
              }]
            }), {
              "class": getFieldError("text") ? "input-error" : "",
              placeholder: contentText,
              title: contentText,
              maxlength: "1000"
            })),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              {
                "class": getFieldError("agreement") ? "checkbox agreement input-error" : "checkbox agreement"
              },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("input", _extends({}, getFieldProps("agreement", {
                rules: [{ required: true }, {
                  validator: function validator(rule, value, callback, source, options) {
                    callback(value ? undefined : _this2.context.intl.dictionary.contactForm.policy);
                  }
                }],
                valuePropName: "checked",
                initialValue: true
              }), {
                type: "checkbox",
                id: "checkbox-agreement"
              })),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                "label",
                { "for": "checkbox-agreement" },
                _ref4,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  "a",
                  { target: "_blank", href: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].prefix + "/privacy" },
                  _ref5
                )
              )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "p",
              { "class": "error" + (this.state.sendError ? "" : "hidden") },
              this.state.sendError
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "button",
              { onClick: this.submit },
              submitText
            )
          )
        )
      )
    );
  };

  return ContactForm;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_rc_form__["a" /* createForm */])()(ContactForm));

/***/ }),

/***/ "z7R8":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "zCAL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "zKeE":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "zotD":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("BxvP");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.1c988.js